window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $('.rte iframe').filter(function () {
      return this.src.match(/(youtube\.com\/embed|youtube-nocookie\.com\/embed|youtu\.be|player\.vimeo)/i);
    });
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    // this._updatePrice(this.currentVariant);

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;
      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      if (!found && selectedValues.length == 3) {
        $("[data-index='option3']").prop("checked", false);
        return this._getVariantFromOptions();
      }
      
      // Enhance found variant with metafields if available
      if (found) {
        found = this._enhanceVariantWithMetafields(found);
      }
      
      return found || null;
    },

    /**
     * Enhance variant with metafields from enhanced product JSON
     */
    _enhanceVariantWithMetafields: function(variant) {
      // Try to get enhanced product data from the enhanced JSON
      var enhancedProductElement = $('[data-product-json-main]');
      if (enhancedProductElement.length && enhancedProductElement.html()) {
        try {
          var enhancedProduct = JSON.parse(enhancedProductElement.html());
          if (enhancedProduct.variants) {
            var enhancedVariant = enhancedProduct.variants.find(function(v) {
              return v.id == variant.id;
            });
            if (enhancedVariant && enhancedVariant.metafields) {
              variant.metafields = enhancedVariant.metafields;
            }
          }
        } catch (e) {
          // Silently fail if JSON parsing fails
        }
      }
      return variant;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function (evt) {
      var variant = this._getVariantFromOptions();
      var option = $(evt.target).attr('data-index');

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        option: option
      });

      if (!variant) {
        console.warn('⚠️ [Variants] No variant found after option change.');
        return;
      }

      this._updateMasterSelect(variant, option);
      this._updateStringSelect(variant, option);
      this._updateImages(variant, option);
      this._updatePrice(variant, option);
      this._updateOptions(variant, option);
      this._updateSKU(variant, option);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
     _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        // return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when available variant options change.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantOptionChange
     */
    _updateOptions: function (variant) {

      if (!variant) {
        return;
      }

      this.$container.trigger({
        type: 'variantOptionChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
     _updateSKU: function(variant) {
      // if (variant.sku === this.currentVariant.sku) {
      //   return;
      // }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

    /**
     * Update hidden string select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateStringSelect: function (variant) {
      const $stringPopupOffer = $(".stringing-popup-offer.popup-fs");
      if ($stringPopupOffer.length > 0) {
        $(this.originalSelectorId, $stringPopupOffer)[0].value = variant.id;
      }
    }
  });

  return Variants;
})();

/*================ Global ================*/
/*============================================================================
  Helper utilities
==============================================================================*/
window.theme = window.theme || {};

theme.utils = {
  /**
   * Turns a string into a handle. Mimics Shopify's format.
   */
  handleize: function (str) {
    return str.toLowerCase().replace("\'", "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },

  /**
   * Cross-browser URL query param getter
   */
  getQueryParams: function (qs) {
    qs = qs || document.location.search;

    if (!qs) {
      return;
    }

    qs = qs.split('+').join(' ');

    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  },

  updateQueryStringParameter: function (key, value, url) {
    if (!url) url = window.location.href;

    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

    if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null)
        return url.replace(re, '$1' + key + "=" + value + '$2$3');
      else {
        hash = url.split('#');
        url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
    } else {
      if (typeof value !== 'undefined' && value !== null) {
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        hash = url.split('#');
        url = hash[0] + separator + key + '=' + value;
        if (typeof hash[1] !== 'undefined' && hash[1] !== null)
          url += '#' + hash[1];
        return url;
      }
      else
        return url;
    }
  },

  getYoutubeId: function (url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : false;
  },

  createElementFromHTML: function (htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  },

  getProductJSON: function (handle, callback) {
    return $.get('/products/' + handle + '?view=json', null, callback, 'text');
  },

  hexToRgb: function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  flash: function (elements, color, duration) {
    var opacity = 100;
    color = color || '255, 255, 136';
    duration = duration || 1500;

    if (color.indexOf('#') > -1) {
      var rgbColor = theme.utils.hexToRgb(color);
      color = [rgbColor.r, rgbColor.g, rgbColor.b].join(',');
    }

    var interval = setInterval(function () {
      opacity -= 2.5;

      $(elements).css({ background: 'rgba(' + color + ', ' + opacity / 100 + ')' });

      if (opacity <= 0) {
        clearInterval(interval);
        return;
      }
    }, duration / 40);
  },

  // Gets the rendered size of an image using object-fit
  getRenderedImgSize: function (contains, cWidth, cHeight, width, height, pos) {
    var oRatio = width / height,
      cRatio = cWidth / cHeight;
    return function () {
      if (contains ? (oRatio > cRatio) : (oRatio < cRatio)) {
        this.width = cWidth;
        this.height = cWidth / oRatio;
      } else {
        this.width = cHeight * oRatio;
        this.height = cHeight;
      }
      this.left = (cWidth - this.width) * (pos / 100);
      this.right = this.width + this.left;
      return this;
    }.call({});
  },

  // Returns size info for an image rendered with object-fit
  getImgSizeInfo: function (img) {
    var pos = window.getComputedStyle(img).getPropertyValue('object-position').split(' ');
    return theme.utils.getRenderedImgSize(true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      parseInt(pos[0]));
  },

  // Returns content of template placed into snippets/js-tempales.liquid
  getTemplate: function (template) {
    return $('[data-template-for="' + template + '"]').html();
  },

  // Returns deep differences between objects, ignoring functions
  difference: function (object, base) {
    function changes(object, base) {
      return _.transform(object, function (result, value, key) {
        if (typeof value !== 'function' && !_.isEqual(value, base[key])) {
          var comparison = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;

          if (!_.isNil(comparison)) {
            result[key] = comparison;
          }
        }
      });
    }
    return changes(object, base);
  },

  getStyleValue: function (variable) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(variable);
    if (value) {
      return value.trim();
    }
    return '';
  },

  // Adds syntax highlighting to JSON output
  syntaxHighlight: function (json) {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    json = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
    json = json.replace(/([\n\r]|^)(\s*){/g, '<span class="group">$2<span class="group-handle">{</span>').replace(/([\n\r]|^)(\s*)}(,|)/g, '$1$2}$3</span>');
    json = json.replace(/(<\/span>|^)(\s*)\[/g, '$1<span class="group group--inline">$2<span class="group-handle">[</span>').replace(/([\n\r]|^)(\s*)](,|)/g, '$2]$3</span>');
    return json;
  },

  errorTippy: function (target, message) {
    var $el = $(target);
    var tip = tippy($el[0], {
      showOnInit: true,
      content: message,
      theme: 'light',
      animation: 'shift-away',
      arrow: true,
      delay: [0, 1000],
      onHidden: function (e) {
        e.destroy();
      }
    });
  },

  /**
  * Locks the page scroll.
  *
  * @param      {element}  scrollEl  optional
  */
  lockPageScroll: function (scrollEl) {

    document.documentElement.classList.add('scroll-locked');
    if ('bodyScrollLock' in window) {
      bodyScrollLock.lock(scrollEl);
    }

  },

  /**
 * Unlocks the page scroll.
 */
  unlockPageScroll: function () {

    document.documentElement.classList.remove('scroll-locked');

    if ('bodyScrollLock' in window) {
      bodyScrollLock.unlock();
    }

  },

  highlightSubString: function (substring, string) {
    return string.replace(new RegExp(substring, 'gi'), function (str) {
      return '<strong>' + str + '</strong>';
    });
  }

};

if ('tinybind' in window) {

  tinybind.formatters.replace = function (value, search, replace) {
    return value.replace(search, replace);
  };

  // Custom formatter: contains (case-insensitive)
  // Usage: rv-if="someString | contains 'needle'"
  tinybind.formatters.contains = function (value, search) {
    if (value == null || search == null) return false;
    const haystack = String(value).toLowerCase();
    const needle = String(search).toLowerCase();
    return haystack.indexOf(needle) !== -1;
  };

  tinybind.formatters.jsonParse = function (value) {
    let val = JSON.parse(value)
    if (val.custom_data) {
      val = JSON.parse(val.custom_data)
    }
    return val;
  };

  tinybind.formatters.array_element=function(e,t){
    if (e === undefined) {
      return null
    }
    return e[t]
  }

  tinybind.formatters.handle = function (string) {
    return theme.utils.handleize(string);
  };

  tinybind.formatters.startsWith = function (value, prefix) {
    return value.indexOf(prefix) === 0;
  };

  tinybind.formatters.endsWith = function (value, suffix) {
    return value.indexOf(suffix, value.length - suffix.length) !== -1;
  };

  tinybind.formatters.gte = function (a, b) {
    return a >= b;
  };

  tinybind.formatters.or = function (a, b) {
    return a || b;
  };

  tinybind.formatters.and = function (a, b) {
    return a && b;
  };

  tinybind.formatters.size = function (a) {
    return _.size(a);
  };

  tinybind.formatters.length = tinybind.formatters.size;

  tinybind.formatters.stripHtml = function (html) {
    var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    return parsedHtml.body.textContent || "";
  };

  tinybind.formatters.escape = function (string) {
    return JSON.stringify(string).replace(/(^"|"$)/g, '');
  };

  tinybind.binders.left = function (el, value) {
    el.style.left = value;
  };

  tinybind.formatters.getSizedImageUrl = function(imgUrl, width) {
    return slate.Image.getSizedImageUrl(imgUrl, width ? width : '{width}x');
  };

  tinybind.formatters.orGetMainImageUrl = function(imgUrl, mainImageUrl) {
    if ( imgUrl) {
      return slate.Image.getSizedImageUrl(imgUrl, '{width}x' )
    } else  if (mainImageUrl){
      return slate.Image.getSizedImageUrl(mainImageUrl, '{width}x' )
    }
    }

  tinybind.binders.order = function (el, value) {
    el.style.order = value + 1;
  };

  tinybind.binders['product-grid-item'] = {
    bind: function (el, product) {
    },
    routine: function (el, product) {
      var $productGridElement = $(el);
      var $swatchesContainer = $productGridElement.find('.product-grid-item__swatch-container');
      var maxVisibleSwatches = 4; // Define the maximum number of visible swatches

      if ($swatchesContainer.length > maxVisibleSwatches) {
        $swatchesContainer.each(function(index) {
          if (index >= maxVisibleSwatches) {
            $(this).hide();
          }
        });

        var moreSwatchesCount = $swatchesContainer.length - maxVisibleSwatches;
        var productUrl = $swatchesContainer.data('href');
        var moreSwatchesEl = $('<span class="more-swatches">+ ' + moreSwatchesCount + '</span>');

        moreSwatchesEl.attr('href', productUrl);
        $productGridElement.find('.product-actions__containter').append(moreSwatchesEl);
        moreSwatchesEl.show();
      }
    }
  };

  tinybind.formatters.log = function (value) {
    console.log(value);
    return value;
  };

  tinybind.formatters.highlight = function (a, b) {
    if (b && a) {
      return theme.utils.highlightSubString(b, a);
    }
    return;
  };

  tinybind.formatters.uniqueVariants = function (product, optionIndex) {
    var hasNumber = /\d/;
    var processedOptions = [];
    var uniqueVariants = [];

    if (product.variants) {
      var variantGroups = {};

      product.variants.forEach(function (variant) {
        if (!variant.options || (!variant.featured_image && !variant.image)) return;

        if (hasNumber.test(variant.options[optionIndex])) {
          optionIndex = 1;
        }

        var optionValue = variant.options[optionIndex];
        if (!variantGroups[optionValue]) {
          variantGroups[optionValue] = [];
        }
        variantGroups[optionValue].push(variant);
      });

      for (var optionValue in variantGroups) {
        var variants = variantGroups[optionValue];

        var availableVariant = variants.find(function (variantItem) {
          return variantItem.available;
        });

        if (availableVariant) {
          uniqueVariants.push(availableVariant);
        } else {
          uniqueVariants.push(variants[0]);
        }
      }
    }

    return uniqueVariants;
  };

  tinybind.formatters.mapAvailability = function (variants) {
    // Debugging function
    if (!variants || variants.length === 0) return '';

    return variants.map(function(variant) {
      const optionsString = variant.options.join(', ');

      return `Options: ${optionsString}, SKU: ${variant.sku}, Price: ${variant.price}, Available: ${variant.available}`;
    }).join(' | ');
  };

  tinybind.formatters.hasAvalability = function (variant) {
    console.log(`Variant SKU: ${variant.sku}, Price: ${variant.price}`);
    return `SKU: ${variant.sku}, Price: ${variant.price}, Available: ${variant.available}`;
  }

  tinybind.formatters.mapTitle = function (title, variant) {
    var hasNumber = /\d/;

    optionIndex = 0;
    if (hasNumber.test(variant.options[0])) {
      optionIndex = 1;
    }
    var color_title = variant.options[optionIndex];
    var color = window.theme.colours[color_title] ? theme.utils.handleize(window.theme.colours[color_title]) : "";

    return color.toLowerCase();
  }

  tinybind.formatters.moreSwatches = function (variants, maxVisibleSwatches) {
    return variants.length > maxVisibleSwatches;
  };

  tinybind.formatters.excludeSizeOptions = function (variants) {
    if (!variants) return [];

    return variants.filter(function(variant) {
      if (!variant.merged_options) {
        return true;
      }

      const hasColorOption = variant.merged_options.some(option =>
          option.toLowerCase().includes('color') || option.toLowerCase().includes('colour')
      );

      const hasOnlySizeOption = variant.merged_options.every(option =>
          option.toLowerCase().includes('size')
      );

      return hasColorOption || !hasOnlySizeOption;
    });
  };

  tinybind.formatters.img = function (image, alt, maxWidth, maxHeight) {

    if (!image) {
      return;
    }

    var imgTemplateURL,
      imgString,
      imgUrl;

    imgUrl = (typeof image == 'string' ? image : image.src);

    imgTemplateURL = slate.Image.getSizedImageUrl(imgUrl, '{width}x');

    maxWidth = maxWidth ? ((image.width ? image.width + 'px' : false) || (typeof maxWidth == 'string' ? maxWidth : maxWidth + 'px')) : 'none';
    maxHeight = maxHeight ? ((image.height ? image.height + 'px' : false) || (typeof maxHeight == 'string' ? maxHeight : maxHeight + 'px')) : 'none';

    alt = alt || null;

    imgString = '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" style="max-width: ' + maxWidth + '; max-height: ' + maxHeight + ';" data-sizes="auto" data-src="' + imgTemplateURL + '" alt="' + alt + ' "/>'

    return imgString;

  };

  tinybind.formatters.customItemCount = function(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return 0;
    }

    let total = cart.items.reduce((count, item) => {
      if (item.quantity > 0 && item.properties && item.properties._custom_data || item.id == '43234201895125') {
        return count + item.quantity;
      }
      return count;
    }, 0);

    return total;
  };
  tinybind.formatters.hasCustomItem = function(cart) { 
    if (!cart || !Array.isArray(cart.items)) return false;
    const result = cart.items.some(item => item.properties && item.properties._custom_data || item.id == '43234201895125');
    return result;
  };
  tinybind.formatters.shouldHide = function(item, cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    const hasCustom = cart.items.some(i => i.properties && i.properties._custom_data || item.id == '43234201895125');
    if (hasCustom) {
      return !(item.properties && item.properties._custom_data || item.id == '43234201895125');
    }

    return false;
  };

  tinybind.formatters.isCustomItem = function(item) {
    return item.properties && item.properties._custom_data || item.id == '43234201895125' ? true : false;
  };
}


window.theme = window.theme || {};
window.theme.drawers = window.theme.drawers || {};
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {

  // if (isMobile.any) {
  //   theme.pageSwipeObject = new Hammer.Manager(document.getElementById('PageContainer'), {
  //     touchAction: 'auto',
  //     inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchMouseInput,
  //     recognizers: [
  //       [Hammer.Swipe, {
  //         direction: Hammer.DIRECTION_HORIZONTAL
  //       }]
  //     ]
  //   });

  //   theme.pageSwipeObject.on('swiperight', function(evt) {
  //     if ($('body').hasClass('js-drawer-open-right')) {
  //       var $drawer = $('.drawer.drawer--right');
  //       theme[$drawer.attr('id')].close();
  //       return;
  //     }

  //     var $drawer = $('.drawer.drawer--left');
  //     if (!$drawer.length) {
  //       return;
  //     }
  //     var delta_x = evt.deltaX;
  //     var final_x = evt.srcEvent.pageX || evt.srcEvent.screenX || 0;
  //     var startPosition = final_x - delta_x;
  //     if (startPosition >= 0 && startPosition <= 25) {
  //       theme[$drawer.attr('id')].open();
  //     }
  //     return false;
  //   });

  //   theme.pageSwipeObject.on('swipeleft', function(evt) {
  //     if ($('body').hasClass('js-drawer-open-left')) {
  //       var $drawer = $('.drawer.drawer--left');
  //       theme[$drawer.attr('id')].close();
  //       return;
  //     }

  //     var $drawer = $('.drawer.drawer--right');
  //     if (!$drawer.length) {
  //       return;
  //     }
  //     var delta_x = evt.deltaX;
  //     var final_x = evt.center.x || 0;
  //     var startPosition = final_x + -delta_x;
  //     var windowWidthOffset = $(window).width() - 25;
  //     if (startPosition >= windowWidthOffset) {
  //       theme[$drawer.attr('id')].open();
  //     }
  //     return false;
  //   });
  // }

  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
      pageContentSelector: '#PageContent',
    };

    var selectors = {
      closeButton: 'button.drawer-close'
    }


    this.config = $.extend(defaults, options);
    this.position = position;

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $(this.config.pageContentSelector)
    };

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    theme.drawers[id] = this;

    this.drawerIsOpen = false;
    this.init();

    $(selectors.closeButton).on('click', function () {
      Drawer.prototype.closeAllDrawers();
      this.drawerIsOpen = false;
    })
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.closeAllDrawers = function (evt) {
    // Close all drawers
    _.forEach(theme.drawers, function (drawer) {
      if (drawer.drawerIsOpen) {
        drawer.close();
      }
    });
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    this.closeAllDrawers();

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
    this.drawerIsOpen = true;

    return this;
  };

  Drawer.prototype.close = function () {

    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerClose && typeof this.config.onDrawerClose === 'function') {
      this.config.onDrawerClose();
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    // this.nodes.$page.on('touchmove.drawer', function() {
    //   return false;
    // });

    this.nodes.$page.on('click', $.proxy(function () {
      if (!$(event.target).parents('.cart-drawer--popup').length) {
        this.close();
      }
    }, this));
  };

  //   this.nodes.$page.on('click.drawer', $.proxy(function() {

  //     if (!this.$drawer[0].contains(event.target)) {
  //       this.close();
  //     }

  //   }, this));
  // };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

window.theme = window.theme || {};

theme.Index = (function (last, first) {

  var self = {
    version: '1.0.5',
    loop: false,
    removed: [],
    added: [],
    active: [],
    first: first || 0,
    last: last,
    span: last - (first || 0) + 1,
    back: [],

    set: function (index) {

      self.curr = clip(index);

      // set active indices
      var active = [self.curr];
      (self.prev = self.curr - 1) < self.first || active.unshift(self.prev);
      (self.next = self.curr + 1) > self.last || active.push(self.next);

      self.prev = clip(self.prev);
      self.next = clip(self.next);


      // save to self
      if (typeof _ === 'function') { // features only available with Underscore

        self.removed = _.difference(self.active, active),
          self.added = _.difference(active, self.active);
      }
      self.active = active;

      // direction
      if (self.back[0]) self.direction = self.curr > self.back[0].prev ? 1 : -1;

      // keep a history of past indices
      self.back.unshift({
        prev: self.prev,
        curr: self.curr,
        next: self.next,
      });

      return self;
    },
  },

    clip = function (index) {

      if (self.loop) {

        if (index > self.last) return self.first;
        else if (index < self.first) return self.last;
        else return index;
      }
      else return Math.min(Math.max(index, self.first), self.last);
    };

  return self;

});

/*============================================================================
  Modal modules
==============================================================================*/
window.theme = window.theme || {};

theme.Modal = (function () {

  var config = {

  };

  function Modal(content, options) {

    this.modalContent = content;
    this.options = options || {};
    this.modal = this._createNewModal();

  }

  Modal.prototype = _.extend(Modal.prototype, {

    _createNewModal: function () {

      var featherlightOptions = this.options.featherlightOptions;
      var modal = $.featherlight($(this.modalContent), featherlightOptions);

      if (this.options.positionX || this.options.positionY) {
        modal.$instance.addClass('od-modal--' + this.options.positionX);
        modal.$instance.addClass('od-modal--' + this.options.positionY);
      }

      return modal;
    }

  });

  return Modal;
})();

theme.Modals = (function () {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $(id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body')
    };
    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    // eslint-disable-next-line shopify/jquery-dollar-sign-reference
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.init();
  }

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal.addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.removeClass(this.config.openClass);
    this.nodes.$parent.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', $.proxy(function (evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }, this));
  };

  Modal.prototype.unbindEvents = function () {
    this.nodes.$parent.off('.modal');
  };

  return Modal;
})();

(function () {
  var selectors = {
    tabHandles: '.tabs-menu a'
  };

  var classes = {
    qtySelector: 'js-qty-select'
  };

  var $tabHandles = $(selectors.tabHandles);

  if (!$tabHandles.length) {
    return;
  }

  $(selectors.tabHandles).click(function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.parent().addClass("current");
    $this.parent().siblings().removeClass("current");
    var tab = $this.attr("href");
    $(".tab-content").not(tab).css("display", "none");
    $(tab).fadeIn();
  });
})();

window.theme = window.theme || {};

// new theme.TabAccordions('.tabs, .accordion', {
//   hashWatch: true,
//   pauseMedia: true,
//   responsiveSwitch: 'tablist',
//   saveState: sessionStorage,
// });
// 

// <div class="tabs minimal hide-title">

//   <section>
//     <h1>Title 1</h1>
//     <div>Section 1</div>
//   </section>

//   <section>
//     <h1>Title 2</h1>
//     <div>Section 3<br>Section 3<br>Section 3<br>Section 3<br>Section 3<br>Section 3<br></div>
//   </section>

//   <section>
//     <h1>Title 3</h1>
//     <div>Section 3</div>
//   </section>

// </div>

theme.TabAccordions = (function () {

  function TabAccordion(element, options) {
    var count = 0;
    var defaults = {
      namespace: 'ODTabAccordion',
    };

    this.$element = $(element);

    if (!this.$element.length) {
      return false;
    }

    this.config = $.extend(defaults, options);
    this.namespace = this.config.namespace + '-' + count++;
    this.type = (this.$element.hasClass('accordion') && 'accordion') || (this.$element.hasClass('tabs') && 'tabs');
    return this.create();
  }

  TabAccordion.prototype.create = function () {
    this.$panels = this.$element.children();
    this.$tabs = this.$panels.children(':first-child');

    if (this.index) var prev = this.index.curr;
    (this.index = theme.Index(this.$panels.length - 1)).loop = true; // <- index looping for keyboard accessibility
    if (prev) this.index.set(prev);

    if (this.type === 'tabs') this.$element.prepend((this.$tabs = this.tabsCreateTablist(this.$tabs).children()).end());

    this.$tablist = (this.type === 'tabs' ? this.$tabs.parent() : this.$element).attr('role', 'tablist');

    this.$tabs.attr({
      'id': function (index) {
        return this.id || this.namespace + '-tab-' + index;
      },
      'role': 'tab',
    });

    var self = this;

    (this.$content = this.$panels.map(function (index) {
      return $(this)
        .attr({
          'aria-labelledby': self.$tabs[index].id,
          'id': self.id || self.namespace + '-panel-' + index,
          'role': 'tabpanel',
        })
        .children()
        .slice(1)
        .wrapAll('<div><div></div></div>')
        .parent()
        .parent()
        .get();
    }))
      .each($.proxy(this.collapse, this));

    $(window).on('resize.' + this.namespace, $.debounce(250, $.proxy(this.resize, this)));

    this.$element.attr({
      'id': this.$element.id || this.namespace,
      'tabindex': 0
    })
      .on('click.' + this.namespace, this.type === 'accordion' && '> * > :first-child' || '> :first-child > *', function (event) {
        self.goTo(self.$tabs.index($(event.target).closest(self.$tabs)));
      })
      .on('keydown.' + this.namespace, function (event) {

        // event.target should be the element and not a descendant 
        if (event.target !== self.$element) return;

        var match = {
          37: 'prev',
          38: 'prev',
          39: 'next',
          40: 'next',
        }[event.keyCode];

        if (match) {

          event.preventDefault();

          self.goTo(self.index[match]);
        }
      })
      .trigger('create');

    if (this.config.saveState) this.extensions.saveState.bind(this, this.config.saveState) && this.extensions.saveState();
    if (this.config.responsiveSwitch) this.extensions.responsiveSwitch.bind(this, this.config.responsiveSwitch) && this.extensions.responsiveSwitch();
    if (this.config.hashWatch) this.extensions.hashWatch.call(this);
    if (this.config.pauseMedia) this.extensions.pauseMedia.call(this);

    if (typeof this.index.curr !== 'number') this.index.set(0);

    setTimeout(function () {
      self.$element.addClass('transition');
    });

    return this.expand(this.index.curr);
  };

  TabAccordion.prototype.destroy = function (keepData) {
    if (this.type === 'tabs') {
      this.$element.height('auto');
      this.$tablist.remove();
    } else {
      this.$tabs.removeAttr('role').filter('[id^="' + this.namespace + '"]').removeAttr('id');
      this.$tablist.removeAttr('role');
    }

    this.$panels
      .removeAttr('aria-expanded aria-labelledby role')
      .filter('[id^="' + this.namespace + '"]').removeAttr('id');

    this.$content
      .children()
      .children()
      .unwrap()
      .unwrap();

    if (!keepData)
      this.$element
        .removeData(namespace)
        .removeData('responsiveBreakpoint.' + this.namespace);

    this.$element
      .add([window, document.body])
      .off('.' + this.namespace)
      .end()
      .removeAttr('aria-activedescendant tabindex')
      .removeClass(this.type)
      .filter('[id^="' + this.namespace + '"]').removeAttr('id')
      .end()
      .trigger('destroy');

    return this;
  };

  TabAccordion.prototype.resize = function () {
    if (this.type === 'tabs') this.$element.height(this.$tablist.outerHeight() + this.$panels.eq(this.index.curr).outerHeight());
    else if (this.type === 'accordion' && this.$panels[this.index.curr].ariaExpanded)
      this.$content
        .eq(this.index.curr)
        .height(this.$content.eq(this.index.curr).children().outerHeight());

    return this;
  };

  TabAccordion.prototype.expand = function (index) {
    var $panel = this.$panels.eq(index).attr('aria-expanded', this.$panels[index].ariaExpanded = true);

    if (this.resize().type === 'tabs') this.$tabs.eq(index).addClass('current');

    this.$element.attr('aria-activedescendant', this.$panels[this.index.curr].id).trigger('expand', [index, $panel]);

    return this;
  };

  TabAccordion.prototype.collapse = function (index) {
    var $panel = this.$panels.eq(index).attr('aria-expanded', this.$panels[index].ariaExpanded = false);

    if (this.type === 'tabs') {
      this.$tabs.eq(index).removeClass('current');
    } else {
      this.$content.eq(index).height(0);
    }

    this.$element.trigger('collapse', [index, $panel]);

    return this;
  };

  TabAccordion.prototype.goTo = function (index) {
    if (this.index.curr !== index && typeof this.index.curr === 'number') this.collapse(this.index.curr);
    this.index.set(index);

    return this[this.type === 'accordion' && this.$panels.eq(index).prop('ariaExpanded') ? 'collapse' : 'expand'](this.index.curr);
  };

  TabAccordion.prototype.tabsCreateTablist = function (titles) {
    if (typeof this.config.tabsCreateTablist === "function") {
      return this.config.tabsCreateTablist();
    }

    for (var i = 0, li = ''; i < titles.length; i++) li += '<li>' + titles[i].innerHTML + '</li>';
    return $('<ul>' + li + '</ul>');
  };

  TabAccordion.prototype.extensions = {
    hashWatch: function () {

      var that = {
        changeHash: function (hash, $target) {

          var id = $target[0].id;

          $target[0].id = '';
          location.hash = hash;
          $target[0].id = id;

          return that;
        },

        expand: function (hash, event) {

          var $target = this.$element.find(hash);

          if ($target.length) {

            var $panel = $target.closest(this.$panels);

            if ($panel.length) {

              if (event) event.preventDefault();

              this.goTo(this.$panels.index($panel));
              that.changeHash(hash, $target);

              if (event)
                setTimeout(function () {

                  $html
                    .add(document.body)
                    .animate({
                      scrollTop: $target.offset().top,
                    });
                },
                  250);
            }
          }

          return that;
        },
      };

      // hash anchor activation
      $(document.body).on('click.' + this.namespace, 'a[href^="#"]:not([href="#"])', function (event) {
        that.expand.call(self, $(event.target).attr('href'), event);
      })

        // navigation e.g. back button
        .on('hashchange.' + this.namespace, function () {
          that.expand.call(self, location.hash);
        });

      return that.expand.call(this, location.hash);
    },

    saveStateLoaded: false,
    saveState: function (storage) {

      if (typeof storage !== 'object') return;

      var state = {
        remove: function () {

          storage.removeItem(this.namespace);
        },

        load: function () {

          var item = storage.getItem(this.namespace),
            data = JSON.parse(item);

          if (data && data.current) this.index.set(data.current);

          this.extensions.saveStateLoaded = true;
        },

        save: function () {

          storage.setItem(this.namespace, JSON.stringify({ current: this.index.curr, expanded: this.$panels[this.index.curr].ariaExpanded }));
        },
      };

      // load only once per instance per page load
      if (!this.extensions.saveStateLoaded) state.load();

      $(window).on('unload.' + this.namespace, state.save);

      return state;
    },

    responsiveSwitch: function (breakpoint) {
      if (breakpoint === 'tablist') {
        if (this.type === 'tabs') this.$element.data('responsiveBreakpoint.' + this.namespace, breakpoint = getTablistWidth());
        else breakpoint = this.$element.data('responsiveBreakpoint.' + this.namespace);
      }

      function getTablistWidth() {
        for (var i = 0, width = 0; i < this.$tabs.length; i++) width += this.$tabs.eq(i).outerWidth(true);
        return width;
      }

      function switchTo(type) {
        var current = this.index.curr,
          expanded = this.$panels[current].ariaExpanded;

        this.destroy(true);

        this.$element.addClass(this.type = type);

        this.index.set(current);
        this.create();

        this.$element.trigger('typechange', type);
      }

      function checkBreakpoint() {
        if (this.$element) {
          var type = this.$element.outerWidth() <= breakpoint ? 'accordion' : 'tabs';
          if (this.type !== type) switchTo(type);
        }
      }

      $(window).on('resize.' + this.namespace, $.debounce(250, checkBreakpoint));
    },

    pauseMedia: function () {
      if (typeof Modernizr === 'undefined' || !Modernizr.audio || !Modernizr.video || !this.$element.find('audio, video').length) return;

      this.$element.on('collapse.' + this.namespace, function (event, index, $panel) {
        $panel.find('audio, video').each(function () {
          this.pause();
        });
      });
    },
  };

  return TabAccordion;
})();

window.theme = window.theme || {};
window.theme.tabsGroups = window.theme.tabsGroups || {};

/*============================================================================
  TAB GROUPS
==============================================================================*/

theme.TabsGroup = (function () {

  var selectors = {
    container: '.tabs-group',
    tab: '.tabs-group__tab'
  };

  var defaultOptions = {
    activeTab: 1,
    tabsActiveClass: 'tabs-group--active',
    navContainerClass: 'tabs-group__nav',
    tabNavItemClass: 'tabs-group__nav-item',
    accordionNavItemClass: 'tabs-group__accordion-nav-item',
    breakpoint: 990,
    transitionDuration: 0.5
  };

  function TabsGroup(el, options) {
    this.$tabsGroup = $(el);

    if (!this.$tabsGroup.length) {
      return;
    }

    this.options = _.defaults(options, defaultOptions);

    this.config = {
      mediaQueryAccordion: 'screen and (max-width: ' + this.options.breakpoint + 'px)',
      mediaQueryTabs: 'screen and (min-width:  ' + (this.options.breakpoint + 1) + 'px)'
    };

    this.$tabs = this.$tabsGroup.find(selectors.tab);
    this.$navContainer = $('<div></div>').addClass(this.options.navContainerClass);

    // Set initial tab states
    for (var j = this.$tabs.length - 1; j >= 0; j--) {
      var $tab = $(this.$tabs[j]);
      var tabId = $tab.data('tab');
      var tabTitle = $tab.data('tabTitle');

      var $navItem = $('<div></div>')
        .attr('data-target', tabId)
        .attr('data-target-title', tabTitle)
        .html(tabTitle);

      if (tabId == this.options.activeTab) {
        this.activeTab = tabId;
        $tab.attr('data-active', 'true');
        $navItem.attr('data-active', 'true');
      } else {
        $tab.attr('data-active', 'false');
        $navItem.attr('data-active', 'false');
      }

      var $tabNavItem = $navItem;
      var $accordionNavItem = $navItem.clone();

      $tabNavItem.addClass(this.options.tabNavItemClass);
      this.$navContainer.prepend($tabNavItem);

      $accordionNavItem.addClass(this.options.accordionNavItemClass).insertBefore($tab);

    }

    this.$tabsGroup.prepend(this.$navContainer);
    this.$navItems = this.$tabsGroup.find('[data-target]');

    var self = this;

    enquire.register(this.config.mediaQueryAccordion, {
      match: function () {
        self.$tabsGroup.attr('data-tabs-type', 'accordion');
      }
    });

    enquire.register(this.config.mediaQueryTabs, {
      match: function () {
        self.$tabsGroup.attr('data-tabs-type', 'tabs');
      }
    });

    // Bind nav click events
    $(this.$navItems).on('click', function () {
      var target = $(this).data('target');

      if (self.activeTab == target) {
        self._closeAll();
      } else {
        self._goTo(target);
        self.activeTab = target;
      }

    });

    $(this.$tabsGroup).addClass(this.options.tabsActiveClass);
  }

  TabsGroup.prototype = $.extend({}, TabsGroup.prototype, {

    _closeAll: function () {
      var self = this;

      if (self.$tabsGroup.attr('data-tabs-type') != 'accordion') {
        return;
      }

      var $activeTab = $('[data-tab="' + self.activeTab + '"]', self.$tabsGroup);

      var animate = false;
      if ($(window).width() < this.options.breakpoint) {
        animate = true;
      }

      var height = {
        active: {}
      };

      if (animate) {
        height.active.current = $activeTab.height();
        $activeTab.css('height', height.active.current);
      }

      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      if (animate) {
        height.active.new = 0;

        $activeTab.height(height.active.current);

        $activeTab.height(height.active.new);

        setTimeout(function () {
          $activeTab.css('height', '');
        }, self.options.transitionDuration * 1000);
      }

      self.activeTab = false;

    },
    _goTo: function (target) {
      var self = this;

      this.$tabsGroup.trigger({
        type: 'tabChange',
        tabIndex: target
      });

      var $tab = $('[data-tab="' + target + '"]', self.$tabsGroup);
      var $activeTab = $('[data-tab="' + self.activeTab + '"]', self.$tabsGroup);

      var animate = false;
      if ($(window).width() < this.options.breakpoint) {
        animate = true;
      }

      var height = {
        target: {},
        active: {}
      };

      if (animate) {
        height.target.current = 0;
        $tab.css('height', height.target.current);

        height.active.current = $activeTab.height();
        $activeTab.css('height', height.active.current);
      }

      $(self.$tabs).attr('data-active', 'false');
      $(self.$navItems).attr('data-active', 'false');

      var $target = self.$tabsGroup.find('[data-tab=' + target + ']');
      $($target).attr('data-active', 'true');

      var $targetNav = self.$tabsGroup.find('[data-target=' + target + ']');
      $($targetNav).attr('data-active', 'true');

      if (animate) {
        height.target.new = $tab.css('height', 'auto').get(0).scrollHeight;
        height.active.new = 0;

        $tab.height(height.target.current);
        $activeTab.height(height.active.current);

        $tab.height(height.target.new);
        $activeTab.height(height.active.new);

        setTimeout(function () {
          $tab.css('height', '');
          $activeTab.css('height', '');

          $(window).scrollTo($target, {
            duration: self.options.transitionDuration * 1000,
            interrupt: !isMobile.apple.device,
            offset: -100
          });

        }, self.options.transitionDuration * 1000);
      }

      self.activeTab = target;
    }

  })

  return TabsGroup;
})();

/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.CompareToolManager = (function () {
  var DEBUG_MODE = true;

  var defaults = {
    comparePageURLBase:
      window.theme.compareToolSettings &&
      window.theme.compareToolSettings.compareToolURL
        ? window.theme.compareToolSettings.compareToolURL
        : "/pages/compare-tool",
    maxProductsCount: window.theme.compareToolSettings?.maxProductsCount || 3,
  };

  var Product = function (data) {
    _.extend(this, data);

    if (
      this.selected_variant &&
      this.selected_variant.id &&
      typeof this.selected_variant.id != "number"
    ) {
      this.selected_variant.id = parseInt(this.selected_variant.id);
    }

    if (typeof this.selected_variant_id != "number") {
      this.selected_variant_id = parseInt(this.selected_variant_id);
    }

    if (!this.handle) {
      console.error("Handle required");
    }

    if (!this.additionalDataLoaded || DEBUG_MODE) {
      this.loading = true;
      this._retrieveAdditionalData();
    }
  };

  Product.prototype._retrieveAdditionalData = function () {
    var self = this;

    var selectedVariantUrlParam = this.selected_variant_id
      ? "&variant=" + this.selected_variant_id
      : "";
        
    $.get(
      "/products/" +
        this.handle +
        "?view=compare-tool-data-json" +
        selectedVariantUrlParam,
      function (data) {


        data = data.replace(/<[^>]*>?/gm, "");
        
        _.extend(self, JSON.parse(data));

        if (!self.selected_variant) {
          self.selected_variant = self.variants[0];
        }

        if (!self.selected_variant) {
          return console.error("No variant found");
        }

        self.selected_variant_image = self.selected_variant.image;
        self.loading = false;
        self.additionalDataLoaded = true;

        theme.CompareToolManager.checkAllProductsLoaded();
      }
    );
  };




  function CompareToolManager(container) {
    this.data = {
      products: [],
      comparePageURL: defaults.comparePageURLBase,
      comparePageShareURL: "",
      maxProductsCount: defaults.maxProductsCount,
    };

    this.containers = [];

    this.ready = false;


    $(document).on('click', '.product-grid-item__compare-tool', function(event) { 
      $compareToolButton = $(event.currentTarget) 

      var productHandle = $compareToolButton.data().productHandle;

      //var variantId = $compareToolButton.data().variantId;


      console.log(productHandle);
      theme.CompareToolManager.toggleProductByHandle(productHandle);

    
      this.dataset.compareToolReady = true;
    })




    this._restoreExistingProductSelections();

    this.checkAllProductsLoaded();
  }

  CompareToolManager.prototype = _.assignIn({}, CompareToolManager.prototype, {
    bindAddButtonToProductGridItems: function () {
      // Product Grid Item logic for Arc'teryx grid item implementation.

      var self = this;

      var $productGridItems = $(".product-grid-item");

      $productGridItems.each(function () {
        var $this = $(this);
        var productHandle = this.dataset.productHandle;

        var $compareToolButton = $(
          '<div class="product-grid-item__compare-tool"><div></div><p>Compare Products</p></div>'
        );
        $this.append($compareToolButton);

        if (self.productExistInCompare(productHandle)) {
          $compareToolButton.addClass("active");
          $this.addClass("compare-tool-active");
        }


        // self.addProductByHandle(productHandle);
        this.dataset.compareToolReady = true;
      });
    },

    clearAll: function () {
      var i = this.data.products.length;
      while (i--) {
        this.removeProductByIndex(i);
      }
    },

    checkAllProductsLoaded: function () {
      var i = this.data.products.length;


      while (i--) {
        if (!this.data.products[i].additionalDataLoaded) {
          return false;
        }
      }

      
      this._cacheProductSelections();
      this._setReady();

    },

    _setReady: function () {
      this.ready = true;
      $(this.containers).trigger("compareToolReady");
    },

    _cacheProductSelections: function () {
      localStorage.setItem(
        "compare-tool-selected-products",
        JSON.stringify(this.data.products)
      );
    },

    _restoreExistingProductSelections: function () {
      var restoredProductsJSON = localStorage.getItem(
        "compare-tool-selected-products"
      );
      var queryParamProducts = this._retrieveProductsFromURL();
      var cachedProducts = JSON.parse(restoredProductsJSON);

      if (!restoredProductsJSON && !queryParamProducts) {
        return;
      }

      cachedProducts && cachedProducts.reverse();

      var products;

      // Check if param handles match cached handles
      if (cachedProducts && queryParamProducts) {
        var cachedProductsHandles = _.map(cachedProducts, "handle");
        var queryParamProductsHandles = _.map(queryParamProducts, "handle");

        if (
          _.isEqual(
            _.sortBy(cachedProductsHandles),
            _.sortBy(queryParamProductsHandles)
          )
        ) {
          products = cachedProducts;
        } else {
          products = queryParamProducts;
        }
      } else if (queryParamProducts) {
        products = queryParamProducts;
      } else {
        products = cachedProducts;
      }

      var i = products.length,
        product;

      while (i--) {
        product = new Product(products[i]);
        this.addProduct(product);
      }
    },

    addProductByHandleAndVariantId: function (handle, variantId) {
      var product = new Product({
        handle: handle,
        selected_variant_id: variantId,
      });
      this.addProduct(product);
    },

    toggleProductByHandleAndVariantId: function (handle, variantId) {
      if (this.productExistInCompare(handle)) {
        this.removeProductByHandle(handle);
        return false;
      }

      return this.addProductByHandleAndVariantId(handle, variantId);
    },

    toggleProductByHandle: function (handle) {
      
      if (this.productExistInCompare(handle)) {
        this.removeProductByHandle(handle);
        return false;
      }

      return this.addProductByHandle(handle);
    },

    removeProductByHandle: function (handle) {
      var productIndex = _.map(this.data.products, "handle").indexOf(handle);
      this.removeProductByIndex(productIndex);
    },

    addProductByHandle: function (handle) {
      var product = new Product({ handle: handle });

      return this.addProduct(product);
    },

    productExistInCompare: function (productHandle) {
      return _.includes(_.map(this.data.products, "handle"), productHandle);
    },

    _retrieveProductsFromURL: function () {
      function decodeProductsHandlesString(string) {
        return decodeURIComponent(escape(atob(string).split("+"))).split(",");
      }

      var queryParams = theme.utils.getQueryParams();

      if (!queryParams) {
        return;
      }

      var encodedProductsHandles = queryParams.p;

      if (encodedProductsHandles) {
        return _.map(
          decodeProductsHandlesString(encodedProductsHandles),
          function (handle) {
            return new Product({ handle: handle });
          }
        );
      }
    },

    _generateComparePageURL: function () {
      var self = this;

      function createEncodedProductsHandlesString() {
        return btoa(unescape(encodeURIComponent(_.map(self.data.products, "handle").join("+"))));
      }

      var encodedProductsHandlesString = createEncodedProductsHandlesString();
      this.data.comparePageURL =
        defaults.comparePageURLBase +
        (encodedProductsHandlesString
          ? "?p=" + encodedProductsHandlesString
          : "");
    },

    addProduct: function (product) {
      if (this.data.products.length == this.data.maxProductsCount) {
        console.error("Max products");
        iziToast.error({ message: "Maximum products added" });
        $(this.containers).trigger("productAddError");
        return false;
      }

      if (this.productExistInCompare(product.handle)) {
        console.error("Product already exists");
        const productGridItemCompareTool2 = document.querySelectorAll(`[data-product-handle="${product.handle}"] .product-grid-item__compare-tool-2`);
          if (productGridItemCompareTool2.length > 0) {
            productGridItemCompareTool2.forEach((button) => {
              button.classList.add('active');
            });
          }

        return false;
      }

      this.data.products.push(product);
      this._cacheProductSelections();
      this._generateComparePageURL();

      $(this.containers).trigger("productAdded");

      // Product Grid Item logic for Arc'teryx grid item implementation.
      var $productGridItem = $(
        '.product-grid-item[data-product-handle="' + product.handle + '"]'
      );
      var $productGridItemCompareTool = $(
        ".product-grid-item__compare-tool",
        $productGridItem
      );

      const productGridItemCompareTool2 = document.querySelectorAll(`[data-product-handle="${product.handle}"] .product-grid-item__compare-tool-2`);
      if (productGridItemCompareTool2.length > 0) {
        productGridItemCompareTool2.forEach((button) => {
          button.classList.add('active');
        });
      }

      $productGridItem.addClass("compare-tool-active");
      $productGridItemCompareTool.addClass("active");

      return true;
    },

    removeProductByIndex: function (index) {
      // Product Grid Item logic for Arc'teryx grid item implementation.
      var $productGridItem = $(
        '.product-grid-item[data-product-handle="' +
          this.data.products[index].handle +
          '"]'
      );
      var $productGridItemCompareTool = $(
        ".product-grid-item__compare-tool",
        $productGridItem
      );
      $productGridItem.removeClass("compare-tool-active");
      $productGridItemCompareTool.removeClass("active");

      this.data.products.splice(index, 1);
      this._cacheProductSelections();
      this._generateComparePageURL();

      $(this.containers).trigger("productRemoved");
    },
  });

  return new CompareToolManager();
})();

theme.CompareToolSheet = (function () {
  var CompareToolManager = theme.CompareToolManager;

  function CompareToolSheet(container) {
    this.container = container;
    this.$container = $(container);

    CompareToolManager.containers.push(this.container);

    _.extend(this, {
      view: {
        open: true,
        peaking: true,
      },

      methods: {
        togglePeaking: this._togglePeaking.bind(this),
        removeSelectedProduct: this._removeSelectedProduct.bind(this),
        clearAll: this._clearAllProducts.bind(this),
      },
    });

    tinybind.bind(container, {
      methods: this.methods,
      compareTool: CompareToolManager,
      view: this.view,
    });

    var self = this;

    this.$container.on("productAdded", function () {
      if (CompareToolManager.data.products.length > 1) {
        self.view.peaking = false;
      } else {
        self.view.peaking = true;
      }
    });

    this.$container.on("productAddError", function () {
      if (CompareToolManager.data.products.length > 0) {
        self.view.peaking = false;
      }
    });
  }

  CompareToolSheet.prototype = _.assignIn({}, CompareToolSheet.prototype, {
    _clearAllProducts: function () {
      CompareToolManager.clearAll();
    },

    _togglePeaking: function () {
      this.view.peaking = !this.view.peaking;
    },

    _removeSelectedProduct: function () {
      var productIndex = event.currentTarget.dataset.index;
      CompareToolManager.removeProductByIndex(productIndex);
    },
  });

  return CompareToolSheet;
})();


theme.QuantitySelectors = (function () {
  var selectors = {
    qtyInputs: 'input[type="number"]',
    excludeInputs: '#cart input[type="number"], .js-qty-select input[type="number"], .product-grid-item input[type="number"]',
    qtySelector: '.js-qty-select',
    qtyButtonAdd: '.js-qty-select-add',
    qtyButtonSubtract: '.js-qty-select-sub',
  };

  var classes = {
    qtySelector: 'js-qty-select',
    qtyButtonAdd: 'js-qty-select-add',
    qtyButtonSubtract: 'js-qty-select-sub',
  };

  var $qtyInputs = $(selectors.qtyInputs).not(selectors.excludeInputs);

  if ($qtyInputs.length) {
    $qtyInputs.each(function () {
      var $el = $(this);
      init($el);
    });
  }

  $(document).on('click.qtySelector', selectors.qtySelector + ' button', function (evt) {
    evt.preventDefault();
    var $button = $(this);
    var $input = $button.siblings(selectors.qtyInputs);
    var oldValue = parseFloat($input.val());
    var maxQty = parseInt($input.prop('max'));
    var minQty = parseInt($input.prop('min'));
    var step = parseFloat($input.attr('step'));
    step = isNaN(step) ? 1 : step;
    var newValue;

    if ($button.hasClass(classes.qtyButtonAdd)) {
      newValue = oldValue + step;
      if (maxQty && newValue >= maxQty) {
        $button.prop('disabled', true);
      }
    } else {
      newValue = oldValue - step;
      if (newValue < minQty) {
        newValue = minQty;
      }
      if (newValue < maxQty) {
          $button.siblings(selectors.qtyButtonAdd).prop('disabled', false);
        }
      }

    $input.val(newValue);
    $input.trigger('update.qtySelector');
  });

  function init($el) {
    if (!$el.length) {
      return false;
    }

    var $wrapper = $el.wrap('<div class="' + classes.qtySelector + '"></div>').parent();
    var value = parseInt($el.val());
    var maxQty = parseInt($el.prop('max'));
    var step = parseFloat($el.attr('step'));
    step = isNaN(step) ? 1 : step;

    var svgAdd = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none"><path d="M6.46411 5.50586L11.0029 11.0036L6.46411 16.4966" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var svgSubtract = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none"><path d="M11.3788 5.50586L6.84082 11.0026L11.3788 16.4945" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    $wrapper.prepend('<button class="' + classes.qtyButtonSubtract + '">' + svgSubtract + '</button>');

    if (maxQty == 1 && value == 1) {
      $wrapper.append('<button class="' + classes.qtyButtonAdd + '" disabled>' + svgAdd + '</button>');
    } else {
      $wrapper.append('<button class="' + classes.qtyButtonAdd + '">' + svgAdd + '</button>');
    }
  }

  return {
    init: init
  };
})();

(function () {
  var classes = {
    notificationHidden: 'notification-message--hidden'
  };

  var queryParams = theme.utils.getQueryParams();

  if (queryParams === undefined || queryParams.status === undefined) {
    return;
  }

  $('[data-notification="' + queryParams.status + '"]').removeClass(classes.notificationHidden);

})();

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'currency',
  write: function (currency) {
    jQuery.cookie(this.name, currency, this.configuration);
  },
  read: function () {
    return jQuery.cookie(this.name);
  },
  destroy: function () {
    jQuery.cookie(this.name, null, this.configuration);
  }
};

Currency.moneyFormats = {
  "USD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} USD"
  },
  "EUR": {
    "money_format": "&euro;{{amount}}",
    "money_with_currency_format": "&euro;{{amount}} EUR"
  },
  "GBP": {
    "money_format": "&pound;{{amount}}",
    "money_with_currency_format": "&pound;{{amount}} GBP"
  },
  "CAD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} CAD"
  },
  "ALL": {
    "money_format": "Lek {{amount}}",
    "money_with_currency_format": "Lek {{amount}} ALL"
  },
  "DZD": {
    "money_format": "DA {{amount}}",
    "money_with_currency_format": "DA {{amount}} DZD"
  },
  "AOA": {
    "money_format": "Kz{{amount}}",
    "money_with_currency_format": "Kz{{amount}} AOA"
  },
  "ARS": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
  },
  "AMD": {
    "money_format": "{{amount}} AMD",
    "money_with_currency_format": "{{amount}} AMD"
  },
  "AWG": {
    "money_format": "Afl{{amount}}",
    "money_with_currency_format": "Afl{{amount}} AWG"
  },
  "AUD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} AUD"
  },
  "BBD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} Bds"
  },
  "AZN": {
    "money_format": "m.{{amount}}",
    "money_with_currency_format": "m.{{amount}} AZN"
  },
  "BDT": {
    "money_format": "Tk {{amount}}",
    "money_with_currency_format": "Tk {{amount}} BDT"
  },
  "BSD": {
    "money_format": "BS${{amount}}",
    "money_with_currency_format": "BS${{amount}} BSD"
  },
  "BHD": {
    "money_format": "{{amount}}0 BD",
    "money_with_currency_format": "{{amount}}0 BHD"
  },
  "BYR": {
    "money_format": "Br {{amount}}",
    "money_with_currency_format": "Br {{amount}} BYR"
  },
  "BZD": {
    "money_format": "BZ${{amount}}",
    "money_with_currency_format": "BZ${{amount}} BZD"
  },
  "BTN": {
    "money_format": "Nu {{amount}}",
    "money_with_currency_format": "Nu {{amount}} BTN"
  },
  "BAM": {
    "money_format": "KM {{amount_with_comma_separator}}",
    "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
  },
  "BRL": {
    "money_format": "R$ {{amount_with_comma_separator}}",
    "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB": {
    "money_format": "Bs{{amount_with_comma_separator}}",
    "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP": {
    "money_format": "P{{amount}}",
    "money_with_currency_format": "P{{amount}} BWP"
  },
  "BND": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} BND"
  },
  "BGN": {
    "money_format": "{{amount}} лв",
    "money_with_currency_format": "{{amount}} лв BGN"
  },
  "MMK": {
    "money_format": "K{{amount}}",
    "money_with_currency_format": "K{{amount}} MMK"
  },
  "KHR": {
    "money_format": "KHR{{amount}}",
    "money_with_currency_format": "KHR{{amount}}"
  },
  "KYD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} KYD"
  },
  "XAF": {
    "money_format": "FCFA{{amount}}",
    "money_with_currency_format": "FCFA{{amount}} XAF"
  },
  "CLP": {
    "money_format": "${{amount_no_decimals}}",
    "money_with_currency_format": "${{amount_no_decimals}} CLP"
  },
  "CNY": {
    "money_format": "&#165;{{amount}}",
    "money_with_currency_format": "&#165;{{amount}} CNY"
  },
  "COP": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} COP"
  },
  "CRC": {
    "money_format": "&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK": {
    "money_format": "{{amount_with_comma_separator}} kn",
    "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
  },
  "CZK": {
    "money_format": "{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
  },
  "DKK": {
    "money_format": "{{amount_with_comma_separator}}",
    "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
  },
  "DOP": {
    "money_format": "RD$ {{amount}}",
    "money_with_currency_format": "RD$ {{amount}}"
  },
  "XCD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "EC${{amount}}"
  },
  "EGP": {
    "money_format": "LE {{amount}}",
    "money_with_currency_format": "LE {{amount}} EGP"
  },
  "ETB": {
    "money_format": "Br{{amount}}",
    "money_with_currency_format": "Br{{amount}} ETB"
  },
  "XPF": {
    "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "FJ${{amount}}"
  },
  "GMD": {
    "money_format": "D {{amount}}",
    "money_with_currency_format": "D {{amount}} GMD"
  },
  "GHS": {
    "money_format": "GH&#8373;{{amount}}",
    "money_with_currency_format": "GH&#8373;{{amount}}"
  },
  "GTQ": {
    "money_format": "Q{{amount}}",
    "money_with_currency_format": "{{amount}} GTQ"
  },
  "GYD": {
    "money_format": "G${{amount}}",
    "money_with_currency_format": "${{amount}} GYD"
  },
  "GEL": {
    "money_format": "{{amount}} GEL",
    "money_with_currency_format": "{{amount}} GEL"
  },
  "HNL": {
    "money_format": "L {{amount}}",
    "money_with_currency_format": "L {{amount}} HNL"
  },
  "HKD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "HK${{amount}}"
  },
  "HUF": {
    "money_format": "{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK": {
    "money_format": "{{amount_no_decimals}} kr",
    "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
  },
  "INR": {
    "money_format": "Rs. {{amount}}",
    "money_with_currency_format": "Rs. {{amount}}"
  },
  "IDR": {
    "money_format": "{{amount_with_comma_separator}}",
    "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
  },
  "ILS": {
    "money_format": "{{amount}} NIS",
    "money_with_currency_format": "{{amount}} NIS"
  },
  "JMD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} JMD"
  },
  "JPY": {
    "money_format": "&#165;{{amount_no_decimals}}",
    "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
  },
  "JEP": {
    "money_format": "&pound;{{amount}}",
    "money_with_currency_format": "&pound;{{amount}} JEP"
  },
  "JOD": {
    "money_format": "{{amount}}0 JD",
    "money_with_currency_format": "{{amount}}0 JOD"
  },
  "KZT": {
    "money_format": "{{amount}} KZT",
    "money_with_currency_format": "{{amount}} KZT"
  },
  "KES": {
    "money_format": "KSh{{amount}}",
    "money_with_currency_format": "KSh{{amount}}"
  },
  "KWD": {
    "money_format": "{{amount}}0 KD",
    "money_with_currency_format": "{{amount}}0 KWD"
  },
  "KGS": {
    "money_format": "лв{{amount}}",
    "money_with_currency_format": "лв{{amount}}"
  },
  "LVL": {
    "money_format": "Ls {{amount}}",
    "money_with_currency_format": "Ls {{amount}} LVL"
  },
  "LBP": {
    "money_format": "L&pound;{{amount}}",
    "money_with_currency_format": "L&pound;{{amount}} LBP"
  },
  "LTL": {
    "money_format": "{{amount}} Lt",
    "money_with_currency_format": "{{amount}} Lt"
  },
  "MGA": {
    "money_format": "Ar {{amount}}",
    "money_with_currency_format": "Ar {{amount}} MGA"
  },
  "MKD": {
    "money_format": "ден {{amount}}",
    "money_with_currency_format": "ден {{amount}} MKD"
  },
  "MOP": {
    "money_format": "MOP${{amount}}",
    "money_with_currency_format": "MOP${{amount}}"
  },
  "MVR": {
    "money_format": "Rf{{amount}}",
    "money_with_currency_format": "Rf{{amount}} MRf"
  },
  "MXN": {
    "money_format": "$ {{amount}}",
    "money_with_currency_format": "$ {{amount}} MXN"
  },
  "MYR": {
    "money_format": "RM{{amount}} MYR",
    "money_with_currency_format": "RM{{amount}} MYR"
  },
  "MUR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} MUR"
  },
  "MDL": {
    "money_format": "{{amount}} MDL",
    "money_with_currency_format": "{{amount}} MDL"
  },
  "MAD": {
    "money_format": "{{amount}} dh",
    "money_with_currency_format": "Dh {{amount}} MAD"
  },
  "MNT": {
    "money_format": "{{amount_no_decimals}} &#8366",
    "money_with_currency_format": "{{amount_no_decimals}} MNT"
  },
  "MZN": {
    "money_format": "{{amount}} Mt",
    "money_with_currency_format": "Mt {{amount}} MZN"
  },
  "NAD": {
    "money_format": "N${{amount}}",
    "money_with_currency_format": "N${{amount}} NAD"
  },
  "NPR": {
    "money_format": "Rs{{amount}}",
    "money_with_currency_format": "Rs{{amount}} NPR"
  },
  "ANG": {
    "money_format": "&fnof;{{amount}}",
    "money_with_currency_format": "{{amount}} NA&fnof;"
  },
  "NZD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} NZD"
  },
  "NIO": {
    "money_format": "C${{amount}}",
    "money_with_currency_format": "C${{amount}} NIO"
  },
  "NGN": {
    "money_format": "&#8358;{{amount}}",
    "money_with_currency_format": "&#8358;{{amount}} NGN"
  },
  "NOK": {
    "money_format": "kr {{amount_with_comma_separator}}",
    "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
  },
  "OMR": {
    "money_format": "{{amount_with_comma_separator}} OMR",
    "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
  },
  "PKR": {
    "money_format": "Rs.{{amount}}",
    "money_with_currency_format": "Rs.{{amount}} PKR"
  },
  "PGK": {
    "money_format": "K {{amount}}",
    "money_with_currency_format": "K {{amount}} PGK"
  },
  "PYG": {
    "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN": {
    "money_format": "S/. {{amount}}",
    "money_with_currency_format": "S/. {{amount}} PEN"
  },
  "PHP": {
    "money_format": "&#8369;{{amount}}",
    "money_with_currency_format": "&#8369;{{amount}} PHP"
  },
  "PLN": {
    "money_format": "{{amount_with_comma_separator}} zl",
    "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
  },
  "QAR": {
    "money_format": "QAR {{amount_with_comma_separator}}",
    "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
  },
  "RON": {
    "money_format": "{{amount_with_comma_separator}} lei",
    "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
  },
  "RUB": {
    "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF": {
    "money_format": "{{amount_no_decimals}} RF",
    "money_with_currency_format": "{{amount_no_decimals}} RWF"
  },
  "WST": {
    "money_format": "WS$ {{amount}}",
    "money_with_currency_format": "WS$ {{amount}} WST"
  },
  "SAR": {
    "money_format": "{{amount}} SR",
    "money_with_currency_format": "{{amount}} SAR"
  },
  "STD": {
    "money_format": "Db {{amount}}",
    "money_with_currency_format": "Db {{amount}} STD"
  },
  "RSD": {
    "money_format": "{{amount}} RSD",
    "money_with_currency_format": "{{amount}} RSD"
  },
  "SCR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} SCR"
  },
  "SGD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} SGD"
  },
  "SYP": {
    "money_format": "S&pound;{{amount}}",
    "money_with_currency_format": "S&pound;{{amount}} SYP"
  },
  "ZAR": {
    "money_format": "R {{amount}}",
    "money_with_currency_format": "R {{amount}} ZAR"
  },
  "KRW": {
    "money_format": "&#8361;{{amount_no_decimals}}",
    "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} LKR"
  },
  "SEK": {
    "money_format": "{{amount_no_decimals}} kr",
    "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
  },
  "CHF": {
    "money_format": "SFr. {{amount}}",
    "money_with_currency_format": "SFr. {{amount}} CHF"
  },
  "TWD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} TWD"
  },
  "THB": {
    "money_format": "{{amount}} &#xe3f;",
    "money_with_currency_format": "{{amount}} &#xe3f; THB"
  },
  "TZS": {
    "money_format": "{{amount}} TZS",
    "money_with_currency_format": "{{amount}} TZS"
  },
  "TTD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} TTD"
  },
  "TND": {
    "money_format": "{{amount}}",
    "money_with_currency_format": "{{amount}} DT"
  },
  "TRY": {
    "money_format": "{{amount}}TL",
    "money_with_currency_format": "{{amount}}TL"
  },
  "UGX": {
    "money_format": "Ush {{amount_no_decimals}}",
    "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
  },
  "UAH": {
    "money_format": "₴{{amount}}",
    "money_with_currency_format": "₴{{amount}} UAH"
  },
  "AED": {
    "money_format": "Dhs. {{amount}}",
    "money_with_currency_format": "Dhs. {{amount}} AED"
  },
  "UYU": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
  },
  "VUV": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}}VT"
  },
  "VEF": {
    "money_format": "Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND": {
    "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT": {
    "money_format": "{{amount_no_decimals}} BTC",
    "money_with_currency_format": "{{amount_no_decimals}} BTC"
  },
  "XOF": {
    "money_format": "CFA{{amount}}",
    "money_with_currency_format": "CFA{{amount}} XOF"
  },
  "ZMW": {
    "money_format": "K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};

Currency.formatMoney = function (cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function (oldCurrency, newCurrency, selector, format) {
  if (newCurrency === undefined) {
    return;
  }

  $(selector || 'span.money').each(function () {
    // If the amount has already been converted, we leave it alone.
    if ($(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if ($(this).attr('data-currency-' + newCurrency)) {
      $(this).html($(this).attr('data-currency-' + newCurrency));
    }
    else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10) * 100, oldCurrency, newCurrency);
      }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10) / 10, oldCurrency, newCurrency);
      }
      else {
        cents = Currency.convert(parseInt($(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      $(this).html(newFormattedAmount);
      $(this).attr('data-currency-' + newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    $(this).attr('data-currency', newCurrency);
  });
  this.currentFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};

/*============================================================================
  Development Helpers
==============================================================================*/
(function () {
  var isDevelopment = window.location.hostname == 'localhost' || $(document.documentElement).hasClass('localhost');

  if (isDevelopment) {
    document.documentElement.classList.add('localhost');
    // Shopify.designMode = true;

    // Media Query Infobox + Admin Links
    var globeIcon = '<svg aria-hidden="true" data-prefix="fas" data-icon="globe" class="svg-inline--fa fa-globe fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"></path></svg>';
    var pencilIcon = '<svg aria-hidden="true" data-prefix="fas" data-icon="pencil-alt" class="svg-inline--fa fa-pencil-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"></path></svg>';
    $('body').append('<div class="dev-helper"><div class="links"><a href="https://shopify.com/admin" title="Admin" target="_blank" rel="noopener noreferrer">' + globeIcon + '</a><a href="https://shopify.com/admin/themes/' + Shopify.theme.id + '/editor" title="Customise" target="_blank" rel="noopener noreferrer">' + pencilIcon + '</a></div><div class="mq" title="' + Shopify.theme.name + '"><span class="visible-xs">XS</span><span class="visible-sm">SM</span><span class="visible-md">MD</span><span class="visible-lg">LG</span><span class="visible-xl">XL</span></div></div>');

    // Janky function to make SCSS debug info easier to see on the frontend
    try {
      for (var i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('/assets/theme.scss.css?') > -1) {
          if (document.styleSheets[i].cssRules !== undefined && document.styleSheets[i].cssRules.length == 0) {
            $("body > *").hide(); $("body").append("<span>Please wait...</span>");
            $.get('/collections', function (data) {
              var scriptString = '<script';
              scriptString += data.split('id="theme-js"')[1].split('</script>')[0];
              scriptString += '$("body > *").hide(); $("body").append("<span>There was a problem loading styles. Check the customise area in the Shopify admin interface or </span> <a href=\'https://" + shop.permanantDomain + "/services/assets/" + Shopify.theme.id + "/editor_asset/theme.scss.css\' target=\'_blank\' rel=\'noopener noreferrer\'>click here for debug information.</a>");';
              scriptString += '</script>';
              $('head').append(scriptString);
            });
          }
          break;
        }
      }
      // for (var i = 0; i < document.styleSheets.length; i++) {
      //   if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('/assets/custom.scss.css?') > -1) {
      //     if (document.styleSheets[i].cssRules !== undefined && document.styleSheets[i].cssRules.length == 0) {
      //       $("body > *").hide(); $("body").append("<span>Please wait...</span>");
      //       $.get('/collections', function (data) {
      //         var scriptString = '<script';
      //         scriptString += data.split('id="theme-js"')[1].split('</script>')[0];
      //         scriptString += '$("body > *").hide(); $("body").append("<span>There was a problem loading styles. Check the customise area in the Shopify admin interface or </span> <a href=\'https://" + shop.permanantDomain + "/services/assets/" + Shopify.theme.id + "/editor_asset/theme.scss.css\' target=\'_blank\' rel=\'noopener noreferrer\'>click here for debug information.</a>");';
      //         scriptString += '</script>';
      //         $('head').append(scriptString);
      //       });
      //     }
      //     break;
      //   }
      // }
    }
    catch (err) { }
  }

  if (Shopify.theme.role == "unpublished" || Shopify.designMode || isDevelopment) {
    var pacifierIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--full-color icon-pacifier" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><defs><style>.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px}</style></defs><title>pacifier</title><path d="M200.06 391.63a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z" fill="#faae3b"/><path d="M200.06 391.63c-.17.47-.41.92-.59 1.38.46.26.93.55 1.39.8A121.31 121.31 0 0 1 50 456a121.47 121.47 0 0 0 192.86-36.6 347.93 347.93 0 0 1-42.8-27.77z" fill="#f7991f"/><path d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z" fill="#7f2424"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7z" fill="#d73939"/><path d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-5.78 11.83-11.51 21.91-17.6 29.64 27.69 46.37 36 87.16 17.53 105.66a29.55 29.55 0 0 1-5.24 4.05c26.26 8.56 47.76 8 59.79-4.05 23.95-23.95 3.03-85.26-46.84-147.72zM214.23 197a209.6 209.6 0 0 1 22.05-12.21 71.18 71.18 0 0 0 12.42-7.64c-58.33-46.58-115.64-67.88-142.48-51 26.06 8.51 56.85 26.15 87.93 51 4.02 3.02 11.25 10.31 20.08 19.85z" fill="#be3434"/><path d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z" fill="#fcf1d1"/><path d="M454.83 45.17S410.2-3.45 353.31 15.71c28.41 9.25 47 29.46 47 29.46s76.5 70.08 0 146.59c-61.92 61.92-111.85 15.15-139.61 72-7.05 14.44-14 26.24-21.68 34.37 36.72 26.74 56.12 6.76 76.22-34.37 27.76-56.81 77.69-10 139.61-72 76.49-76.51-.02-146.59-.02-146.59z" fill="#f4ddaa"/><path class="cls-8" d="M182.85 317.15C108.65 242.94 72 159.29 101 130.3l-31.8 31.78c-29 29 7.67 112.64 81.88 186.84s157.86 110.86 186.84 81.88L369.7 399c-28.99 29-112.64-7.65-186.85-81.85z"/><path class="cls-8" d="M219.18 280.82c50.13 50.12 72.6 30.87 96-17.1 27.76-56.81 77.69-10 139.61-72 76.51-76.51 0-146.59 0-146.59s-70.08-76.51-146.59 0c-61.92 61.92-15.15 111.85-72 139.61-47.89 23.48-67.14 45.95-17.02 96.08z"/><path class="cls-8" d="M322.86 251.3a71.18 71.18 0 0 0-7.64 12.42c-23.44 48-45.91 67.22-96 17.1s-30.87-72.6 17.1-96a71.18 71.18 0 0 0 12.42-7.64c-62.5-49.91-123.81-70.83-147.74-46.88-29 29 7.67 112.64 81.87 186.85S340.71 428 369.7 399c23.95-23.93 3.03-85.24-46.84-147.7zm-122.8 140.33a71.49 71.49 0 1 1-91.69-91.69 347.93 347.93 0 0 1-27.79-42.84A121.85 121.85 0 1 0 242.9 419.42a347.93 347.93 0 0 1-42.84-27.79z"/></svg>';
    var dummyLinkTooltip = '<div class="hidden"><div id="dummy-link-tooltip">' + pacifierIcon + ' This is a dummy link.</div></div>';
    $('body').append(dummyLinkTooltip);

    tippy('a[href="#"]:not(.btn):not("#CartDrawer a")', {
      content: document.getElementById('dummy-link-tooltip'),
      size: 'small',
      animation: 'shift-toward',
      placement: 'right',
      trigger: 'mouseenter focus',
    });

    tippy('a[href="#"].btn', {
      content: document.getElementById('dummy-link-tooltip'),
      size: 'small',
      animation: 'shift-toward',
      placement: 'right',
      trigger: 'click',
    });
  }

  // Pretty variable dump outputs
  var elems = document.getElementsByClassName('vardump');
  for (var i = 0; i < elems.length; i++) {
    var json = JSON.stringify(JSON.parse(elems[i].dataset.json), undefined, 2);
    elems[i].innerHTML = theme.utils.syntaxHighlight(json);
  }

  tippy('.vardump', {
    content: 'Click items to copy',
    trigger: 'mouseenter',
    theme: 'light',
    placement: 'bottom-end',
    offset: "-20, -50",
    distance: 0,
    animation: 'fade'
  });

  $('.vardump span:not(.group):not(.group-handle)').on('click', function () {
    var $this = $(this);
    var $elem = $('<input value="' + $this.text().replace(/^"/, '').replace(/"$/, '') + '" />').appendTo('body');
    $elem.select();
    document.execCommand('copy');
    $elem.remove();

    tippy(this, {
      content: 'Copied to clipboard!',
      trigger: 'manual',
      theme: 'light',
      showOnInit: true,
      onShown: function (tip) {
        window.setTimeout(function () {
          tip.hide();
        }, 2000);
      },
      onHidden: function (tip) {
        tip.destroy();
      },
    });
  });

  $('.vardump span.group-handle').on('click', function () {
    $(this).parent('.group').toggleClass('closed');
  });

})();

window.theme = window.theme || {};
window.accordions = window.accordions || {};

theme.SimpleAccordion = (function () {

  var defaults = {
    activeClass: 'active',
    accordionClass: 'simple-accordion',
    accordionTitleClass: 'simple-accordion__title'
  };

  var selectors = {
    accordion: '[data-simple-accordion]',
    title: '> .' + defaults.accordionTitleClass,
  };

  function SimpleAccordion(el) {

    this.$el = $(el);

    var mediaQuery = this.$el.data('simpleAccordion');

    if (mediaQuery) {
      this.mediaQuery = theme.settings.mediaQuery[mediaQuery];
    }

    var styleValue = theme.utils.getStyleValue('--accordion-transition-duration') || '0.5s';

    this.animationDuration = styleValue.replace('s', '') * 1000;

    this.$titles = this.$el.find(selectors.title);
    if (!this.$titles.length) {

      this.$titles = this.$el.find('> * ' + selectors.title);

      if (!this.$titles.length) {

        this.$titles = this.$el.children().first();
        this.$titles.addClass(defaults.accordionTitleClass);
      }
    }

    var self = this;

    if (self.mediaQuery) {
      _registerBreakpoints(self.mediaQuery);
    } else {
      initAccordion();
    }

    function initAccordion() {
      self.$el.addClass(defaults.accordionClass);
      if (self.$titles.closest(".mobile-nav-custom").length > 0) {
        self.$titles.on('click.accordion', _openCloseMenu);
      } else {
        self.$titles.on('click.accordion', _openClose);
      }
    }

    function destroyAccordion() {
      self.$el.removeClass(defaults.accordionClass);
      self.$titles.off('click.accordion');
    }

    function _registerBreakpoints(mediaQuery) {

      enquire.register(mediaQuery, {
        match: function () {
          initAccordion();
        },
        unmatch: function () {
          destroyAccordion();
        }
      });

    }

    function _openClose() {

      var $currentTitle = $(this);

      var $target = $(this).next();
      var $active = self.$titles.filter('.' + defaults.activeClass).next();

      var close = false;
      if ($target[0] == $active[0]) {
        close = true;

        // If target is a link and accordion is open then go to link
        if (event.target.href || event.currentTarget.href) {
          window.location.href = event.target.href || event.currentTarget.href;
          return;
        }

      }

      event.preventDefault();

      self.$titles.removeClass(defaults.activeClass);

      var height = {
        target: {},
        active: {}
      };

      height.target.current = $target.height();
      height.active.new = 0;
      height.active.current = $active.height();

      $active.height(height.active.current);

      if (!close) {
        $(this).addClass(defaults.activeClass);
        $target.height(height.target.current);
        $target.addClass(defaults.activeClass);
      }

      $active.removeClass(defaults.activeClass);

      if (!close) {
        $target.height('auto')
        $active.height('auto');
        $active.height(height.active.new);
        height.target.new = $target.get(0).scrollHeight;
        $target.offset();
        $active.offset();
        $currentTitle.trigger('accordionTransitionHeightCalc');
        $active.height('auto');
        $active.height(height.active.current);
        $target.height(height.target.current);
        $target.height(height.target.new);
      }

      $active.height(height.active.new);

      setTimeout(function () {
        $target.height('');
        $active.height('');
        $currentTitle.trigger('accordionTransitionEnd');
      }, self.animationDuration);

      return;
    }
    function _openCloseMenu(event) {

      var $currentTitle = $(this);
      var $target = $(this).next();
      
      var isOpen = $currentTitle.hasClass(defaults.activeClass);

      if (isOpen) {
        if (event.target.href || event.currentTarget.href) {
          window.location.href = event.target.href || event.currentTarget.href;
          return;
        }
      }

      event.preventDefault();

      var height = {
        target: {}
      };

      height.target.current = $target.height();

      if (!isOpen) {
        $currentTitle.addClass(defaults.activeClass);
        $target.addClass(defaults.activeClass);
        
        height.target.new = $target.get(0).scrollHeight;
        
        $target.height(height.target.current);
        $target.offset(); 
        $currentTitle.trigger('accordionTransitionHeightCalc');
        $target.height(height.target.new);

        setTimeout(function () {
          $target.height('');
          $currentTitle.trigger('accordionTransitionEnd');
        }, self.animationDuration);

      } else {
        $target.height($target.height());
        $target.offset(); 
        
        $currentTitle.removeClass(defaults.activeClass);
        $target.removeClass(defaults.activeClass);
        $target.height(0);

        setTimeout(function () {
          $target.height('');
          $currentTitle.trigger('accordionTransitionEnd');
        }, self.animationDuration);
      }

      return;
    }
  }

  (function init() {
    var $accordions = $(selectors.accordion);
    if (!$accordions.length) {
      return;
    }
    for (var i = $accordions.length - 1; i >= 0; i--) {
      window.accordions[i] = new SimpleAccordion($accordions[i]);
    }
  })();

  return SimpleAccordion;
})();

theme.LearnMoreAccordion = (function () {

  var defaults = {
    activeClass: 'active',
    accordionClass: 'simple-accordion',
    accordionTitleClass: 'simple-accordion__title'
  };

  var selectors = {
    accordion: '[data-learnmore-accordion]',
    title: '> .' + defaults.accordionTitleClass,
  };

  function LearnMoreAccordion(el) {

    this.$el = $(el);

    var mediaQuery = this.$el.data('simpleAccordion');

    if (mediaQuery) {
      this.mediaQuery = theme.settings.mediaQuery[mediaQuery];
    }

    var styleValue = theme.utils.getStyleValue('--accordion-transition-duration') || '0.5s';

    this.animationDuration = styleValue.replace('s', '') * 1000;

    this.$titles = this.$el.find(selectors.title);
    if (!this.$titles.length) {

      this.$titles = this.$el.find('> * ' + selectors.title);

      if (!this.$titles.length) {

        this.$titles = this.$el.children().first();
        this.$titles.addClass(defaults.accordionTitleClass);
      }
    }

    var self = this;

    if (self.mediaQuery) {
      _registerBreakpoints(self.mediaQuery);
    } else {
      initAccordion();
    }

    function initAccordion() {
      self.$el.addClass(defaults.accordionClass);
      self.$titles.on('click.accordion', _openClose);
    }

    function destroyAccordion() {
      self.$el.removeClass(defaults.accordionClass);
      self.$titles.off('click.accordion');
    }

    function _registerBreakpoints(mediaQuery) {

      enquire.register(mediaQuery, {
        match: function () {
          initAccordion();
        },
        unmatch: function () {
          destroyAccordion();
        }
      });

    }

    function _openClose() {

      var $currentTitle = $(this);
      var $currentContent = $currentTitle.next();
      var $innerContent = $currentContent.find('.inner');

      var isActive = $currentTitle.hasClass(defaults.activeClass);

      event.preventDefault();

      // Check if this accordion is currently active
      if (isActive) {
        // Close it
        $currentTitle.removeClass(defaults.activeClass);
        $currentContent.removeClass(defaults.activeClass).height('');
      } else {
        // Open it
        $currentTitle.addClass(defaults.activeClass);
        var targetHeight = $innerContent[0].scrollHeight;
        $currentContent.addClass(defaults.activeClass).css('max-height', targetHeight + 'px');

        var height = {
          target: {}
        };

        height.target.current = $currentContent.height();

        $currentContent.height(height.target.current);
        $currentContent.addClass(defaults.activeClass);

        $currentContent.height('auto');
        height.target.new = $currentContent.get(0).scrollHeight;
        $currentContent.offset();
        $currentContent.height(height.target.current);
        $currentContent.height(height.target.new);

        setTimeout(function () {
          $currentContent.height('');
          $currentTitle.trigger('accordionTransitionEnd');
        }, self.animationDuration);
      }

      return;
    }
  }

  (function init() {
    var $accordions = $(selectors.accordion);
    if (!$accordions.length) {
      return;
    }
    for (var i = $accordions.length - 1; i >= 0; i--) {
      window.accordions[i] = new LearnMoreAccordion($accordions[i]);
    }
  })();

  return LearnMoreAccordion;
})();

theme.CompareTool = (function () {
  var CompareToolManager = theme.CompareToolManager;

  var cache = {};

  var featureTypes = [
    {
      title: "product-description",
      formatter: function (feature, product) {
        if (!product.description) {
          return null;
        }
        return product.description.split("</p>")[0] + "</p>";
      },
    },
    {
      title: "variant-price",
      formatter: function (feature, product) {
        if (!product.selected_variant) {
          return "error";
        }
        var priceInCents = product.selected_variant.price;
        return Shopify.formatMoney(priceInCents);
      },
    },
    {
      title: "product-price",
      formatter: function (feature, product) {
        if (product.price_varies) {
          return (
            Shopify.formatMoney(product.price_min) +
            " - " +
            Shopify.formatMoney(product.price_max)
          );
        }
        return Shopify.formatMoney(product.price_min);
      },
    },
    {
      title: "product-rating",
      formatter: function (feature, product) {
        return product.metafields.stamped.badge || null;
      },
    },
    {
      title: "variant-weight",
      formatter: function (feature, product) {
        if (!product.selected_variant.weight_in_unit) {
          return null;
        }
        return "<p>" + product.selected_variant.weight_in_unit + "</p>";
      },
    },
    {
      title: "product-metafield",
      formatter: function (feature, product) {
        if (
          product.metafields &&
          product.metafields[feature.namespace] &&
          product.metafields[feature.namespace][feature.key]
        ) {
          return (
            "<p>" +
            product.metafields[feature.namespace][feature.key].replace(
              "<p>####</p>",
              ""
            ) +
            "</p>"
          );
        }
        return null;
      },
    },
    {
      title: "product-options",
      template:
        '<div class="compare-tool-feature__option-thumbnails-wrapper">' +
        '<a class="compare-tool-feature__option-thumbnail" rv-each-variant="variants" rv-href="product.url | append \'?variant=\' | append variant.id">' +
        '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
        'data-sizes="auto"' +
        'rv-if="variant.image"' +
        'rv-data-src="variant.image | getSizedImageUrl "' +
        'rv-class-lazyload="product.selected_variant_image"' +
        'rv-alt="variant | array_element optionWithPosition"/>' +
        "</a>" +
        "</div>",
      formatter: function (feature, product) {
        if (product.options_by_name[feature.option_name]) {
          // Sometimes data is returned differently. Unsure why.
          var option =
              product.options_by_name[feature.option_name].option ||
              product.options_by_name[feature.option_name],
            values = option.values,
            position = option.position,
            optionWithPosition = "option" + position;

          if (!feature.display_images) {
            return values.join(", ");
          }

          var i = values.length,
            j = product.variants.length,
            value,
            variant,
            variants = [];

          while (i--) {
            value = values[i];
            while (j--) {
              variant = product.variants[j];
              if (variant[optionWithPosition] == value) {
                variants.push(variant);
                break;
              }
            }
          }

          var el = document.createElement("DIV");
          el.innerHTML = this.template;

          tinybind.bind(el, {
            variants: variants,
            product: product,
            optionWithPosition: optionWithPosition,
          });

          return el.innerHTML;
        }
        return null;
      },
    },
  ];

  var emptyFeatureValueHTML = '<p class="compare-tool-feature__empty"> — </p>';

  function Section(data) {
    _.extend(this, data);
    if (this.title) {
      this.id = theme.utils.handleize(this.title);
    }
    this.valueFound = false;
    this.features = [];
  }

  function Feature(data) {
    _.extend(this, data, data.settings);
    this.valueFound = false;
    delete this.settings;
  }

  Feature.prototype.buildHTML = function (product) {
    var featureType = _.find(featureTypes, { title: this.type });
    if (!featureType) {
      return;
    }

    var html = featureType.formatter(this, product);

    if (html) {
      this.valueFound = true;

      if (this.hide_when_empty) {
        this.section.valueFound = true;
      }
    }

    return html || emptyFeatureValueHTML;
  };

  function CompareTool(container) {
    this.container = container;
    this.$container = $(container);

    cache.containerHTML = container.innerHTML;

    CompareToolManager.containers.push(this.container);

    _.extend(this, {
      data: {
        sections: [],
        features: [],
      },

      view: {
        activeSlideIndex: 0,
        productsInView: 0,
        ready: false,
      },

      methods: {
        removeSelectedProduct: this._removeSelectedProduct.bind(this),
        goToPreviousSlide: this.goToPreviousSlide.bind(this),
        goToNextSlide: this.goToNextSlide.bind(this),
        panSlides: this._panSlides.bind(this),
      },
    });

    this._getSections();
    this._getFeatures();

    tinybind.formatters.add_parameter = function (a, b) {
      if (Array.isArray(a)) {
        a.push(b);
        return a;
      }
      return [a, b];
    };

    tinybind.binders["compare-tool-feature-html"] = function (el, data) {
      // data must be an array, with [0] = product and [1] = feature
      var product = data[0],
        feature = data[1];

      el.innerHTML = feature.buildHTML(product);
    };

    tinybind.binders["swipe"] = function (el, options) {
      options = _.extend(options || {}, { domEvents: true });
      new Hammer(el, options);
    };

    tinybind.bind(container, {
      data: this.data,
      methods: this.methods,
      compareTool: CompareToolManager,
      view: this.view,
    });

    var self = this;

    enquire.register(theme.settings.mediaQuery.largeUp, {
      match: function () {
        self.view.productsInView = 3;
        self.view.activeSlideIndex = 0;
      },
    });

    enquire.register(theme.settings.mediaQuery.medium, {
      match: function () {
        self.view.productsInView = 2;
        self.view.activeSlideIndex = 0;
      },
    });

    enquire.register(theme.settings.mediaQuery.small, {
      match: function () {
        self.view.productsInView = 2;
        self.view.activeSlideIndex = 0;
      },
    });

    if (CompareToolManager.ready) {
      this._onReady();
    } else {
      this.$container.one("compareToolReady", function () {
        self._onReady();
      });
    }
  }

  CompareTool.prototype = _.assignIn({}, CompareTool.prototype, {
    _panSlides: function () {
      if (!event.gesture) {
        return;
      }

      if (event.gesture.direction == Hammer.DIRECTION_LEFT) {
        this.goToNextSlide();
      } else if (event.gesture.direction == Hammer.DIRECTION_RIGHT) {
        this.goToPreviousSlide();
      }
    },

    _onReady: function () {
      var self = this;

      this.view.ready = true;

      this.bindAccordion();

      this.$container.on("productAdded", function () {});

      this.$container.on("productRemoved", function () {});
    },

    bindAccordion: function () {
      var $accordions = $(".compare-tool__accordion", this.container);
      $accordions.each(function () {
        new theme.SimpleAccordion(this);
      });
    },

    goToPreviousSlide: function () {
      if (this.view.activeSlideIndex > 0) {
        this.view.activeSlideIndex -= 1;
      }
    },

    goToNextSlide: function () {
      if (
        this.view.activeSlideIndex <
        CompareToolManager.data.maxProductsCount - this.view.productsInView
      ) {
        this.view.activeSlideIndex += 1;
      }
    },

    _removeSelectedProduct: function () {
      var productIndex = event.currentTarget.dataset.index;
      CompareToolManager.removeProductByIndex(productIndex);
    },

    _getSections: function () {
      var sections = window.theme.compareToolSettings.sections;

      for (var i = 0; i < sections.length; i++) {
        this.data.sections.push(new Section(sections[i]));
      }
    },

    _getFeatures: function () {
      var sectionIDs = _.map(this.data.sections, "id"),
        features = window.theme.compareToolSettings.features,
        feature,
        section,
        sectionIndex;

      for (var i = 0; i < features.length; i++) {
        feature = new Feature(features[i]);

        // Add feature to section
        if (feature.section_title) {
          sectionIndex = sectionIDs.indexOf(
            theme.utils.handleize(feature.section_title)
          );

          if (sectionIndex > -1) {
            section = this.data.sections[sectionIndex];
            section.features.push(feature);
            feature.section = section;
          }
        }

        this.data.features.push(feature);
      }
    },
  });

  return CompareTool;
})();

/*============================================================================
  Scroll to utility
==============================================================================*/
window.theme = window.theme || {};

theme.scrollTo = (function () {

  var options = {

    scrollTo: {
      duration: 700,
      interrupt: !isMobile.apple.device, // Don't allow interupt on iOS
      offset: -150
    }

  }

  function init() {

    $('a[href^="#"]').click(function (e) {
      e.preventDefault();
      $(window).stop(true) && $(window).scrollTo(this.hash, options.scrollTo);
    });

    if (document.location.search && theme.utils.getQueryParams().scrollto) {
      $(window).stop(true)[0].scrollTo('#' + theme.utils.getQueryParams().scrollto, options.scrollTo);
      history.replaceState(null, '', theme.utils.updateQueryStringParameter('scrollto', null));
    }

  }


  init();

  return;

})();
/*============================================================================
  Quantity Selectors
==============================================================================*/
window.theme = window.theme || {};

theme.ProductGridItem = (function () {
  var cache = {};

  var selectors = {
    orderForm: '.product-grid-item__order-form',
    orderSubmitButton: '.product-grid-item__order-submit',
    productJson: '[data-product-json]',
    productMetafieldsJson: '[data-product-metafields-json]',
    productVariantInventoryJson: '[data-product-variant-inventory-json]'
  };

  function ProductGridItem(container) {
    this.$container = $(container);

    if (!this.$container.length) {
      return;
    }

    this._cacheSelectors();

    this.productSingleObject = cache.$productJson.length ? JSON.parse(cache.$productJson.html()) : {};
    this.productSingleObject.metafields = cache.$productMetafieldsJson.length ? JSON.parse(cache.$productMetafieldsJson.html()) : {};

    var self = this;

    if (cache.$productVariantInventoryJson.length) {
      var productVariantInventoryJson = cache.$productVariantInventoryJson.length ? JSON.parse(cache.$productVariantInventoryJson.html()) : {};

      this.productSingleObject.variants.forEach(function (variant, index) {
        var inventoryObject = _.find(productVariantInventoryJson, ['id', variant.id]);
        self.productSingleObject.variants[index] = _.merge(self.productSingleObject.variants[index], inventoryObject);
      });
    }

    this.$orderForms = $(selectors.orderForm, this.$container);
    this.$orderSubmitButton = $(selectors.orderSubmitButton, this.$container);

    if (!this.$orderForms.length || !this.$orderSubmitButton.length) {
      return false;
    }

    this._bindSubmitButton();
    this._initQuantitySelectors();
  }

  ProductGridItem.prototype = $.extend({}, ProductGridItem.prototype, {
    _bindSubmitButton: function () {
      var self = this;

      // Submit all forms
      this.$orderSubmitButton.on('click.product-grid-item', function () {
        self.$orderForms.each(function () {
          $(this).submit();
        });
      });

    },

    _cacheSelectors: function () {
      cache = {
        $productJson: $(selectors.productJson, this.$container),
        $productMetafieldsJson: $(selectors.productMetafieldsJson, this.$container),
        $productVariantInventoryJson: $(selectors.productVariantInventoryJson, this.$container),
      };
    },

    _initQuantitySelectors: function () {
      var self = this;

      this.$orderForms.each(function () {
        var $form = $(this);
        var varaintId = $form.data('varaintId');
        var variant = _.find(self.productSingleObject.variants, ['id', varaintId]);
        var $quantitySelector = $('input[type="number"]', $form);
        $quantitySelector.attr('max', variant.inventory_quantity);
        theme.QuantitySelectors.init($quantitySelector);
      });
    }
  });

  return ProductGridItem;

})();

theme.productGridItems = (function () {

  var selectors = {
    productGridItem: '.product-grid-item',
    productSwatch: '.product-grid-item__swatch-container',
    productStitch: '.product-grid-item__swatch-container--new',
    productImageContainer: '.product-grid-item__image',
    productSwatchesContainer: '.product-actions__containter',
    productSwatchesContainer2: '.product-grid-item__swatches',
    productGridItemLink: '.product-grid-item a',
    moreSwatches: '.more-swatches'
  };

  $(document).on('click', selectors.productSwatch, goToPdp);
  $(document).on('mouseover', selectors.productSwatch, toggleImage);
  $(document).on('mouseover', selectors.productStitch, replaceStitchImage);
  $(document).on('click', selectors.productGridItemLink, function (event) {
    if ($(event.target).hasClass('slick-arrow')) {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  var $productGridItems = $(selectors.productGridItem);

  $productGridItems.each(function () {
    new theme.ProductGridItem(this);
    handleSwatches($(this));
  });
  
  function goToPdp(event) {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = $(this).data('href');
  }

  function toggleImage(event) {
    event.preventDefault();
    event.stopPropagation();
    var productId = $(this).data('product-id');
    var variantId = $(this).data('variant-id');
    var $productGridElement = $(this).closest('.product-grid-item');
    $productGridElement.find('img[data-variant-id]').removeClass('visible');
    $productGridElement.find('img[data-variant-id="' + variantId + '"]').addClass('visible');
  }

  function replaceStitchImage(event) {
    event.preventDefault();
    event.stopPropagation();
    var $productGridElement = $(this).closest('.product-grid-item');
    var stitchingImgElement = $(this).find('img');
    if ($productGridElement.find('img.main-image').length > 0 && stitchingImgElement.length > 0) {
      $productGridElement.find('img.main-image')[0].src = stitchingImgElement[0].src;
      $productGridElement.find('img.main-image')[0].srcset = stitchingImgElement[0].src;
    }
  }

  function handleSwatches($productGridElement) {
    var $swatchesContainer = $productGridElement.find(selectors.productSwatch);
    var $swatches = $swatchesContainer.children();

    var maxVisibleSwatches = 4;

    if ($swatches.length > maxVisibleSwatches) {
      for (var i = maxVisibleSwatches; i < $swatches.length; i++) {
        $($swatches[i]).hide();
      }

      var moreSwatchesCount = $swatches.length - maxVisibleSwatches;
      var productUrl = $swatchesContainer.data('href');
      var moreSwatchesEl = $('<span class="more-swatches">+ ' + moreSwatchesCount + '</span>');

      moreSwatchesEl.attr('href', productUrl);
      $swatchesContainer.append(moreSwatchesEl);
      moreSwatchesEl.show();
    }
  }
})();

/*================ Modules ================*/
window.theme = window.theme || {};

theme.AjaxCart = (function () {
  var selectors = {
    addToCartBtn: '[type="submit"]',
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: '.site-header__cart',
    cartToggle: '.cart__toggle',
    cartDrawer: '.cart-drawer',
    cartDrawerOpen: '.cart-drawer--open',
    cartDrawerTabs: '.cart-drawer__tabs'
  };

  var settings = {
    // 'aboveForm' for top of add to cart form, 
    // 'belowForm' for below the add to cart form, 
    // 'nextButton' for next to add to cart button and
    // 'afterBody' for after the main body content (used for fixed notifications).
    feedbackPosition: 'afterBody'
  };

  var options = {
    requestBodyClass: 'cart-loading',
    moneyFormat: window.shop.moneyFormat,
    moneyWithCurrencyFormat: window.shop.moneyWithCurrencyFormat,
    weightUnit: 'kg', // g, kg, oz, lb
    weightPrecision: 0,
    currency: shop.currency,
    tinybindModels: {
      customer: window.shop.customer,
      methods: {
        customProductInCart: function () {
          var customProductInCart = false;

          for (var i = CartJS.cart.items.length - 1; i >= 0; i--) {
            if (CartJS.cart.items[i].properties && CartJS.cart.items[i].properties._custom_data) {
              customProductInCart = true;
            }
          }

          return customProductInCart;
        }
      },
    },
    errorHandling: {
      cartError: function () {
        $('.cart-loader.loading').removeClass('loading');
        if (this.description) {
          showFeedback('error', this.description);
        }
      }
    }
  };

  var cache = {
    previousCartItems: [],
    updatedItems: []
  };

  var productDataCache = {};
  
  // Note: CartJS cart items don't include variant metafields
  // We'll rely on the Liquid validation in cart-attributes.liquid for mixed cart detection

  // Combined logic to check both terms checkbox and mixed cart items
  function checkCartButtonState() {
    var checkbox = document.querySelector('.js-checkbox-terms-input');
    var cartButtons = document.querySelectorAll('.js-cart-drawer-submit, .cart-summary__submit, input[name="checkout"]');
  
    var termsAccepted = !checkbox || checkbox.checked;
  
    var mixedCartInput = document.querySelector('input[name="attributes[has_mixed_cart]"]');
    var settingEnabled = mixedCartInput && mixedCartInput.getAttribute('data-setting-enabled') === 'true';
    
    if (!settingEnabled) {
      // If setting is disabled, only check terms
      if (termsAccepted) {
        cartButtons.forEach(function(button) {
          button.removeAttribute("disabled");
        });
      } else {
        cartButtons.forEach(function(button) {
          button.setAttribute("disabled", "disabled");
        });
      }
      return;
    }
    
    // Always use Liquid validation results from cart-attributes.liquid
    // CartJS cart items don't include variant metafields, so we can't validate in JavaScript
    var hasMixedCart = mixedCartInput && (mixedCartInput.value === 'true' || mixedCartInput.dataset.mixedCart === 'true');
    var mixedCartReason = mixedCartInput ? mixedCartInput.getAttribute('data-mixed-cart-reason') : '';
    updateButtonState(termsAccepted, hasMixedCart, cartButtons, mixedCartReason);
  }
  
  // Helper function to update button state and notice
  function updateButtonState(termsAccepted, hasMixedCart, cartButtons, mixedCartReason) {
    updateCartNotice(hasMixedCart, mixedCartReason);
    
    var mixedCartInput = document.querySelector('input[name="attributes[has_mixed_cart]"]');
    var settingEnabled = mixedCartInput && mixedCartInput.getAttribute('data-setting-enabled') === 'true';
    
    if (settingEnabled) {
      updateCartAttribute('has_mixed_cart', hasMixedCart);
    }
    
    if (termsAccepted && (!settingEnabled || !hasMixedCart)) {
      cartButtons.forEach(function(button) {
        button.removeAttribute("disabled");
      });
    } else {
      cartButtons.forEach(function(button) {
        button.setAttribute("disabled", "disabled");
      });
    }
    
    if (typeof console !== 'undefined') {
      // console.log('Cart button state updated:', {
      //   termsAccepted: termsAccepted,
      //   hasMixedCart: hasMixedCart,
      //   settingEnabled: settingEnabled,
      //   buttonsDisabled: !termsAccepted || (settingEnabled && hasMixedCart)
      // });
    }
  }

  function updateCartAttribute(attributeKey, attributeValue) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        console.info("Cart attribute updated:", attributeKey, attributeValue, data);
        updateHiddenInput(attributeKey, attributeValue);
      })
      .catch(function(error) {
        console.error("Error updating cart attribute:", error);
      });
  }
  
  // Function to update hidden input field
  function updateHiddenInput(attributeKey, attributeValue) {
    var inputName = 'attributes[' + attributeKey + ']';
    var hiddenInput = document.querySelector('input[name="' + inputName + '"]');
    
    if (hiddenInput) {
      hiddenInput.value = attributeValue.toString();
      hiddenInput.setAttribute('data-mixed-cart', attributeValue.toString());
    } else {
      var newInput = document.createElement('input');
      newInput.type = 'hidden';
      newInput.name = inputName;
      newInput.value = attributeValue.toString();
      newInput.setAttribute('data-mixed-cart', attributeValue.toString());
      
      var form = document.querySelector('form[action="/cart"]');
      if (form) {
        form.appendChild(newInput);
      }
    }
  }

  // Function to dynamically update cart notice with appropriate message
  function updateCartNotice(hasMixedCart, mixedCartReason) {
    var cartContent = document.querySelector('.cart-drawer__content');
    var mixedCartInput = document.querySelector('input[name="attributes[has_mixed_cart]"]');
    var settingEnabled = mixedCartInput && mixedCartInput.getAttribute('data-setting-enabled') === 'true';
    
    // Get the appropriate error message based on the reason
    var errorMessage = '';
    if (mixedCartInput) {
      if (mixedCartReason === 'multiple_preorder_products') {
        errorMessage = mixedCartInput.getAttribute('data-multiple-preorder-message') || 'Your cart contains multiple pre-order products with different shipping dates. Please checkout each pre-order product separately.';
      } else {
        errorMessage = mixedCartInput.getAttribute('data-mixed-preorder-regular-message') || 'Your cart contains both pre-order and regular items. Please checkout these item types separately.';
      }
    } else {
      errorMessage = 'Your cart contains mixed items that cannot be checked out together. Please checkout these items separately.';
    }
    
    // Remove existing notices
    var existingNotice = document.querySelector('.cart-mixed-notice');
    if (existingNotice) {
      existingNotice.remove();
    }
    
    if (cartContent) {
      if (settingEnabled && hasMixedCart) {
        cartContent.classList.add('has-mixed-cart-notice');
      } else {
        cartContent.classList.remove('has-mixed-cart-notice');
      }
    }
    
    // Add new notice if needed and setting is enabled
    if (settingEnabled && hasMixedCart) {
      var notice = document.createElement('div');
      notice.className = 'cart-mixed-notice';
      notice.setAttribute('data-mixed-cart-reason', mixedCartReason || '');
      notice.textContent = errorMessage;
      
      // Try to insert the notice in different possible locations
      var insertionPoints = [
        document.querySelector('.cart-drawer__footer'),
        document.querySelector('.cart__footer'),
        document.querySelector('.cart-summary'),
        document.querySelector('.cart-drawer__content')
      ];
      
      for (var i = 0; i < insertionPoints.length; i++) {
        if (insertionPoints[i]) {
          insertionPoints[i].insertBefore(notice, insertionPoints[i].firstChild);
          break;
        }
      }
    }
  }

  function init() {
    if (!$(selectors.cartDrawer).length) {
      return;
    }

    var $tabsGroup = $(selectors.cartDrawerTabs);
    $.each($tabsGroup, function (index, tabsGroup) {
      window.theme.tabsGroups[tabsGroup] = new theme.TabsGroup(tabsGroup, {
        breakpoint: 0
      });
    });

    $(document).on('click', '[data-add-to-cart], [data-cart-add], [data-cart-update], [data-cart-update-id], [data-cart-remove]', function (evt) {
      var $this = $(this);
      var progressElementSelector = $this.data('progress-element');
      var $progressElement = progressElementSelector ? $(progressElementSelector) : $this;
      if (document.querySelector(".cart-drawer-item.item-cart-custom") && $(this).is("[data-add-to-cart]") && !evt.target.closest(".cart-drawer__footer")) {
        // If there is a custom product, it is not allowed to add normal products.
        const checkIdPDP = $(this).parents(".product-form").find("select[name='id']").val();
        const error = document.querySelector(".cart-drawer__hascustom").dataset.alert;
        if (document.getElementById("cart-drawer-item-43234201895125")) {
          evt.preventDefault();
          evt.stopPropagation();
        }
        if (checkIdPDP != '43234201895125') {
          alert(error);
          evt.preventDefault();
          evt.stopPropagation();
        }
      }
      if ($(this).is("[data-cart-remove]")) {
        const cartDrawer = document.querySelector("#CartDrawer");
        const cartItems = cartDrawer.querySelectorAll(".cart-drawer-item");
        const isGiftCart = document.getElementById("cart-drawer-item-43234201895125");
        const currentCart = evt.target.closest(".cart-drawer-item").getAttribute("data-id");
        if (cartItems.length == 2 && isGiftCart && currentCart != '43234201895125') {
          setTimeout(() => {
            cartDrawer.querySelector("[data-cart-remove]").click();
          },500);
        }
      }

      if ($('.site-header__count')[1] && $this.is('[data-add-to-cart], [data-cart-add]')) {
        $('.site-header__count')[1].click()
      }
      
      if (!$this.is('.disabled')) {
        if ($this.is('[data-opens-cart-drawer]')) {
          $('body').addClass('cart-loading--opens-drawer');
        }
      } else {
        evt.preventDefault();
        evt.stopPropagation();

        $progressElement.addClass('error');
        window.setTimeout(function () {
          $progressElement.removeClass('error');
        }, 1500);

        var highlightElements = $this.data('enable-requirements');
        if (highlightElements) {
          theme.utils.flash(highlightElements);
        }
      }
    });

    initDrawer();

    $(selectors.cartDrawerOpen).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      theme.CartDrawer.drawerIsOpen ? theme.CartDrawer.close() : theme.CartDrawer.open();
    });

    CartJS.init(window.shop.cart, options);

      (function () {
          var _bypassing = false;
          var _queryId = (window.shop && window.shop.cartAvailabilityQueryId) || '';

          function extractLocationInventory(response) {
              var edges =
                  response &&
                  response.data &&
                  response.data.productVariant &&
                  response.data.productVariant.inventoryItem &&
                  response.data.productVariant.inventoryItem.inventoryLevels &&
                  response.data.productVariant.inventoryItem.inventoryLevels.edges;
              if (!Array.isArray(edges)) return [];
              return edges
                  .map(function (edge) {
                      var node = edge && edge.node;
                      var location = node && node.location;
                      var quantities = Array.isArray(node && node.quantities) ? node.quantities : [];
                      var available = quantities.find(function (q) {
                          return q && q.name === 'available';
                      });
                      return {
                          id: location && location.id,
                          name: location && location.name,
                          quantity:
                              available && typeof available.quantity === 'number'
                                  ? available.quantity
                                  : Number((available && available.quantity) || 0),
                          warehouseEnable:
                              location &&
                              location.warehouseStockAvailability &&
                              location.warehouseStockAvailability.value === 'true',
                          storeEnable:
                              location &&
                              location.storeStockAvailability &&
                              location.storeStockAvailability.value === 'true',
                      };
                  })
                  .filter(function (x) {
                      return x.id && x.name;
                  });
          }

          async function fetchAndAppendLocationInventory(form) {
              var idInput = form.querySelector('[name="id"]');
              if (!_queryId || !idInput || !idInput.value) return;

              try {
                  var resp = await fetch('/apps/datajet/task/' + _queryId, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ productVariantId: String(idInput.value) }),
                  });
                  var data = await resp.json();
                  var locationInventory = extractLocationInventory(data);
                  if (!Array.isArray(locationInventory) || locationInventory.length === 0) return;

                  var hidden = form.querySelector('input[name="properties[_location_inventory]"]');
                  if (!hidden) {
                      hidden = document.createElement('input');
                      hidden.type = 'hidden';
                      hidden.name = 'properties[_location_inventory]';
                      form.appendChild(hidden);
                  }
                  hidden.value = JSON.stringify(locationInventory);
              } catch (err) {
                  console.warn('Failed to append _location_inventory to cart/add request', err);
              }
          }

          document.addEventListener(
              'submit',
              function (e) {
                  if (_bypassing) return;
                  var form = e.target;
                  if (!form || !form.hasAttribute('data-cart-submit')) return;
                  if (!_queryId) return;

                  e.preventDefault();
                  e.stopImmediatePropagation();

                  fetchAndAppendLocationInventory(form).finally(function () {
                      _bypassing = true;
                      if (form.requestSubmit) {
                          form.requestSubmit();
                      } else {
                          $(form).trigger('submit');
                      }
                      _bypassing = false;
                  });
              },
              true
          );

          var _origAddItem = CartJS.addItem;
          CartJS.addItem = function (variantId, quantity, properties, options) {
              if (_queryId) {
                  var origArgs = arguments;
                  fetch('/apps/datajet/task/' + _queryId, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ productVariantId: String(variantId) }),
                  })
                      .then(function (r) { return r.json(); })
                      .then(function (data) {
                          var locInv = extractLocationInventory(data);
                          if (Array.isArray(locInv) && locInv.length > 0) {
                              properties = $.extend({}, properties);
                              properties._location_inventory = JSON.stringify(locInv);
                          }
                      })
                      .catch(function () { })
                      .finally(function () {
                          _origAddItem.call(CartJS, variantId, quantity, properties, options);
                      });
                  return;
              }
              return _origAddItem.call(this, variantId, quantity, properties, options);
          };
      })();


    $('#cart-drawer-note, #cart-note').on('blur', function () {
      var note = $(this).val();
      if (note) {
        CartJS.setNote(note);
      } else {
        CartJS.setNote('');
      }
    });

    $('.cart-drawer__submit').click(function () {
      $(document.body).addClass('checkout-activated');
    });

    $(document).on('cart.requestStarted', function (event, cart) {
      cache.previousCartItems = _.values(_.omit(cart.items, _.functions(cart.items)));

      if ('NProgress' in window) {
        NProgress.start();
      }
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      if ('NProgress' in window) {
        NProgress.done();
      }

      $('.cart-loader.loading').removeClass('loading');

      cache.updatedItems = theme.utils.difference(_.values(_.omit(cart.items, _.functions(cart.items))), cache.previousCartItems);
      _.remove(cache.updatedItems, _.isEmpty);

      if (!cache.updatedItems.length && cart.items.length > 0) {
        // showFeedback('error', theme.strings.quantityUnavailable);
      }

      shop.cart = cart;

      // Fetch updated cart validation from server
      setTimeout(function() {
        fetch('/cart?view=drawer')
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            // Extract the updated mixed cart validation from the response
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            var updatedMixedCartInput = tempDiv.querySelector('input[name="attributes[has_mixed_cart]"]');
            
            if (updatedMixedCartInput) {
              var existingMixedCartInput = document.querySelector('input[name="attributes[has_mixed_cart]"]');
              if (existingMixedCartInput) {
                existingMixedCartInput.value = updatedMixedCartInput.value;
                existingMixedCartInput.setAttribute('data-mixed-cart', updatedMixedCartInput.getAttribute('data-mixed-cart'));
                existingMixedCartInput.setAttribute('data-mixed-cart-reason', updatedMixedCartInput.getAttribute('data-mixed-cart-reason'));
                existingMixedCartInput.setAttribute('data-mixed-preorder-regular-message', updatedMixedCartInput.getAttribute('data-mixed-preorder-regular-message'));
                existingMixedCartInput.setAttribute('data-multiple-preorder-message', updatedMixedCartInput.getAttribute('data-multiple-preorder-message'));
              }
            }
            
            // Now check cart button state with updated validation
            checkCartButtonState();
          })
          .catch(function(error) {
            console.warn('Could not fetch updated cart validation:', error);
            // Fallback to checking with existing data
            checkCartButtonState();
          });
      }, 100);

      if (theme.Favicon !== undefined) {
        if (cart.item_count > 0) {
          theme.Favicon.set(cart.item_count);
        } else {
          theme.Favicon.reset();
        }
      }

      var opensDrawer = $('body').is('.cart-loading--opens-drawer');

      if (opensDrawer !== undefined && opensDrawer) {
        if ((theme.cartQueue === undefined || theme.cartQueue.length == 0) && theme.cartQueueProcessing == false) {
          if (!theme.CartDrawer.drawerIsOpen) {
            $('body').removeClass('cart-loading--opens-drawer');
            theme.CartDrawer.open();
          }
        }
      }

      if (theme.CartDrawer.drawerIsOpen && cart.item_count < 1) {
        window.setTimeout(function () {
          theme.CartDrawer.close();
        }, 2500);
      }
    });

    // Set up terms checkbox listener if it exists
    var termsCheckbox = document.querySelector('.js-checkbox-terms-input');
    if (termsCheckbox) {
      termsCheckbox.addEventListener('change', function() {
        checkCartButtonState();
      });
    }

    // Initial button state check
    setTimeout(checkCartButtonState, 100);
  }

  function initDrawer() {
    $('#MainContent').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'CartDrawer').attr('aria-expanded', 'false');

    theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
      onDrawerOpen: cartDrawerOpen,
    });
  }

  function cartDrawerOpen() {
    // $(selectors.cartToggle).addClass(settings.cartDrawerOpen);
    // Check button state when drawer opens
    setTimeout(checkCartButtonState, 50);

      // Refresh cart availability indicators when drawer opens
      //   if (theme.CartPerItemFetch && theme.CartPerItemFetch.refreshIndicators) {
      //       setTimeout(function () {
      //           theme.CartPerItemFetch.refreshIndicators();
      //       }, 300);
      //   }
  
  }

  function cartDrawerClose() {
    // $(selectors.cartToggle).removeClass(settings.cartDrawerOpen);
  }

  function showFeedback(status, response, $addToCartForm) {
    $('.ajax-cart-feedback').remove();
    var feedback = '<div class="ajax-cart-feedback ' + status + '">' + response + '</div>';

    if ($addToCartForm !== undefined && $addToCartForm.length > 0) {
      switch (settings.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'afterBody':
          $(document.body).append(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(selectors.addToCartBtn).after(feedback);
          break;
      }
    } else {
      iziToast.show({
        message: response,
        color: 'red',
        position: 'center'
      });
    }

    var $feedbackElement = $('.ajax-cart-feedback');

    $feedbackElement.offset(); // redraw
    $feedbackElement.addClass('active');
    window.setTimeout(function () {
      $feedbackElement.removeClass('active');
    }, 6500);
  };

  return {
    init: init,
    checkCartButtonState: checkCartButtonState,
    showFeedback: showFeedback
  };
})();

theme.AjaxCart.init();


/*================ Cart Per-Item Availability Fetch ================*/
/**
 * Fetches inventory availability per cart item (variant-level) from Datajet,
 * stores location_inventory as line item properties, and renders
 * delivery / click-and-collect indicators inside the cart drawer & cart page.
 *
 * Adapted from arcteryx-development CartItems.initPerItemFetch().
 * Works with Wilson's CartJS + tinybind architecture.
 */
window.theme = window.theme || {};

theme.CartPerItemFetch = (function () {
    var _availabilityCache = {};
    var _processedDataCache = {};
    var _currentStoreName = '';
    var _currentStoreId = '';
    var _queryId = '';
    var _isRunning = false;
    var _isUpdatingProperties = false;

    function init() {
        _queryId = (window.shop && window.shop.cartAvailabilityQueryId) || '';
        if (!_queryId) {
            return;
        }

        // Initial fetch (wait for tinybind to render cart items)
        setTimeout(function () {
            initPerItemFetch();
        }, 1200);

        // Re-run after every cart change
        $(document).on('cart.requestComplete', function () {
            if (_isUpdatingProperties || _isRunning) return;
            // Small delay so tinybind can re-render the DOM
            setTimeout(function () {
                initPerItemFetch();
            }, 800);
        });

        // Listen for store location changes from stock-display component
        document.addEventListener('storeLocationChanged', function (event) {
            if (event.detail) {
                _currentStoreName = event.detail.name || '';
                _currentStoreId = event.detail.dataId || '';
            }
            // renderIndicators();
        });
    }

    /* ---- Core: per-item fetch & process ---- */
    async function initPerItemFetch() {
        if (_isRunning) return;
        _isRunning = true;

        try {
            var items = CartJS.cart.items;
            if (!items || items.length === 0) {
                _isRunning = false;
                return;
            }

            var storeInfoPromise = fetchCurrentStoreInfo();

            var tasks = items.map(async function (item, index) {
                var productVariantId = String(item.variant_id);
                if (!productVariantId) return;

                // Locate the matching DOM row (drawer or cart page)
                var cartItemRow =
                    document.getElementById('cart-drawer-item-' + item.id) ||
                    document.getElementById('cart-page-item-' + item.id);

                // Fetch variant availability from Datajet
                var data = await getProductAvailability(productVariantId);
                var locationInventory = extractLocationInventory(data);

                // Extract block_from_click_collect from response
                var blockFromCC =
                    data &&
                    data.data &&
                    data.data.productVariant &&
                    data.data.productVariant.product &&
                    data.data.productVariant.product.block_from_click_collect &&
                    data.data.productVariant.product.block_from_click_collect.value;

                _processedDataCache[productVariantId] = {
                    locationInventory: locationInventory,
                    blockClickCollect: blockFromCC === 'true' || blockFromCC === true,
                };

                if (cartItemRow) {
                    if (blockFromCC !== undefined) {
                        cartItemRow.dataset.blockClickCollect = blockFromCC;
                    }
                    cartItemRow.dataset.locationInventory = JSON.stringify(locationInventory);
                }

                // Write _location_inventory to line-item properties via AJAX Cart API
                if (cartItemRow && Array.isArray(locationInventory) && locationInventory.length > 0) {
                    var line = index + 1;
                    var quantity = item.quantity;
                    if (Number.isFinite(line) && Number.isFinite(quantity)) {
                        await updateLineItemLocationInventory(line, quantity, locationInventory);
                    }
                }
            });

            await Promise.allSettled([storeInfoPromise].concat(tasks));

            // Render delivery / pickup indicators now that data is ready
            // renderIndicators();

            // Re-render after tinybind re-renders the DOM (triggered by cart/change.js)
            // setTimeout(function () {
            //     renderIndicators();
            // }, 1500);
        } catch (error) {
            console.error('CartPerItemFetch: error in initPerItemFetch', error);
        } finally {
            _isRunning = false;
        }
    }

    /* ---- Extract location inventory from Datajet response ---- */
    function extractLocationInventory(response) {
        var edges =
            response &&
            response.data &&
            response.data.productVariant &&
            response.data.productVariant.inventoryItem &&
            response.data.productVariant.inventoryItem.inventoryLevels &&
            response.data.productVariant.inventoryItem.inventoryLevels.edges;

        if (!Array.isArray(edges)) return [];

        return edges
            .map(function (edge) {
                var node = edge && edge.node;
                var location = node && node.location;
                var quantities = Array.isArray(node && node.quantities) ? node.quantities : [];
                var available = quantities.find(function (q) {
                    return q && q.name === 'available';
                });

                return {
                    id: location && location.id,
                    name: location && location.name,
                    quantity:
                        available && typeof available.quantity === 'number'
                            ? available.quantity
                            : Number((available && available.quantity) || 0),
                    warehouseEnable:
                        location &&
                        location.warehouseStockAvailability &&
                        location.warehouseStockAvailability.value === 'true',
                    storeEnable:
                        location &&
                        location.storeStockAvailability &&
                        location.storeStockAvailability.value === 'true',
                };
            })
            .filter(function (x) {
                return x.id && x.name;
            });
    }

    /* ---- Update a single line-item's properties with location inventory ---- */
    async function updateLineItemLocationInventory(line, quantity, locationInventory) {
        _isUpdatingProperties = true;
        try {
            var body = JSON.stringify({
                line: line,
                quantity: quantity,
                properties: {
                    _location_inventory: JSON.stringify(locationInventory),
                },
            });

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: body,
            });
        } catch (error) {
            console.error('CartPerItemFetch: Failed to update line item properties', error);
        } finally {
            // Delay reset so any async CartJS events settle first
            setTimeout(function () {
                _isUpdatingProperties = false;
            }, 400);
        }
    }

    /* ---- Fetch current pickup store from cart attributes / cookie ---- */
    async function fetchCurrentStoreInfo() {
        try {
            var response = await fetch('/cart.json');
            var cart = await response.json();
            _currentStoreName = (cart.attributes && cart.attributes._pickup_store_name) || '';
            _currentStoreId = (cart.attributes && cart.attributes._pickup_store_id) || '';

            // Fallback: read from cookie (same cookie used by stock-display component)
            if (!_currentStoreName && !_currentStoreId) {
                var cookieStore = getCookie('currentStore');
                if (cookieStore) {
                    _currentStoreName = cookieStore.name || '';
                    _currentStoreId = cookieStore.dataId || '';
                }
            }
        } catch (e) {
            console.error('CartPerItemFetch: Failed to fetch current store info:', e);
        }
    }

    /* ---- Render delivery & pickup indicators on each cart item ---- */
    // function renderIndicators() {
    //     var containers = document.querySelectorAll('.cart-item__availability-indicators');
    //     var currentStoreId = _currentStoreId;
    //     var currentStoreName = _currentStoreName;
    //     var hasStoreSelected = !!(currentStoreId || currentStoreName);

    //     containers.forEach(function (container) {
    //         var cartItemRow = container.closest('.cart-drawer-item');
    //         if (!cartItemRow) return;

    //         var variantId = container.dataset.variantId;
    //         var locationInventory;
    //         var blockClickCollect = false;

    //         var locationInventoryStr = cartItemRow.dataset.locationInventory;
    //         if (locationInventoryStr) {
    //             try {
    //                 locationInventory = JSON.parse(locationInventoryStr);
    //             } catch (_) {
    //                 locationInventory = [];
    //             }
    //             blockClickCollect = cartItemRow.dataset.blockClickCollect === 'true';
    //         } else if (variantId && _processedDataCache[variantId]) {
    //             var cached = _processedDataCache[variantId];
    //             locationInventory = cached.locationInventory;
    //             blockClickCollect = cached.blockClickCollect;
    //             cartItemRow.dataset.locationInventory = JSON.stringify(locationInventory);
    //             cartItemRow.dataset.blockClickCollect = String(blockClickCollect);
    //         } else {
    //             return;
    //         }

    //         var lineQty = parseInt(container.dataset.lineQuantity, 10) || 1;

    //         // ---- Delivery status ----
    //         var warehouseLocations = locationInventory.filter(function (loc) {
    //             return loc.warehouseEnable;
    //         });
    //         var bestWarehouseQty = Math.max.apply(
    //             null,
    //             warehouseLocations.map(function (loc) { return loc.quantity; }).concat([0])
    //         );
    //         var deliveryAvailable = bestWarehouseQty >= lineQty;

    //         // ---- Pickup status ----
    //         var pickupStatus = 'no-store';
    //         var pickupLocationName = '';
    //         if (hasStoreSelected) {
    //             var storeLocation = locationInventory.find(function (loc) {
    //                 return (
    //                     loc.id === 'gid://shopify/Location/' + currentStoreId ||
    //                     loc.name === currentStoreName
    //                 );
    //             });
    //             var storeInventory = storeLocation ? storeLocation.quantity : 0;
    //             var isPickupAvailable =
    //                 !blockClickCollect && storeLocation && storeInventory >= lineQty;
    //             pickupStatus = isPickupAvailable ? 'available' : 'unavailable';
    //             pickupLocationName = (storeLocation && storeLocation.name) ? storeLocation.name : (currentStoreName || '');
    //         }

    //         // ---- Apply to DOM ----
    //         var deliveryEl = container.querySelector('.cart-item__delivery-indicator');
    //         var pickupEl = container.querySelector('.cart-item__pickup-indicator');

    //         if (deliveryEl) {
    //             var dLabel = deliveryEl.querySelector('.indicator-label');
    //             deliveryEl.classList.remove('available', 'unavailable');
    //             deliveryEl.classList.add(deliveryAvailable ? 'available' : 'unavailable');
    //             if (dLabel) dLabel.textContent = 'Delivery';
    //         }

    //         if (pickupEl) {
    //             var pLabel = pickupEl.querySelector('.indicator-label');
    //             pickupEl.classList.remove('available', 'unavailable');
    //             if (pickupStatus === 'no-store') {
    //                 pickupEl.classList.add('unavailable');
    //                 if (pLabel) pLabel.textContent = 'Set store to see status';
    //             } else if (pickupStatus === 'available') {
    //                 pickupEl.classList.add('available');
    //                 if (pLabel) pLabel.textContent = pickupLocationName ? 'Click & Collect - ' + pickupLocationName : 'Click & Collect';
    //             } else {
    //                 pickupEl.classList.add('unavailable');
    //                 if (pLabel) pLabel.textContent = pickupLocationName ? 'Click & Collect - ' + pickupLocationName : 'Click & Collect';
    //             }
    //         }

    //         // Show container once data is loaded
    //         container.classList.add('loaded');
    //     });
    // }

    /* ---- Fetch variant availability from Datajet (with cache) ---- */
    async function getProductAvailability(productVariantId) {
        if (_availabilityCache[productVariantId]) {
            return _availabilityCache[productVariantId];
        }

        var url = '/apps/datajet/task/' + _queryId;
        var payload = { productVariantId: productVariantId };

        try {
            var response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            var data = await response.json();
            console.log('CartPerItemFetch: variant availability', productVariantId, data);
            _availabilityCache[productVariantId] = data;
            return data;
        } catch (error) {
            console.error('CartPerItemFetch: Fetch Error:', error);
            return {};
        }
    }

    /* ---- Helper: read cookie (same format as stock-display component) ---- */
    function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) {
                try {
                    return JSON.parse(decodeURIComponent(c.substring(nameEQ.length)));
                } catch (e) {
                    return null;
                }
            }
        }
        return null;
    }

    /* ---- Public: refresh indicators only (e.g. after store change) ---- */
    // async function refreshIndicators() {
    //     await fetchCurrentStoreInfo();
    //     // renderIndicators();
    // }

    return {
        init: init,
        initPerItemFetch: initPerItemFetch,
        // refreshIndicators: refreshIndicators,
    };
})();

theme.CartPerItemFetch.init();


// Helpers to detect pre-order/normal items in cart
function hasPreorderInCart(cartObj) {
  try {
    var cart = cartObj || (CartJS && CartJS.cart);
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;
    return cart.items.some(function (it) {
      if (!it || (it.quantity !== undefined && it.quantity <= 0)) return false;
      return it.properties && (it.properties._is_pre_order === true || it.properties._is_pre_order === 'true');
    });
  } catch (e) { return false; }
}
function hasNormalInCart(cartObj) {
  try {
    var cart = cartObj || (CartJS && CartJS.cart);
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;
    return cart.items.some(function (it) {
      if (!it || (it.quantity !== undefined && it.quantity <= 0)) return false;
      var isPre = it && it.properties && (it.properties._is_pre_order === true || it.properties._is_pre_order === 'true');
      return !isPre;
    });
  } catch (e) { return false; }
}
function isMixedCartRestrictionEnabled() {
  try {
    if (window.theme && theme.settings && typeof theme.settings.enable_mixed_cart_restriction !== 'undefined') {
      return !!theme.settings.enable_mixed_cart_restriction;
    }
  } catch (e) {}

  try {
    var mixedCartInput = document.querySelector('input[name="attributes[has_mixed_cart]"]');
    if (mixedCartInput && mixedCartInput.getAttribute('data-setting-enabled') === 'true') {
      return true;
    }
  } catch (e) {}

  return false;
}
function shouldBlockAdd(addingIsPreOrder, cartObj) {
  if (!isMixedCartRestrictionEnabled()) return false;
  // If adding pre-order and there is any normal in cart -> block
  if (addingIsPreOrder && hasNormalInCart(cartObj)) return true;
  // If adding normal and there is any pre-order in cart -> block
  if (!addingIsPreOrder && hasPreorderInCart(cartObj)) return true;
  return false;
}
function showMixedCartAlert(addingIsPreOrder) {
  var message;
  // Try to use existing localized strings if present
  if (window.theme && window.theme.strings && window.theme.strings.mixedCartError) {
    message = window.theme.strings.mixedCartError;
  }
  if (!message) {
    if (window.Shopify && window.Shopify.locale === 'ja') {
      message = '予約商品と通常商品は同時にカートに追加できません。別々にご注文ください。';
    } else {
      message = "You can't mix pre‑order items with regular items in one cart. Please purchase them separately.";
    }
  }

  // Prefer using the existing AjaxCart feedback UI if available
  try {
    if (window.theme && theme.AjaxCart && typeof theme.AjaxCart.showFeedback === 'function') {
      theme.AjaxCart.showFeedback('error', message);
      return;
    }
  } catch (e) {}

  // Fallback to iziToast if available
  if (typeof iziToast !== 'undefined' && iziToast.show) {
    try {
      iziToast.show({ message: message, color: 'red', position: 'center' });
      return;
    } catch (e) {}
  }

  // Final fallback: alert
  try { alert(message); } catch (e) { console && console.warn(message); }
}

// Wrap CartJS.addItem to prevent mixed carts
(function(){
  if (window.CartJS && typeof CartJS.addItem === 'function' && !CartJS._mixedGuardWrapped) {
    var _origAddItem = CartJS.addItem;
    CartJS.addItem = function(variantId, quantity, properties, options){
      var addingIsPreOrder = properties && (properties._is_pre_order === true || properties._is_pre_order === 'true');
      if (shouldBlockAdd(addingIsPreOrder)) {
        showMixedCartAlert(addingIsPreOrder);
        if (options && typeof options.error === 'function') {
          try { options.error.call(this, { description: 'Mixed cart blocked' }); } catch(e){}
        }
        return;
      }
      return _origAddItem.apply(CartJS, arguments);
    };
    CartJS._mixedGuardWrapped = true;
  }
})();

// Intercept native form submissions to prevent mixed carts
document.addEventListener('submit', function(e){
  var form = e.target;
  if (!form || !form.matches || !form.matches('form[action="/cart/add"]')) return;
  var input = form.querySelector('input[name="properties[_is_pre_order]"]');
  var addingIsPreOrder = input && (input.value === 'true' || input.value === true);
  if (shouldBlockAdd(addingIsPreOrder)) {
    e.preventDefault();
    e.stopPropagation();
    showMixedCartAlert(addingIsPreOrder);
  }
}, true);

theme.cartQueue = [];
theme.cartQueueProcessing = false;
theme.processCartQueue = function () {
  // If there's something in the queue, process it
  if (theme.cartQueue.length) {
    theme.cartQueueProcessing = true;
    var request = theme.cartQueue.shift();
    var requestType = request.type || 'add';

    if (requestType == 'add') {
      var addingIsPreOrder = request && request.properties && (request.properties._is_pre_order === true || request.properties._is_pre_order === 'true');
      if (shouldBlockAdd(addingIsPreOrder)) {
        showMixedCartAlert(addingIsPreOrder);
        // Skip this add and continue with the next item in the queue
        theme.processCartQueue();
        return;
      }
      CartJS.addItem(request.variant_id, request.quantity, request.properties, {
        "success": function (data, textStatus, jqXHR) {
          theme.processCartQueue();
        }
      });
    } else if (requestType == 'update') {
      CartJS.updateItem(line_number, quantity, properties = {}, options = {})
    } else {
      // CartJS.removeItem(line_number, options = {})
    }


    // Removed legacy ShopifyAPI.addItem call to prevent duplicate or unguarded adds.
    // Cart operations are handled via CartJS above.
  }
  else {
    theme.cartQueueProcessing = false;
  }
};

window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: 'body',
    navigation: '.site-nav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link, .site-nav__grandchild-link, .site-nav__childlist-footer .btn',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavExpandingChildLink: '.site-nav--mega .site-nav__dropdown--expanding .site-nav__childlist-item > .site-nav__link',
    siteNavChildLinkWithChildren: '.site-nav__child-link--parent',
    siteNavDropdown: '.site-nav__dropdown',
    siteNavFeatureProduct: '.site-nav__childlist-item--feature-product',
  };

  var config = {
    hoverClass: 'site-nav--hover',
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    submenuVisibleOnHover: true,
    firstParentClickNavigates: true, // Overridden for mobile devices
    secondParentClickClosesSubmenu: false, // Relies on previous option being disabled for non-mobile devices
  };

  var cache = {
    isMobile: isMobile.any
  };

  function init() {
    cacheSelectors();

    cache.$noticeBarSlider.slick({
      arrows: false,
      rows: 0,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    var self = this;

    // this._buildDropdowns();
    // this._bindShowHideLowerHeader();

    // new theme.ResponsiveNavList(this.$nav, {
    //   overflowItemHtml: '<a href="#" class="site-nav__link site-nav__link--main site-nav__link--more"><span class="">' + theme.icons.moreVertical + '</span></a>'
    // });

    $('.site-nav__dropdown--expanding').each(function () {
      $(this).attr('data-original-height', $(this).children('.site-nav__childlist').innerHeight());
    });

    cache.$expandingChildren.on('mouseenter.siteNav', function (evt) {
      var $this = $(this);
      var $dropdownElem = $this.parents(selectors.siteNavDropdown);
      var dropdownPadding = $dropdownElem.innerHeight() - $dropdownElem.height();
      var minHeight = parseInt($dropdownElem.data('original-height'));
      var listHeight = _.max([_.map($this.siblings('ul'), function (el) { return el.scrollHeight; }), $(selectors.siteNavFeatureProduct + '[data-handle="' + $this.data('handle') + '"]', $dropdownElem).innerHeight()]);

      anime({
        targets: $dropdownElem[0],
        height: Math.max(minHeight, listHeight) + dropdownPadding,
        easing: 'easeInOutQuad',
        duration: 300,
      });

      $this.addClass('active');

      $(selectors.siteNavFeatureProduct, $dropdownElem).removeClass('active');
      $(selectors.siteNavFeatureProduct + '[data-handle="' + $this.data('handle') + '"]', $dropdownElem).addClass('active');
    });

    if (config.submenuVisibleOnHover && cache.isMobile == false) {
      cache.$parents.on('mouseenter.siteNav', function (evt) {
        var $el = $(this);
        showDropdown($el);
      });

      cache.$parents.on('mouseleave.siteNav', function (evt) {
        var $el = $(this);
        hideDropdown($el);

        $(selectors.siteNavFeatureProduct, $el).removeClass('active');
        $('.site-nav__childlist-navlist ul', $el).removeClass('active');
      });
    }

    if (cache.$nav.is('[data-disable-parent-navigation]')) {
      // Override standard click events
      cache.$childLinksWithChildren.on('click.siteNav', function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      });
      config.firstParentClickNavigates = false;
      config.secondParentClickClosesSubmenu = true;
    }

    cache.$parents.on('click.siteNav', function (evt) {
      var $el = $(this);

      if (config.firstParentClickNavigates && cache.isMobile == false) {
        return;
      }

      if (config.secondParentClickClosesSubmenu || !config.secondParentClickClosesSubmenu && !$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      if (config.secondParentClickClosesSubmenu && $el.hasClass(config.activeClass)) {
        hideDropdown($el);
        return;
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function () {
      setTimeout(function () {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = _.assignIn({}, cache, {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $childLinksWithChildren: $(selectors.siteNavChildLinkWithChildren),
      $expandingChildren: $(selectors.siteNavExpandingChildLink),
      $noticeBarSlider: $('.site-header__notice-bar-slider'),
    });
  }

  function showDropdown($el) {
    $el.addClass(config.hoverClass);
    var dropdownActivationDelay = cache.isMobile ? 0 : 150;

    setTimeout(function () {
      if ($el.hasClass(config.hoverClass) || cache.isMobile) {
        $el.addClass(config.activeClass);

        // close open dropdowns
        if (cache.$activeDropdown.length) {
          hideDropdown(cache.$activeDropdown);
        }

        cache.$activeDropdown = $el;

        // set expanded on open dropdown
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

        $(window).on('keyup.siteNav', function (evt) {
          if (evt.keyCode === 27) {
            hideDropdown($el);
          }
        });

        $(selectors.body).on('click.siteNav', function () {
          hideDropdown($el);
        });
      } else {
        hideDropdown($el);
      }
    }, dropdownActivationDelay);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');

    var $dropdownElem = $el.find(selectors.siteNavDropdown);
    var dropdownPadding = $dropdownElem.innerHeight() - $dropdownElem.height();

    if ($dropdownElem.is('.site-nav__dropdown--expanding')) {
      anime({
        targets: $dropdownElem[0],
        height: $dropdownElem.data('original-height') + dropdownPadding,
        easing: 'easeInOutQuad',
        duration: 300,
      });
    }

    $el.removeClass(config.activeClass);
    $el.removeClass(config.hoverClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
    cache.$noticeBarSlider.slick('unslick');
  }


  return {
    init: init,
    unload: unload
  };
})();



window.theme = window.theme || {};

theme.MobileSearch = (function () {

  var selectors = {
    searchIconHeader: '.site-header__search--global .icon-search',
    closeIcon: '.search-global__close',
    searchBox: '.search-global__container',
    inputElement: '.search-global__search-box .site-search__form-input',
    boostSearchBox: '#bc-sf-search-box-mobile',
    suggestionWrapper: '.bc-sf-search-suggestion-wrapper'
  };

  function MobileSearch() {
    $(selectors.searchIconHeader).on('click', this._toggleSearchBox.bind(this))
    $(selectors.closeIcon).on('click', this._toggleSearchBox.bind(this))
    // $(document).on('input', selectors.boostSearchBox, this._onChangeListener);
    // $(document).on('blur', selectors.boostSearchBox, this._removeActiveState);
    // $(document).on('focus', selectors.boostSearchBox, this._addActiveState);
    // $(document).on(selectors.boostSearchBox, 'change', this._onChangeListener)
    // $(selectors.boostSearchBox).on('change', this._onChangeListener)

  }

  MobileSearch.prototype = $.extend({}, MobileSearch.prototype, {
    _toggleSearchBox: function () {
      var container = $(selectors.searchBox);
      if (container.hasClass('open')) {
        container.removeClass('open');
        $(selectors.suggestionWrapper).css('display', 'none');
      } else {
        container.addClass('open');
        $(selectors.suggestionWrapper).css('display', 'block');
      }
    },

    _addActiveState: function () {
      console.log('adding class');
      $(selectors.inputElement).addClass('active');
    },

    _removeActiveState: function () {
      console.log('removing class');
      $(selectors.inputElement).removeClass('active');
    },

    _onChangeListener: function (event) {
      $target = $(event.target);
      console.log('event', event.target.value);
      $(selectors.inputElement).val(event.target.value);

    }
  });

  return new MobileSearch();
})();

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = theme.settings && theme.settings.mediaQuery && theme.settings.mediaQuery.small;

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContent'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    // var headerHeight = cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;
    var headerHeight = 65;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$pageContainer.addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, 0, 0)',
      'margin-top': headerHeight + 'px'
    });

    cache.$pageContainer.css({
      // overflow: 'hidden',
      height: cache.$mobileNavContainer.outerHeight() + 'px',
      overflow: 'hidden',
      // height: 100 + 'vh'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
        .find('.' + classes.navLinkWrapper + ':first')
        .find('.' + classes.navLink),
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$pageContainer.removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(-100%, 0, 0)'
    });

    cache.$pageContainer.css({
      overflow: 'auto',
      height: '100%'
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .prepareTransition()
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu[0].scrollHeight;
    if (!target) {
      translateMenuHeight = $targetMenu.outerHeight();
    }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    var newContainerHeight = translateMenuHeight + cache.$sectionHeader.outerHeight() + cache.$sectionHeader.offset().top;
    cache.$mobileNavContainer
      .css('height', newContainerHeight + 'px')
      .removeClass(classes.thirdNavShowing)
      .addClass('is-transitioning')
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function () {
        if ($elementToFocus.length > 1) {
          slate.a11y.trapFocus({
            $container: $targetMenu,
            $elementToFocus: $elementToFocus,
            namespace: 'subNavFocus'
          });
        } else {
          slate.a11y.trapFocus({
            $container: cache.$sectionHeader,
            $elementToFocus: cache.$mobileNav
              .find('.' + classes.navLinkWrapper + ':first')
              .find('.' + classes.navLink),
            namespace: 'navFocus'
          });
        }

        cache.$mobileNavContainer.off('.subnavToggle');
        cache.$mobileNavContainer.removeClass('is-transitioning');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      // overflow: 'initial',
      // height: newContainerHeight + 'px'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.MegaMenu = (function () {
  var selectors = {
    megaMenuDropDown: '.site-nav__dropdown ',
    col1: '.site-nav__childlist-navlist--column-1',
    col2: '.site-nav__childlist-navlist--column-2',
    col3: '.site-nav__childlist-navlist--column-3',
    linksContainer: '.site-nav__links'
  };


  function MegaMenu() {
    setMegaMenuHeight();
  }

  function setMegaMenuHeight() {
    $(selectors.megaMenuDropDown).each(function (index, element) {
      var col1Height = 0;
      var col2Height = 0;
      var col3Height = 0;
      $(element).find(selectors.col1).each(function (index, el) {
        col1Height += $(el).outerHeight();
      });
      $(element).find(selectors.col2).each(function (index, el) {
        col2Height += $(el).outerHeight();
      });
      $(element).find(selectors.col3).each(function (index, el) {
        col3Height += $(el).outerHeight();
      });
      var maxHeight = Math.max(col1Height, col2Height, col3Height);
      var heightInEm = maxHeight + 100;
      $(element).find(selectors.linksContainer).css('height', heightInEm + 'px')
    })
  }


  return new MegaMenu();
})();

// theme.current.collection.products[3].compare_at_price = "15000";
// theme.current.collection.products[2].tags.push('preorder');
// theme.current.collection.products[1].tags.push('new');
// theme.current.collection.products[0].available = false;

window.theme = window.theme || {};

theme.ProductFilter = (function () {

  var selectors = {
    collection: '.collection',
    collectionTitle: '[data-collection-title]',
    collectionDescription: '[data-collection-description]',
    collectionGrid: '.collection-grid',
    collectionGridRow: '.collection-grid .row',
    collectionSection: '#shopify-section-collection',
    pageHeader: '.page-header',
    filterTitle: '.bc-sf-filter-block-title h3',
    filterOptionMenuItem: '.bc-sf-filter-option-block',
    filtersDesktop: '.js-filter',
    filteredProductsContainer: '#bc-sf-filter-products',
    collectionVendorsData: '#collection-vendors-data',
    productGridItem: '.product-grid-item',
  };

  var options = {
    displayCollectionDescription: true,
    animateHeaderHeight: false
  };

  var cache = {
    headerHeightCurrent: 0,
    headerHeightNew: 0,
    sort: false,
    $vendorSections: {},
    vendorProducts: {},
    vendorData: {},
    viewBound: false,
  };

  function init() {
    if(window.BCSfFilter){
        window.bcsffilter = new BCSfFilter();
        window.bcSfFilterSettings = {
          general: {
            limit: 69
          }
        };
        window.bcsffilter.init();
        window.bcsffilter.initFilter();
        window.bcsffilter.initSearchBox();
    
        // if ($('.bc-sf-filter-filter-dropdown').val() == 'type') {
        //   theme.ProductFilterAndSearch.loadSubcollectionView();
        // }
    }

  }

  function buildCollectionPage(data, eventType) {

    if (!$(selectors.collection).length) {
      return;
    }

    if (!cache.viewBound) {
      var $collectionSection = $(selectors.collectionSection);
      if ($collectionSection.length) {
        tinybind.bind($collectionSection, theme);
        cache.viewBound = true;
      }
    }

    cache.sort = bcsffilter.queryParams.sort;
    $(selectors.collection).attr('data-sort', cache.sort);

    if ('anime' in window) {
      anime({
        targets: '.product-grid-item',
        translateY: [15, 0],
        opacity: [0, 1],
        duration: 300,
        easing: 'easeInOutCubic',
        delay: anime.stagger(100, { grid: [4, 4] })
      });
    }
  }

  return {
    init: init,
    buildCollectionPage: buildCollectionPage
  };

})();

theme.ProductFilter.init();

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.js-search-toggle',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    pageContent: '#PageContent'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open',
    mobileSearchIsOpen: 'js-search--is-open'
  };

  var searchIsOpen = false;

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    $(selectors.searchSubmit).on('click', function (evt) {
      searchIsOpen = false;
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });

    $(selectors.siteHeaderSearchToggle).on('click', activateSearch);

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus', activateSearch);
    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('blur', deactivateSearch);
  }

  function activateSearch(evt) {
    if (evt.type != 'focus') {
      searchFocus($(selectors.searchInput));
    }
    searchIsOpen = true;

    $(selectors.searchHeader).addClass(classes.focus);
    $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
  }

  function deactivateSearch() {
    searchIsOpen = false;

    $(selectors.searchHeader).removeClass(classes.focus);
    $(selectors.pageContent).removeClass(classes.mobileSearchIsOpen);
  }

  function toggleSearch() {
    if (searchIsOpen) {

    } else {
      searchFocus($(selectors.searchInput));
      searchIsOpen = true;

      $(selectors.searchHeader).addClass(classes.focus);
      $(selectors.pageContent).addClass(classes.mobileSearchIsOpen);
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  return {
    init: init
  };
})();

window.theme = window.theme || {};

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
  // #TODO: Make these more global
  var config = {
    mediaQuerySmall: theme.settings && theme.settings.mediaQuery.small,
    mediaQueryMedium: theme.settings && theme.settings.mediaQuery.medium,
    mediaQueryLargeUp: theme.settings && theme.settings.mediaQuery.largeUp
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    asNavFor: null,
    autoplay: false,
    autoplaySpeed: 7000,
    centerMode: false,
    centerPadding: '40px',
    dots: false,
    draggable: true,
    fade: false,
    infinite: true,
    rows: 0,
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true,
    touchThreshold: 20,
  };

  function slideshow(el) {
    this.$slideshow = $(el);

    if (!this.$slideshow.length) {
      return;
    }

    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper) || this.parent();
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.sliderActive = false;
    var elementOptions = this.$slideshow.data();

    defaults.prevArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__prev';
    defaults.nextArrow = '#' + this.$slideshow.attr('id') + ' ~ .slideshow__next';

    this.settings = {};
    this.settings.all = {
      adaptiveHeight: elementOptions.adaptiveHeight,
      arrows: elementOptions.arrows,
      asNavFor: elementOptions.asNavFor,
      autoplay: elementOptions.autoplay,
      autoplaySpeed: elementOptions.speed,
      centerMode: elementOptions.centerMode,
      centerPadding: elementOptions.centerPadding,
      dots: elementOptions.dots,
      draggable: elementOptions.draggable,
      fade: elementOptions.fade,
      focusOnSelect: elementOptions.focusOnSelect,
      infinite: elementOptions.infinite,
      nextArrow: elementOptions.nextArrow,
      prevArrow: elementOptions.prevArrow,
      rows: elementOptions.rows,
      slidesPerRow: elementOptions.perRow,
      slidesToScroll: elementOptions.slidesScroll,
      slidesToShow: elementOptions.slidesShow,
      waitForAnimate: elementOptions.waitForAnimate,
    };
    this.settings.desktop = {
      arrows: elementOptions.arrowsDesktop,
      autoplay: elementOptions.autoplayDesktop,
      autoplaySpeed: elementOptions.speedDesktop,
      centerMode: elementOptions.centerModeDesktop,
      centerPadding: elementOptions.centerPaddingDesktop,
      dots: elementOptions.dotsDesktop,
      focusOnSelect: elementOptions.focusOnSelectDesktop,
      infinite: elementOptions.infiniteDesktop,
      rows: elementOptions.rowsDesktop,
      slidesPerRow: elementOptions.perRowDesktop,
      slidesToScroll: elementOptions.slidesScrollDesktop,
      slidesToShow: elementOptions.slidesShowDesktop,
    };
    this.settings.tablet = {
      arrows: elementOptions.arrowsTablet,
      autoplay: elementOptions.autoplayTablet,
      autoplaySpeed: elementOptions.speedTablet,
      centerMode: elementOptions.centerModeTablet,
      centerPadding: elementOptions.centerPaddingTablet,
      dots: elementOptions.dotsTablet,
      focusOnSelect: elementOptions.focusOnSelectTablet,
      infinite: elementOptions.infiniteTablet,
      rows: elementOptions.rowsTablet,
      slidesPerRow: elementOptions.perRowTablet,
      slidesToScroll: elementOptions.slidesScrollTablet,
      slidesToShow: elementOptions.slidesShowTablet,
    };
    this.settings.mobile = {
      arrows: elementOptions.arrowsMobile,
      autoplay: elementOptions.autoplayMobile,
      autoplaySpeed: elementOptions.speedMobile,
      centerMode: elementOptions.centerModeMobile,
      centerPadding: elementOptions.centerPaddingMobile,
      dots: elementOptions.dotsMobile,
      focusOnSelect: elementOptions.focusOnSelectMobile,
      infinite: elementOptions.infiniteMobile,
      rows: elementOptions.rowsMobile,
      slidesPerRow: elementOptions.perRowMobile,
      slidesToScroll: elementOptions.slidesScrollMobile,
      slidesToShow: elementOptions.slidesShowMobile,
    };

    _.defaults(this.settings.desktop, this.settings.all);
    _.defaults(this.settings.desktop, defaults);

    _.defaults(this.settings.tablet, this.settings.all);
    _.defaults(this.settings.tablet, defaults);

    _.defaults(this.settings.mobile, this.settings.all);
    _.defaults(this.settings.mobile, defaults);

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    // this.$slideshow.slick(this.settings);

    var self = this;

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        if (!elementOptions.disableMobile) {
          initSlider(self.$slideshow, self.settings.mobile);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function () {
        if (!elementOptions.disableTablet) {
          initSlider(self.$slideshow, self.settings.tablet);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function () {
        if (!elementOptions.disableDesktop) {
          initSlider(self.$slideshow, self.settings.desktop);
        } else {
          destroySlider(self.$slideshow);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }

      sliderObj.slick(args);
      self.sliderActive = true;
    }

    function destroySlider(sliderObj) {
      if (self.sliderActive) {
        sliderObj.slick('unslick');
        self.sliderActive = false;
      }
    }

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (isMobile.any) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function (evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function () {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

(function () {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

/**
* Module to show Recently Viewed Products
*
* Copyright (c) 2014 Caroline Schnapp (11heavens.com)
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
*/

window.theme = window.theme || {};

theme.RecentlyViewed = (function () {

  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;
    },
    destroy: function () {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function () {
    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try { config.onComplete() } catch (error) { }
    }
  };

  var moveAlong = function () {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      jQuery.ajax({
        dataType: 'json',
        url: '/products/' + productHandleQueue[0] + '.js',
        cache: false,
        success: function (product) {
          console.log(product);
          product.featured_image = {
            src: product.featured_image,
          };
          product.images = [];
          for (var i = 0; i < product.images.length; i++) {
            product.images[i] = {
              src: product.images[i],
            };
          }

          template.tmpl(product).appendTo(wrapper);
          productHandleQueue.shift();
          shown++;
          moveAlong();
        },
        error: function () {
          cookie.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      });
    } else {
      finalize();
    }

  };

  return {

    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = jQuery('#' + config.templateId);
      wrapper = jQuery('#' + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && template.length && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }

    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {

      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // What is the product handle on this page.
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);

      }

    }

  };

})();

(function () {
  var selectors = {
    backButton: '.back-to-top',
  };

  var classes = {
    visible: 'back-to-top--visible',
    fade: 'back-to-top--fade',
  };

  var config = {
    showAfter: 300,
    dimAfter: 1200,
    scrollDuration: 700,
  };

  $backButton = $(selectors.backButton);

  if (!$backButton.length) {
    return;
  }

  $(window).scroll(function () {
    ($(this).scrollTop() > config.showAfter) ? $backButton.addClass(classes.visible) : $backButton.removeClass(classes.visible + ' ' + classes.fade);
    if ($(this).scrollTop() > config.dimAfter) {
      $backButton.addClass(classes.fade);
    }
  });

  $backButton.on('click', function (evt) {
    evt.preventDefault();
    $('body,html').animate({ scrollTop: 0 }, config.scrollDuration);
  });
})();

/*============================================================================
  Favicon cart counter
==============================================================================*/
window.theme = window.theme || {};

theme.Favicon = (function () {

  if (window.Favico === undefined) {
    return;
  }

  var icon = new Favico({
    bgColor: '#0cbdc9',
    textColor: '#fff',
    fontFamily: 'sans-serif', // Arial, Verdana, Times New Roman, serif, sans-serif, ...
    fontStyle: 'bold', // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    type: 'circle', // circle, rectangle
    position: 'down', // up, down, left, upleft
    animation: 'none', // slide, fade, pop, popFade, none
    elementId: false, // Image element ID if there is need to attach badge to regular image
    element: false, // DOM element where to change "href" attribute (useful in case of multiple link icon elements)
    dataUrl: false, // Method that will be called for each animation from with data URI parameter
  });

  if (window.shop.cart !== undefined && window.shop.cart.item_count > 0) {
    set(window.shop.cart.item_count);
  }

  function set(value) {
    icon.badge(value);
  }

  function reset() {
    icon.reset();
  }

  return {
    set: set,
    reset: reset
  };
})();

/*
 * Adapted from Currency tools by Caroline Schnapp
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

window.theme = window.theme || {};

theme.CurrencySelectors = (function () {

  function init() {
    Currency.format = shop.currencyFormat;

    var shopCurrency = shop.currency;

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.moneyFormats[shopCurrency].money_with_currency_format = shop.moneyWithCurrencyFormat;
    Currency.moneyFormats[shopCurrency].money_format = shop.moneyFormat;

    /* Default currency */
    var defaultCurrency = shop.defaultCurrency;

    /* Cookie currency */
    var cookieCurrency = Currency.cookie.read();

    /* Fix for customer account pages */
    $('span.money span.money').each(function () {
      $(this).parents('span.money').removeClass('money');
    });

    /* Saving the current price */
    $('span.money').each(function () {
      $(this).attr('data-currency-' + shop.currency, $(this).html());
    });

    // If there's no cookie.
    if (cookieCurrency == null) {
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      }
      else {
        Currency.currentCurrency = defaultCurrency;
      }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if ($('[name=currencies]').length && $('[name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    }
    else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }

    $('[name=currencies]').val(Currency.currentCurrency).change(function () {
      var newCurrency = $(this).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      $('.selected-currency').text(Currency.currentCurrency);
    });

    var original_selectCallback = window.selectCallback;
    var selectCallback = function (variant, selector) {
      original_selectCallback(variant, selector);
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    };

    $(document).on('cart.requestComplete', function (event, cart) {
      Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      $('.selected-currency').text(Currency.currentCurrency);
    });

    $('.selected-currency').text(Currency.currentCurrency);
    $('.currency-picker__wrapper').removeClass('loading');
  }

  return {
    init: init,
  };
})();

theme.CurrencySelectors.init();

theme.videoPlayers = theme.videoPlayers || {};

(function () {
  var selectors = {
    lightboxTriggers: '.video-lightbox__trigger, .rte a[href*="youtube.com"], .rte a[href*="youtu.be"]',
    placeholderImages: '.video-lightbox__trigger img.placeholder, .video-lightbox__trigger .placeholder-svg',
  };

  $(selectors.lightboxTriggers).yu2fvl({
    minPaddingX: 60, // the space you want on *top and bottom when centering the video (value is divided by 2)
    minPaddingY: 60, // the space you want on *left and right when centering the video (value is divided by 2)
    ratio: 16 / 9, // choose the ration you want for your video
    cssClass: "video-lightbox", // set a namespace / global css class
    overlayCssClass: "__overlay", // give a suffix css class for the overlay
    iframeCssClass: "__iframe", // give a suffix css class for the iframe
    closeCssClass: "__close", // give a suffix css class for the close button
    // #TODO: Handle the SVG close button a little more nicely
    closeText: "<svg viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(381 231)\"><path d=\"M-370.7-174.7l-2.3-2.3 46-46 2.3 2.3-46 46\"/><path d=\"M-327-174.7l-46-46 2.3-2.3 46 46-2.3 2.3\"/></g></svg>", // give some text for the close button
    vid: false, // set directly a youtube video id (though using an anchor is cool for SEO !)
    open: false // Open the lightbox immediately from JavaScript. Requires vid to be set to work properly.
  });

  var frameScript = document.createElement('script');
  frameScript.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(frameScript, firstScriptTag);

  $(selectors.lightboxTriggers).on('click', function (evt) {
    var videoID = $(this).data('video-id') || $(this).parent().data('video-id') || false;
    if (!videoID) {
      return;
    }

    var $iframe = $('.video-lightbox__iframe[src*=' + $(this).data('video-id') + ']')
    if (!$iframe.length) {
      return;
    }

    if (theme.videoPlayers[videoID] == undefined) {
      $iframe.attr('id', 'lightbox-video-' + videoID);
      theme.videoPlayers[videoID] = new YT.Player('lightbox-video-' + videoID, {
        events: {
          'onStateChange': onPlayerStateChange
        }
      });
    }
  });

  function onPlayerStateChange(evt) {
    var player = evt.target;
    if (player.getPlayerState !== undefined && player.getPlayerState() == 0) {
      player.seekTo(0);
      var videoID = evt.target.getVideoData().video_id;
      $('#lightbox-video-' + videoID + ' ~ .video-lightbox__close').trigger('click');
    }
  }

  var $placeholders = $(selectors.placeholderImages);

  if (!$placeholders.length) {
    return;
  }

  $placeholders.each(function () {
    var $el = $(this);
    var $trigger = $el.parents('.video-lightbox__trigger');
    var videoID = $el.data('video-id') || $trigger.data('video-id') || theme.utils.getYoutubeId($trigger.href);

    if (!videoID) {
      return;
    }

    var image = new Image();
    image.src = 'https://i.ytimg.com/vi/' + videoID + '/maxresdefault.jpg';
    image.onload = function () {
      if (image.naturalWidth !== undefined && image.naturalWidth < 200 && image.src.indexOf('hqdefault') !== -1) {
        image.src = image.src.replace('sddefault', 'hqdefault').replace('maxresdefault', 'sddefault');
        return;
      }

      if ($el.hasClass('placeholder-svg')) {
        $el.parent('.video-lightbox__placeholder').replaceWith(image);
      } else {
        $el.attr('src', image.src);
      }
    }
  });

})();

window.theme = window.theme || {};

theme.NewsletterPopup = (function () {

  var selectors = {
    el: '#newsletter-popup',
    successMessage: '.form-success',
    barTopParent: '#PageContent',
    barBottomParent: ''
  };

  var defaults = {
    cookieTitle: 'newsletter_popup',
  };

  /**
   * Create a new Newsletter Popup
   *
   * @class      NewsletterPopup
   * @param      {object}  options  The options
   */
  function NewsletterPopup(options) {

    this.el = document.querySelector(selectors.el);

    if (!this.el || this.hasBeenDismised) {
      return;
    }

    this.options = _.defaults(defaults, this.getOptions());

    if (this.options.devMode) {
      this.openPopup();
    } else if (this.checkHasBeenDismissed() || window.location.pathname.indexOf('challenge') > -1) {
      return;
    } else if (this.checkHasBeenViewed()) {
      this.openPopup();
    } else {
      this.bindListener();
    }

  }

  NewsletterPopup.prototype = _.extend(NewsletterPopup.prototype, {

    bindListener: function () {
      var self = this;

      $(document).on('scroll.newsletterModal', function () {

        window.setTimeout(function () {
          self.openPopup();
        }, self.options.delay || 0);

        $(document).off('scroll.newsletterModal');
      });

    },

    /**
     * Get the options set as data attributes on the element
     *
     * @return     {Object}  The options set on the element data attribute.
     */
    getOptions: function () {

      var activationDelay,
        cookieExpiry,
        developerMode,
        popupType,
        options = {};

      activationDelay = this.el.dataset.delay;
      cookieExpiry = this.el.dataset.expiry;
      developerMode = this.el.dataset.developerMode;
      popupType = this.el.dataset.popupType;
      popupPosition = this.el.dataset.popupPosition;

      return {
        delay: activationDelay ? parseInt(activationDelay) : null,
        expiry: cookieExpiry ? parseInt(cookieExpiry) : null,
        devMode: developerMode ? (developerMode == 'true') : null,
        type: popupType ? popupType : null,
        position: popupPosition ? popupPosition : null,
      };

    },

    /**
     * Check if the popup has been viewed
     *
     * @return     {boolean}  Has the popup been viewed before?
     */
    checkHasBeenViewed: function () {
      return ($.cookie(this.options.cookieTitle + '_viewed') == 'true');
    },

    storeViewedState: function () {
      $.cookie(this.options.cookieTitle + '_viewed', 'true', { expires: this.options.expiry, path: '/' });
    },

    checkHasBeenDismissed: function () {
      return ($.cookie(this.options.cookieTitle + '_dismissed') == 'true');
    },

    storeDismissedState: function () {
      $.cookie(this.options.cookieTitle + '_dismissed', 'true', { expires: this.options.expiry, path: '/' });
    },

    /**
     * Check the popup type and open the popup
     */
    openPopup: function () {

      var self = this;

      switch (this.options.type) {
        case 'modal':
          this._openAsModal();
          break;
        case 'bar':
          this._openAsBar(this.options.position);
          break;
        default:
      }

      this.storeViewedState();

      $('.newsletter-popup-close').on('click.newsletterModal', function () {
        self.closePopup();
      });

      if (this.el.querySelector('.form-success')) {
        this.storeDismissedState();
      }

    },

    closePopup: function () {

      var self = this;

      switch (this.options.type) {
        case 'modal':
          this._closeModal();
          break;
        case 'bar':
          this._closeBar();
          break;
        default:
      }

      this.storeDismissedState();

      $('.newsletter-popup-close').on('click.newsletterModal', function () {
        self.closePopup();
      });

    },

    _closeBar: function () {
      this.el.remove();
    },

    /**
     * Open the popup as a modal
     */
    _openAsModal: function () {

      var self = this;

      new theme.Modal(this.el, {
        positionX: 'bottom',
        positionY: 'left',
        featherlightOptions: {
          beforeClose: function () {
            self.storeDismissedState();
          }
        }
      })
      console.log(this.el);
      $(this.el).remove();

    },

    /**
     * Open the popup as a bar at the desired position
     *
     * @param      {string}  position  Currently supports 'top'
     */
    _openAsBar: function (position) {

      var target;

      if (position == 'top') {
        target = document.querySelector(selectors.barTopParent);
        target.insertBefore(this.el, target.firstChild);

        $(this.el).stickybits({
          useFixed: true,
          useStickyClasses: true
        });

        this.el.classList.add('reveal');
      }

    }

  });

  return new NewsletterPopup();

})();

window.theme = window.theme || {};

theme.NewsletterModal = (function () {

  var selectors = {
    modalContainer: '#newsletter-modal',
    successMessage: '.form-success',
  };

  function init() {

    if (!$(selectors.modalContainer).length) {
      return;
    }

    var activationDelay = parseInt($(selectors.modalContainer).attr('data-delay')),
      cookieExpiry = $(selectors.modalContainer).attr('data-expiry'),
      forceModal = JSON.parse($(selectors.modalContainer).attr('data-force-modal')),
      userHasVisited = $.cookie('newsletterModalViewed') || false;

    if (forceModal) {
      activationDelay = 0;
    }

    if (!userHasVisited || forceModal) {
      activateModal(activationDelay, cookieExpiry);
    } else if ($(selectors.successMessage, selectors.modalContainer).length) {
      // Instead of openning modal scroll down to footer
      // openModal();
      console.log('scroll')
      $('html, body').animate({ scrollTop: $(document).height() - 400 }, 'slow');
    }

    function activateModal(activationDelay, cookieExpiry) {

      $(document).on('scroll.newsletterModal', function () {
        window.setTimeout(function () {
          openModal();

          $.cookie('newsletterModalViewed', 'true', { expires: cookieExpiry, path: '/' });
        }, activationDelay);

        $(document).off('scroll.newsletterModal');
      });

    }

    function openModal() {
      $.featherlight($(selectors.modalContainer), {
        variant: 'newsletter-modal',
        otherClose: '.od-modal__close',
      });
    }

  }

  return init();

})();

window.theme = window.theme || {};

theme.StickyAddToCart = (function () {

  var selectors = {
    productDetails: '.product-single__col--details'
  };

  var stickybitsDefaults = {
    useFixed: true
  };

  var defaults = {
    selectors: selectors,
    useStickybits: false,
    stickybits: stickybitsDefaults,
    parent: '#MainContent',
    templateName: 'product-sticky-add-to-cart',
    revealClass: 'show',
    showOnLoad: false
  };

  function StickyAddToCart(options) {

    this.options = _.defaultsDeep(options, defaults);
    this.product = this.options.product;

    if (!this.product) {
      console.error('No product defined');
      return;
    }

    var self = this;

    this._build();
    this._bindReveal();

    this.isHidden = true;
    if (this.options.showOnLoad) {
      this.show();
    }
  }

  StickyAddToCart.prototype = $.extend({}, StickyAddToCart.prototype, {

    _build: function () {
      var self = this;

      var template = theme.utils.getTemplate(this.options.templateName);
      self.$el = $(template);
      $(self.options.parent).prepend(self.$el);

      // Bind StickyBits
      if (self.options.useStickybits) {
        self.$el.stickybits(self.options.stickybits);
      }

      // Bind TinyBind view
      // You can either bind here or in product.js
      // self.view = tinybind.bind(self.$el, { data: self }); 

      return;
    },

    _bindReveal: function () {
      var self = this;

      var waypointElement = $(selectors.productDetails)[0];

      self.waypoint = new Waypoint({
        element: waypointElement,
        handler: function (direction) {
          if (direction == 'down') {
            self.show();
          } else {
            self.hide();
          }
        },
        offset: function () {
          return -this.element.clientHeight + 150;
        }
      });

    },

    show: function () {
      var self = this;
      if (self.isHidden) {
        self.isHidden = false;
        self.$el.addClass(self.options.revealClass);
      }

    },

    hide: function () {
      var self = this;
      if (!self.isHidden) {
        self.isHidden = true;
        self.$el.removeClass(self.options.revealClass);
      }
    },

    destroy: function () {
      var self = this;
      self.$el.remove();
    }

  });

  return StickyAddToCart;
})();
window.theme = window.theme || {};

// theme.Video = (function() {

//   var selectors = {
//     videoContainer: '.video',
//   };

//   var sources = {
//     vimeo: 'https://player.vimeo.com/api/player.js',
//     youtube: 'https://www.youtube.com/iframe_api'
//   };

//   var methods = {
//     vimeo: function(elem) {
//       var player = new Vimeo.Player(elem);
//       player.play();
//     },
//     youtube: function(elem) {
//       if((typeof YT !== "undefined") && YT && YT.Player){
//         var player = new YT.Player(elem, {
//          events: {
//           'onReady': onPlayerReady
//           }
//         });
//       }

//       function onPlayerReady(event) {
//         event.target.playVideo();
//       }
//     }
//   };

//   var cache = {
//     videoTypes: [],
//     videoTypesLoaded: []
//   };

//   function init() {
//     if (!$(selectors.videoContainer).length) {
//       return;
//     }

//     _loadPlayerAPIs();
//     _bindEventListeners();
//   };

//   function _loadPlayerAPIs() {
//     var videoTypes = [],
//         videoType,
//         $videoContainer;

//     for (i = 0; i < $(selectors.videoContainer).length; i++) {
//       $videoContainer = $(selectors.videoContainer)[i];
//       videoType = $($videoContainer).attr('data-video-type');

//       if (cache.videoTypes.indexOf(videoType) === -1) {
//         cache.videoTypes.push(videoType);
//       }
//     }

//     for (i = 0; i < cache.videoTypes.length; i++) {
//       videoType = cache.videoTypes[i];
//       _includePlayer(videoType);
//     }
//   }

//   function _includePlayer(type) {
//     var source = sources[type];

//     if (source == undefined ) {
//       console.error('Video type ' + type + ' is not supported');
//       return;
//     }

//     if ($('script[src="' + source + '"]').length) {
//       cache.videoTypesLoaded.push(type);
//       return;
//     }

//     loadJS(source, function() {
//       cache.videoTypesLoaded.push(type);

//       if (_checkAdditionalSources()) {
//         _autoPlay();
//       }
//     });
//   }

//   function _checkAdditionalSources() {
//     for (i = 0; i < cache.videoTypes.length; i++) {
//       var type = cache.videoTypes[i];
//       if (cache.videoTypesLoaded.indexOf(type) === -1) {
//         return false;
//       }
//     }
//     return true;
//   }

//   function _autoPlay() {
//     for (var i = $(selectors.videoContainer).length - 1; i >= 0; i--) {
//       var $videoContainer = $(selectors.videoContainer)[i],
//           videoIsVisible  = $($videoContainer).is(':visible'),
//           videoType       = $($videoContainer).attr('data-video-type'),
//           videoAutoPlay   = $($videoContainer).attr('data-video-autoplay');
//           videoVisible   = $($videoContainer).attr('data-video-visible');

//       if (videoIsVisible && videoAutoPlay == 'true' && videoVisible == 'true') {
//          methods[videoType]($($videoContainer).find('iframe')[0]);
//       }
//     }
//   }

//   function _bindEventListeners() {
//     $(selectors.videoContainer).on('click', _revealVideo);
//   }

//   function _revealVideo() {
//     var videoType = $(this).attr('data-video-type'),
//         videoId   = $(this).attr('data-video-id');

//     methods[videoType]($(this).find('iframe')[0]);

//     $(this).attr('data-video-visible','true');
//   }

//   return {
//     init: init
//   };

// })();

// theme.Video.init();

var originalOnYouTubePlayerAPIReady = _.noop;

if (typeof onYouTubePlayerAPIReady == 'function') {
  originalOnYouTubePlayerAPIReady = onYouTubePlayerAPIReady;
}

window.onYouTubePlayerAPIReady = function () {
  var youTubeService = _.find(theme.videoServiceAPIs, { 'name': 'youtube' });
  youTubeService.runOnReadyQueue();

  originalOnYouTubePlayerAPIReady();

};

theme.videoServiceAPIs = (function () {

  function PlayerServiceAPI(data) {
    _.extend(this, data);
    this._isloaded = false;
    this._isloading = false;
    this._onReadyQueue = [];
  }

  PlayerServiceAPI.prototype = _.extend(PlayerServiceAPI.prototype, {

    load: function (callback) {

      var self = this;

      if (this._isloaded || this._checkIsLoaded()) {
        callback();
        return;
      }

      this._onReadyQueue.push(callback);

      if (this._isloading) {
        return;
      }

      loadJS(this.url, function () {

        if (self.name == 'vimeo') {
          self.runOnReadyQueue();
        }

      });

    },

    runOnReadyQueue: function () {

      this._isloaded = true;

      while (this._onReadyQueue.length) {
        this._onReadyQueue.shift().call();
      }

    }

  });

  return [

    new PlayerServiceAPI({
      name: 'youtube',
      url: 'https://www.youtube.com/iframe_api',
      newPlayer: function (data) {

        return new YT.Player(data.node.id, {
          videoId: data.videoID,
          playerVars: {
            modestbranding: 1,
            rel: 0,
            iv_load_policy: 3,
            showinfo: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
          },
          events: {
            'onReady': data.onPlayerReady || _.noop,
            'onStateChange': data.onPlayerStateChange || _.noop,
          }
        });

      },
      _checkIsLoaded: function () {
        return (typeof YT != 'undefined' && YT && YT.loaded);
      },
      isPlaying: function (event) {
        return (event.data == YT.PlayerState.PLAYING);
      },
      play: function (player) {
        player.playVideo();
      },
      pause: function (player) {
        player.pauseVideo();
      }
    }),

    // TODO
    // new PlayerServiceAPI({
    //   name: 'vimeo',
    //   url: 'https://player.vimeo.com/api/player.js',
    //   newPlayer: function(data) {
    //     var player = new Vimeo.Player(data.node, {
    //       // TODO
    //     });
    //     player.on('play', function() {
    //       if (data.onPlayerStateChange) {
    //         data.onPlayerStateChange();
    //       }
    //     });
    //     if (data.onPlayerReady) {
    //       data.onPlayerReady();
    //     }
    //   },
    //   _checkIsLoaded: function() {
    //     var scriptElement;
    //     scriptElement = document.querySelectorAll('script[src="' + this.url + '"]');
    //     if (scriptElement.length > 0) {
    //       return true;
    //     }
    //     return false;
    //   },
    //   play: function(player) {
    //     player.playVideo();
    //   },
    //   pause: function(player) {
    //     player.pauseVideo();
    //   }
    // }),

  ];

})();

theme.Video = (function () {

  var SELECTORS = {
    placeholder: '.video__placeholder'
  };

  function Video(container) {

    this.container = container;
    this.videoID = container.dataset.videoId;
    this.autoPlay = (container.dataset.videoAutoplay == 'true');
    this.placeholder = this.container.querySelector(SELECTORS.placeholder);

    if (this.container.dataset.placeholderOverlay) {
      this.additionalOverlay = document.querySelector(this.container.dataset.placeholderOverlay);
      // this.additionalOverlay.classList.add('video-is-paused');
    }

    var playerServiceName = container.dataset.videoType;

    this._loadPlayerServiceAPI(playerServiceName);
  }

  Video.prototype = _.extend(Video.prototype, {

    _loadPlayerServiceAPI: function (playerServiceName) {

      var self = this;

      var type,
        source;

      this.playerService = _.find(theme.videoServiceAPIs, { 'name': playerServiceName });

      if (!this.playerService) {
        console.error(new Error('No service found'));
        return;
      }

      this.playerService.load(this._onServiceLoad.bind(this));

    },

    _onServiceLoad: function () {

      if (this.autoPlay) {

        this._bindWaypoint();

      } else {

        if (this.placeholder) {
          this._bindPlaceholder();
        } else {
          this._createPlayer();
        }

      }

    },

    _bindWaypoint: function () {
      var self = this;

      new Waypoint({
        element: this.container,
        offset: '100%',
        handler: function () {
          console.info('Waypoint triggered');
          self._createPlayer(self.play.bind(self));
          this.destroy();
        },
      });

    },

    _bindPlaceholder: function () {

      var self = this;

      this.placeholder.addEventListener('click', function () {
        self._addPlaceholderLoadingState();
        self._createPlayer(self.play.bind(self));
      });

    },

    revealVideo: function () {
      this.container.dataset.videoVisible = true;
      this._removePlaceholderLoadingState();
    },

    _createPlayer: function (onPlayerReady) {

      var videoNode = document.getElementById('video-' + this.videoID);

      this.player = this.playerService.newPlayer({
        node: videoNode,
        videoID: this.videoID,
        onPlayerReady: onPlayerReady || _.noop,
        onPlayerStateChange: this._onStateChange.bind(this),
      });

    },

    _onStateChange: function (event) {

      if (this.playerService.isPlaying(event)) {

        this.revealVideo();

        if (this.additionalOverlay) {
          this.additionalOverlay.classList.add('video-is-playing');
          this.additionalOverlay.classList.remove('video-is-paused');
        }

      } else {

        if (this.additionalOverlay) {
          this.additionalOverlay.classList.add('video-is-paused');
          this.additionalOverlay.classList.remove('video-is-playing');
        }

      }

    },

    _addPlaceholderLoadingState: function () {
      this.container.classList.add('loading');
    },

    _removePlaceholderLoadingState: function () {
      this.container.classList.remove('loading');
    },

    play: function () {

      try {
        this.playerService.play(this.player);
      } catch (e) {
        console.error(e);
      }

    }

  });

  return Video;

})();

window.theme = window.theme || {};

theme.ResponsiveNavList = (function () {

  var selectors = {

  };

  var defaults = {
    breakPoint: 900,
    overflowItemHtml: '<a href="#">More</a>'
  };

  function ResponsiveNavList(el, options) {

    var settings,
      lastDocWidth;

    settings = _.defaults(options, defaults);

    lastDocWidth = $(document).width();


    var $list = $(el);
    var container = $list.parent();
    var overflowItem = $('<li class="dropdown hide" style="order:999">' + settings.overflowItemHtml + '<ul class="dropdown-menu"></ul></li>').appendTo($list);
    var overflowList = $(overflowItem).find('ul.dropdown-menu');

    var thisWidth = $list[0].scrollWidth;
    var maxWidth = $(container).width();

    $(overflowItem).not(overflowList).on('click', function () {
      $(this).toggleClass('active');
    });

    function reset() {
      var child = $(overflowList).children();

      //////////

      var count = child.length;
      if (count > 0) {
        for (var i = 0; i < count; i++) {
          $(child[i]).insertBefore($list.children(':last-child'));
        }
      }
      $(overflowItem).addClass('hide');
    }

    function grow() {
      var overflowWidth = $(overflowItem).width();
      var child = $(overflowList).children();

      //////////

      var count = child.length;

      if (count > 0) {
        for (var i = 0; i < count; i++) {
          // move the first dropdown item to end of list
          $(child[i]).insertBefore($list.children(':last-child'));
          thisWidth = $list[0].scrollWidth;
          if ((i == count - 1 && thisWidth - overflowWidth > maxWidth) || (i != count - 1 && thisWidth > maxWidth)) {
            $(child[i]).prependTo(overflowList);
            break;
          }
        }
      }

      // Hide the overflow item if it has no children
      if ($(overflowList).children().length == 0) {
        $(overflowItem).addClass('hide');
      }

      return;
    }

    function shrink() {
      var child = $list.children(':not(:last-child)');

      // Do not hide featured items
      child = $(child).filter(function () {
        return $(this).hasClass('featured') ? false : true;
      });

      var count = child.length;
      if (count < 1) return;

      // show the overflow link in case it's been hidden
      $(overflowItem).removeClass('hide');

      $($(container).parent().parent()).css('overflow', 'hidden');
      maxWidth = $(container).width();

      for (var i = count - 1; i >= 0; i--) {

        // move the last item to dropdown
        $(child[i]).prependTo(overflowList);

        // recalc width
        thisWidth = $list.width();
        if (thisWidth < maxWidth) break;
      }

      $($(container).parent().parent()).css('overflow', 'visible');
    }

    function refresh() {
      thisWidth = $list.width();
      maxWidth = $(container).width() - ($(container).find('.navbar-header').width() || 0);
      var docWidth = $(document).width();

      if ($(window).width() < settings.breakPoint) {
        reset();
      } else if (thisWidth > maxWidth) {
        shrink();
      } else if (0 < (docWidth - lastDocWidth)) {
        grow();
      }
      lastDocWidth = docWidth;
    }



    $(window).resize(_.throttle(refresh, 250)).trigger('resize');
  };

  return ResponsiveNavList;

})();
window.theme = window.theme || {};

theme.SizingCharts = (function () {

  var modalOpen = false;

  var selectors = {
    pageContainer: '.template-page-sizing-charts',
    productPageContainer: '.template-product',
    unitButtonSingle: '.unit-button.unit-button--single',
    unitButtonAll: '.unit-button.unit-button--all',
    unitTableContainer: '.unit-table-container',
    navigationMobile: '.navigation-mobile',
    menuContainer: '.sizing-chart-nav__container',
    modalClose: '.od-modal-close',
    modalBackdrop: '.sizing-chart__modal-backdrop',
    modalContainer: '.sizing-chart__modal-container',
    modalLink: '.sizing-chart__modal-link',
    cmActive: 'cm-active',
    inActive: 'in-active',

  };


  function init() {
    const isSizingChartPage = $(selectors.pageContainer).length > 0;
    const isProductPage = $(selectors.productPageContainer).length > 0;
    if (!(isProductPage || isSizingChartPage)) return

    $(selectors.unitButtonSingle).on('click', switchUnit)
    $(selectors.unitButtonAll).on('click', switchAll)
    $(selectors.navigationMobile).on('click', toggleMobileMenu);
    $(selectors.modalClose).on('click', closeModal);
    $(selectors.modalBackdrop).on('click', closeModal);
    $(selectors.modalLink).on('click', openModal);


    function switchUnit() {
      const active = $(this).data('active')
      if (active == 'cm') {
        $(this).data('active', 'in')
        $(this).removeClass(selectors.cmActive)
        $(this).addClass(selectors.inActive)
        $(this).prev().removeClass(selectors.cmActive)
        $(this).prev().addClass(selectors.inActive)
      } else {
        $(this).data('active', 'cm')
        $(this).removeClass(selectors.inActive)
        $(this).addClass(selectors.cmActive)
        $(this).prev().removeClass(selectors.inActive)
        $(this).prev().addClass(selectors.cmActive)
      }
    }

    function switchAll() {
      const active = $(this).data('active')
      if (active == 'cm') {
        $(this).data('active', 'in')
        $(this).removeClass(selectors.cmActive)
        $(this).addClass(selectors.inActive)
      } else {
        $(this).data('active', 'cm')
        $(this).removeClass(selectors.inActive)
        $(this).addClass(selectors.cmActive)
      }
      $(selectors.unitButtonSingle).each(function (index) {
        if ($(this).data('active') == active) {
          $(this).delay(100 * index).queue(function () {
            $(this).click().dequeue();
          })
        }
      })
    }

    function toggleMobileMenu() {
      $(this).toggleClass('active');
      $(this).hasClass('active') ? $(selectors.menuContainer).slideDown() : $(selectors.menuContainer).slideUp()
    }

    function toggleModal() {
      modalOpen ? closeModal() : openModal()
    }

    function openModal() {
      var target = $(this).data('modal');
      $(selectors.modalContainer + '[data-modal=' + target + ']').addClass('open');
      modalOpen = false;
      $('body').addClass('popup-open');
    }

    function closeModal() {
      $('body').removeClass('popup-open');
      $(selectors.modalContainer).removeClass('open');
      modalOpen = true;
    }


  }

  return init();


})();

window.theme = window.theme || {};

theme.ProductTabs = (function () {

  const activeClass = 'active';

  var selectors = {
    pageContainer: '.template-page-sizing-charts',
    navigationItem: '.product-tabs__navigation-item',
    tabContent: '.product-tab',

    active: '.' + activeClass
  };


  function init() {

    // if(! $(selectors.pageContainer).length > 0) return

    $(selectors.navigationItem).on('click', switchTab)

    function switchTab() {
      var activeNavElement = $(selectors.navigationItem + selectors.active)
      var activeContentElement = $(selectors.tabContent + selectors.active)

      const activeIndex = activeNavElement.data('tab-index');
      const currentIndex = $(this).data('tab-index')
      if (activeIndex != currentIndex) {
        activeNavElement.removeClass(activeClass)
        $(this).addClass(activeClass)

        activeContentElement.removeClass(activeClass)
        $(selectors.tabContent + '[data-tab-index=' + currentIndex + ']').addClass(activeClass);
      }
    }

  }

  return init();


})();

window.theme = window.theme || {};

theme.StringingPopup = (function () {

  var config = {
    openClass: 'open',
    isOpen: false,
    activeTabSuffix: '-active',
    activeTab: 'recommended',
    stringProductsTag: 'custom-strings'
  };

  var selectors = {
    mainProductForm: '.main-product-form',
    productPageContainer: '.product-single',
    container: '.stringing-popup__container',
    backdrop: '.stringing-popup__backdrop',
    popup: '.stringing-popup',
    addStringingButton: '.product-single__add-stringing',
    changeStringingButton: '.product-single__change-stringing',
    removeStringingButton: '.product-single__remove-stringing',
    closeButton: '.stringing-popup__close-button',
    tabButton: '.stringing-popup__tab',
    tabsContent: '.stringing-popup__tabs-content',
    stringingMessage: '.product-single__stringing-message',
    quantity: '.product-form__quantity',
    submitButton: '.product-form__cart-submit:not(.cart-submit-jp)',
    yourStringingContainer: '.product-single__your-stringing',
    typeString: '.product-single__your-stringing .type-string',
    typePrice: '.product-single__your-stringing .type-price',
    typeCrosses: '.product-single__your-stringing .type-crosses',
    typeMains: '.product-single__your-stringing .type-mains',
    typeStencil: '.product-single__your-stringing .type-stencil',
    typeCrossesContainer: '.product-single__stringing-type--crosses',
    typeMainsContainer: '.product-single__stringing-type--mains',
    productPrice: '.product-single__details-inner [data-product-price]'
  };

  function StringingPopup() {

    this.$container = $(selectors.container);
    this.$productPageContainer = $(selectors.productPageContainer)
    this.recommendedSelected = true;
    this.stringingAdded = false;

    if (!this.$container.length && !this.$container.length) {
      return;
    }

    var barcode = '';
    var sku = '';

    this.custom = {
      product: null,
      variant: null,
      mains: null,
      crosses: null,
      stencil: false,
      disabled: true,
      price: 0
    }

    this.recommended = {
      product: null,
      variant: null,
      mains: null,
      crosses: null,
      stencil: false,
      price: 0
    }

    var self = this;

    this.data = {
      products: {}
    };

    this.methods = {
      openPopup: this._openPopup.bind(this),
      closePopup: this._closePopup.bind(this),
      changeTab: this._changeTab.bind(this),
      setStencil: this._setStencil.bind(this),
      setActiveStringing: this._setActiveStringing.bind(this),
      addCustomStringing: this._addCustomStringing.bind(this),
      addCustomStringingToCart: this._addCustomStringingToCart.bind(this),
      addRecommendedStringing: this._addRecommendedStringing.bind(this),
      addRecommendedStringingToCart: this._addRecommendedStringingToCart.bind(this),
      addStringingToCart: this._addStringingToCart.bind(this),
      addOnlyStringingToCart: this._addOnlyStringingToCart.bind(this),
      removeStringing: this._removeStringing.bind(this)
    };

    $(selectors.addStringingButton).on('click', this.methods.openPopup);
    $(selectors.changeStringingButton).on('click', this.methods.openPopup)
    $(selectors.backdrop).on('click', this.methods.closePopup)
    $(selectors.tabButton).on('click', this.methods.changeTab);
    $(selectors.closeButton).on('click', this.methods.closePopup);
    $(selectors.submitButton).on('click', this.methods.addStringingToCart);
    $(selectors.removeStringingButton).on('click', this.methods.removeStringing);

    // Initialize with recommended product availability check
    this._initializeRecommendedProductCheck();

    this._getStringingProducts();

  }

  StringingPopup.prototype = _.extend({}, StringingPopup.prototype, {

    _bindView: function () {
      var self = this;
      tinybind.bind(this.$container, {
        data: self.data,
        methods: self.methods,
        custom: self.custom,
        recommended: self.recommended
      });
    },

    _changeSku: function (sku) {
      this.sku = sku
    },

    _uploadProductPrice: function () {
      var type = this.recommendedSelected ? 'recommended' : 'custom';
      var prodOnlyPrice = parseInt($(selectors.productPrice).data('product-only-price'));
      var totalPrice = prodOnlyPrice;
      if (this.stringingAdded) {
        totalPrice += this[type].price
      }
      $(selectors.productPrice).text(Currency.formatMoney(totalPrice));
    },

    _updateUserMessage: function () {
      var type = this.recommendedSelected ? 'recommended' : 'custom';

      $(selectors.typeString).text(this[type].product)
      $(selectors.typePrice).text(Currency.formatMoney(this[type].price, shop.moneyFormat))
      $(selectors.typeCrossesContainer).removeClass('hidden')
      $(selectors.typeMainsContainer).removeClass('hidden')
      $(selectors.typeMains).text(this[type].mains)
      $(selectors.typeCrosses).text(this[type].crosses)
      $(selectors.typeStencil).text(this[type].stencil)
      this[type].stencil ? $(selectors.typeStencil).text('Yes') : $(selectors.typeStencil).text('No');
    },

    _removeStringing: function () {
      this.recommendedSelected = true;
      this.stringingAdded = false;

      if (!$(selectors.yourStringingContainer).hasClass('hidden')) {
        $(selectors.yourStringingContainer).addClass('hidden');
      }

      if ($(selectors.addStringingButton).hasClass('hidden')) {
        $(selectors.addStringingButton).removeClass('hidden');
      }

      this._uploadProductPrice();
    },

    _addStringingToRacketJp: function () {
      this._updateUserMessage();

      if ($(selectors.yourStringingContainer).hasClass('hidden')) {
        $(selectors.yourStringingContainer).removeClass('hidden');
      }

      if (!$(selectors.addStringingButton).hasClass('hidden')) {
        $(selectors.addStringingButton).addClass('hidden');
      }

      this.stringingAdded = true;
      this._closePopup();
    },

    _addStringingToRacket: function () {
      this._updateUserMessage();

      if ($(selectors.yourStringingContainer).hasClass('hidden')) {
        $(selectors.yourStringingContainer).removeClass('hidden');
      }

      if (!$(selectors.addStringingButton).hasClass('hidden')) {
        $(selectors.addStringingButton).addClass('hidden');
      }

      this.stringingAdded = true;
      this._uploadProductPrice();
      this._closePopup();
    },

    _setStencil: function () {
      if ($(event.target).is(":checked")) {
        this.custom.stencil = true
      } else {
        this.custom.stencil = false
      }
    },

    _addCustomStringing: function (e) {
      this.recommendedSelected = false;

      this._addStringingToRacket();
      if(e.target.dataset.cracketAction) {
        setTimeout(() => {
        console.log($(e.target));
        $(selectors.submitButton)[0].click();
        }, 300);
      }
    },

    _addRecommendedStringing: function (e) {
      // Check if recommended product is available before proceeding
      var recommendedAvailable = this.$container.data('recommended-available');
      if (!recommendedAvailable) {
        return; // Don't proceed if recommended product is not available
      }
      
      this.recommendedSelected = true;
      this._addStringingToRacket();
      if(e.target.dataset.cracketAction) {
        // travel to closet product form
        setTimeout(() => {
        console.log($(e.target));
        $(selectors.submitButton)[0].click();
        }, 300);
      }
    },

    _addCustomStringingToCart: function (e) {
      this.recommendedSelected = false;
      this._addOnlyStringingToCart(this.custom.variant);
    },

    _addRecommendedStringingToCart: function (e) {
      // Check if recommended product is available before proceeding
      var recommendedAvailable = this.$container.data('recommended-available');
      if (!recommendedAvailable) {
        return; // Don't proceed if recommended product is not available
      }
      
      this.recommendedSelected = true;
      this._addOnlyStringingToCart(this.recommended.variant);
      if(e.target.dataset.cracketAction) {
      }
    },

    _addStringingToCart: function () {
      var self = this;
      var quantity = $(selectors.quantity).val();
      if (self.stringingAdded) {
        var product;
        var properties;
        if (self.recommendedSelected) {
          // Check if recommended product is available
          var recommendedAvailable = this.$container.data('recommended-available');
          if (!recommendedAvailable || !this.recommended.variant) {
            return; // Don't proceed if recommended product is not available
          }
          
          product = this.recommended.variant;
          properties = {
            "tension_crosses": this.recommended.crosses,
            "tension_mains": this.recommended.mains,
            "w_stencil": this.recommended.stencil,
            "product": this.sku
          }
        } else {
          product = this.custom.variant;
          properties = {
            "tension_crosses": this.custom.crosses,
            "tension_mains": this.custom.mains,
            "w_stencil": this.custom.stencil,
            "product": this.sku
          }
        }

        //console.log('_addStringingToCart', properties);
        CartJS.addItem(product, quantity, properties);
      }
    },

    _addOnlyStringingToCart: function () {
      var self = this;
      var quantity = 1; // Set the quantity as needed

      if (quantity > 0) {
        var product;
        var properties;
        if (self.recommendedSelected) {
          // Check if recommended product is available
          var recommendedAvailable = this.$container.data('recommended-available');
          if (!recommendedAvailable || !this.recommended.variant) {
            return; // Don't proceed if recommended product is not available
          }
          
          product = this.recommended.variant;
          properties = {
            "tension_crosses": this.recommended.crosses,
            "tension_mains": this.recommended.mains,
            "w_stencil": this.recommended.stencil,
            "product": this.sku
          }
        } else {
          product = this.custom.variant;
          properties = {
            "tension_crosses": this.custom.crosses,
            "tension_mains": this.custom.mains,
            "w_stencil": this.custom.stencil,
            "product": this.sku
          }
        }


       // console.log('_addOnlyStringingToCart', properties);

        // Remove existing stringing items from the cart
        CartJS.cart.items.forEach(function(cartItem) {
          var itemProperties = cartItem.properties;
          if (itemProperties && itemProperties.product === self.sku) {
            CartJS.removeItemById(cartItem.id);
          }
        });

        // Add the new stringing item to the cart
        CartJS.addItem(product, quantity, properties);

        self._addStringingToRacketJp();
      }
    },

    _setRecommended: function () {
      var self = this
      var prodHandle = this.$container.data('recommended');
      var recommendedAvailable = this.$container.data('recommended-available');
      var recommendedExists = this.$container.data('recommended-exists');
      
      // Only set recommended product if it exists
      if (prodHandle) {
        this.data.products.forEach(function (product) {
          if (product.handle == prodHandle) {
            self.recommended.product = product.title;
            if (recommendedExists) {
              self.recommended.price = product.price;
              self.recommended.variant = product.variants[0].id;
            } else {
              self.recommended.price = product.price; // Optionally show price even if out of stock
              self.recommended.variant = null;
            }
          }
        });
        this.recommended.crosses = this.$container.find('[data-crosses]').data('crosses');
        this.recommended.mains = this.$container.find('[data-mains]').data('mains');
        this.recommended.stencil = this.$container.find('[data-stencil]').data('stencil');
      } else {
        // If recommended product does not exist at all
        this.recommended.price = 0;
        this.recommended.variant = null;
        this.recommended.product = null;
        this.recommended.crosses = null;
        this.recommended.mains = null;
        this.recommended.stencil = false;
      }
    },

    _setActiveStringing: function () {
      var self = this;
      var el = event.target;
    
      this.custom[el.name] = el.value;
    
      if (el.name === 'product') {
        // 1) JSON list (accentuate path)
        var matched = false;
        this.data.products.forEach(function (product) {
          if (String(product.id) === String(el.value)) {
            self.custom.price = product.price;
            self.custom.variant = product.variants[0].id;
            self.custom.product = product.title;
            matched = true;
          }
        });
    
        // 2) Fallback for NON-accentuate liquid (option contains variant + price)
        if (!matched) {
          var opt = el.options[el.selectedIndex];
          self.custom.product = opt.dataset.title || opt.textContent;
          self.custom.variant = opt.dataset.variantId || el.value;
          self.custom.price = parseInt(opt.dataset.price, 10) || 0;
        }
      }
    
      var mainsFieldPresent = document.querySelector('.string-option-box__select[name="mains"]') !== null;
      var crossesFieldPresent = document.querySelector('.string-option-box__select[name="crosses"]') !== null;
    
      if (this.custom.product && mainsFieldPresent && crossesFieldPresent) {
        this.custom.disabled = !(this.custom.mains && this.custom.crosses);
      } else if (!mainsFieldPresent && !crossesFieldPresent && this.custom.product) {
        this.custom.disabled = false;
      } else {
        this.custom.disabled = true;
      }
    },
    
    _initializeRecommendedProductCheck: function () {
      var self = this;
      var recommendedExists = this.$container.data('recommended-exists');
      var recommendedAvailable = this.$container.data('recommended-available');
      var defaultTab = this.$container.data('default-tab');
      
      // Set initial active tab based on recommended product availability
      if (defaultTab === 'own') {
        config.activeTab = 'own';
        this.recommendedSelected = false;
        
        // Update tab classes
        $(selectors.tabsContent).removeClass('recommended-active');
        $(selectors.tabsContent).addClass('own-active');
        $(selectors.tabButton).removeClass('active');
        $(selectors.tabButton + '[data-tab="own"]').addClass('active');
      }
    },

    _getStringingProducts: function () {
      var self = this;
      $.get('/collections/all/' + config.stringProductsTag + '?view=json', function (data) {
        self.data.products = jQuery.parseJSON(data);
        self._bindView();
        self._setRecommended();
      })
    },

    _openPopup: function () {
      if (!config.isOpen) {
        $(selectors.container).addClass(config.openClass);
        $('body').addClass('popup-open');
        $('.btn-stringing-pop-up').hide();
        $('.product-form__cart-submit').removeClass('hide');
        config.isOpen = true;
      }
    },

    _closePopup: function () {
      if (config.isOpen) {
        $(selectors.container).removeClass(config.openClass);
        $('body').removeClass('popup-open');
        config.isOpen = false;
      }
    },

    _changeTab: function () {
      var button = event.target.dataset.tab;
      if (config.activeTab != button) {
        $(selectors.tabsContent).removeClass(config.activeTab + config.activeTabSuffix);
        $(selectors.tabsContent).addClass(button + config.activeTabSuffix);
        $(selectors.tabButton).removeClass('active');
        $(event.target).addClass('active');
        config.activeTab = button;
      }
    }
  });

  return new StringingPopup();
})();

window.theme = window.theme || {};

theme.StringingDropdown = (function () {

  var config = {
    stringProductsTag: 'custom-strings'
  };

  var selectors = {
    container: '.stringing-dropdown',
    choice: '[data-stringing-choice]',
    panels: '.stringing-dropdown__panel',
    recommendedPanel: '[data-panel="recommended"]',
    customPanel: '[data-panel="custom"]',
    framePanel: '[data-panel="frame-only"]',
    productSelect: '[data-stringing-product]',
    mainsSelect: '[data-stringing-mains]',
    crossesSelect: '[data-stringing-crosses]',
    stencilCheckbox: '[data-stringing-stencil]',
    summaryContainer: '.stringing-dropdown__summary',
    summary: '[data-stringing-summary]',
    summaryString: '.stringing-dropdown__summary .type-string',
    summaryPrice: '.stringing-dropdown__summary .type-price',
    summaryCrosses: '.stringing-dropdown__summary .type-crosses',
    summaryMains: '.stringing-dropdown__summary .type-mains',
    summaryStencil: '.stringing-dropdown__summary .type-stencil',
    recommendedPrice: '[data-recommended-price]',
    customPrice: '[data-custom-price]',
    addToCart: '.product-form__cart-submit',
    addToCartText: '[data-add-to-cart-text]',
    quantity: '.product-form__quantity',
    productPrice: '.product-single__details-inner [data-product-price]'
  };

  function StringingDropdown() {
    this.$container = $(selectors.container);
    if (!this.$container.length) {
      return;
    }

    this.$choice = this.$container.find(selectors.choice);
    this.$panels = this.$container.find(selectors.panels);
    this.$addToCart = $(selectors.addToCart);
    this.$addToCartText = this.$addToCart.find(selectors.addToCartText);
    this.$summaryContainer = this.$container.find(selectors.summaryContainer);
    this.$summary = this.$container.find(selectors.summary);
    this.$summaryString = this.$container.find(selectors.summaryString);
    this.$summaryPrice = this.$container.find(selectors.summaryPrice);
    this.$summaryCrosses = this.$container.find(selectors.summaryCrosses);
    this.$summaryMains = this.$container.find(selectors.summaryMains);
    this.$summaryStencil = this.$container.find(selectors.summaryStencil);

    this.selectionPrompt = this.$container.data('selection-text') || 'Make a Selection';
    this.defaultButtonText = this._getButtonText();
    this.variantAvailable = !this.$addToCart.prop('disabled');

    this.recommendedSelected = false;
    this.stringingAdded = false;
    this.selectionComplete = false;
    this.sku = '';

    this.custom = {
      product: null,
      variant: null,
      mains: null,
      crosses: null,
      stencil: false,
      price: 0
    };

    this.recommended = {
      product: null,
      variant: null,
      mains: null,
      crosses: null,
      stencil: false,
      price: 0
    };

    this.data = {
      products: []
    };

    // Force initial state to require an explicit selection
    this.$choice.val('');
    this._bindEvents();
    this._disableAddToCart(true);
    this._updateSummary(this._promptText(), false);
    this._getStringingProducts();
    this._setRecommended();
    this._attachVariantChange();
  }

  StringingDropdown.prototype = _.extend({}, StringingDropdown.prototype, {
    _bindEvents: function () {
      var self = this;
      this.$choice.on('change', this._onChoiceChange.bind(this));
      this.$container.on('change', selectors.productSelect, this._onCustomChange.bind(this));
      this.$container.on('change', selectors.mainsSelect, this._onCustomChange.bind(this));
      this.$container.on('change', selectors.crossesSelect, this._onCustomChange.bind(this));
      this.$container.on('change', selectors.stencilCheckbox, this._onStencilChange.bind(this));
      this.$addToCart.on('click', this._handleAddToCart.bind(this));
    },

    _attachVariantChange: function () {
      var self = this;
      document.addEventListener('variant:change', function (evt) {
        var variant = evt.detail ? evt.detail.variant : null;
        self._changeSku(variant && variant.sku);
        self.variantAvailable = variant ? !!variant.available : false;
        self._resetSelection();
        if (self.variantAvailable) {
          self._disableAddToCart(true);
        }
      });
    },

    _changeSku: function (sku) {
      this.sku = sku;
    },

    _onChoiceChange: function (evt) {
      var value = $(evt.target).val();
      this.selectionType = value;
      this.stringingAdded = false;
      this.selectionComplete = false;

      this.$panels.addClass('hidden');

      if (value === 'recommended') {
        this.$container.find(selectors.recommendedPanel).removeClass('hidden');
        this.recommendedSelected = true;
        this.stringingAdded = true;

        if (this.recommended.variant && this.$container.data('recommended-available')) {
          this.selectionComplete = true;
          this._renderSummary('recommended');
          this._updateSummary(true);
          this._enableAddToCart();
        } else {
          this._updateSummary(false);
          this._disableAddToCart(true);
        }
      } else if (value === 'custom') {
        this.$container.find(selectors.customPanel).removeClass('hidden');
        this.recommendedSelected = false;
        this._updateSummary(false);
        this._evaluateCustomReady();
      } else if (value === 'frame-only') {
        this.recommendedSelected = false;
        this.stringingAdded = false;
        this.selectionComplete = true;
        this.$container.find(selectors.framePanel).removeClass('hidden');
        this._clearSummaryFields();
        this._updateSummary(false);
        this._enableAddToCart();
      } else {
        this._updateSummary(false);
        this._disableAddToCart(true);
      }
    },

    _onCustomChange: function (evt) {
      var target = evt.target;

      if ($(target).is(selectors.productSelect)) {
        var option = $(target).find('option:selected');
        this.custom.product = option.data('title') || option.text();
        this.custom.price = parseInt(option.data('price')) || 0;
        this.custom.variant = option.val();
        this._updateCustomPrice();
      }

      if ($(target).is(selectors.mainsSelect)) {
        this.custom.mains = $(target).val();
      }

      if ($(target).is(selectors.crossesSelect)) {
        this.custom.crosses = $(target).val();
      }

      this._evaluateCustomReady();
    },

    _onStencilChange: function (evt) {
      this.custom.stencil = $(evt.target).is(':checked');
      if (this.selectionType === 'custom' && this.selectionComplete) {
        this._renderSummary('custom');
        this._updateSummary(true);
      }
    },

    _evaluateCustomReady: function () {
      var mainsFieldPresent = this.$container.find(selectors.mainsSelect).length > 0;
      var crossesFieldPresent = this.$container.find(selectors.crossesSelect).length > 0;
      var productSelected = !!this.custom.variant;
      var mainsSelected = !!this.custom.mains;
      var crossesSelected = !!this.custom.crosses;

      this.selectionComplete = productSelected && (
        (!mainsFieldPresent && !crossesFieldPresent) ||
        (mainsSelected && crossesSelected)
      );

      this.stringingAdded = this.selectionComplete;

      if (this.selectionComplete) {
        this._renderSummary('custom');
        this._updateSummary(true);
        this._enableAddToCart();
      } else {
        this._updateSummary(false);
        this._disableAddToCart(true);
      }
    },

    _handleAddToCart: function (evt) {
      if (!this.selectionComplete || !this.variantAvailable) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this._disableAddToCart(true);
        return false;
      }

      if (this.stringingAdded) {
        this._addStringingToCart();
      } else {
        this._removeStringingForSku();
      }
    },

    _addStringingToCart: function () {
      var quantity = $(selectors.quantity).val() || 1;
      var selection = this.recommendedSelected ? this.recommended : this.custom;

      if (!selection.variant) {
        return;
      }

      var properties = {
        "tension_crosses": selection.crosses,
        "tension_mains": selection.mains,
        "w_stencil": selection.stencil,
        "product": this.sku
      };

      CartJS.addItem(selection.variant, quantity, properties);
      this._updateProductPrice(selection.price);
    },

    _removeStringingForSku: function () {
      var self = this;
      this._updateProductPrice(0);
    },

    _updateProductPrice: function (stringingPrice) {
      var prodOnlyPrice = parseInt($(selectors.productPrice).data('product-only-price'));
      if (!prodOnlyPrice || typeof Currency === 'undefined' || !Currency.formatMoney) {
        return;
      }
      var totalPrice = prodOnlyPrice + (stringingPrice || 0);
      $(selectors.productPrice).text(Currency.formatMoney(totalPrice));
    },

    _getStringingProducts: function () {
      var self = this;
      $.get('/collections/all/' + config.stringProductsTag + '?view=json', function (data) {
        self.data.products = jQuery.parseJSON(data);
        self._populateCustomOptionsFromData();
        self._setRecommended();
      });
    },

    _populateCustomOptionsFromData: function () {
      var select = this.$container.find(selectors.productSelect);
      if (!select.length || select.find('option').length > 1) {
        return;
      }
      this.data.products.forEach(function (product) {
        var option = $('<option/>', {
          value: product.variants[0].id,
          text: product.title + ' + ' + (typeof Currency !== 'undefined' && Currency.formatMoney ? Currency.formatMoney(product.price, shop.moneyFormat) : product.price),
          'data-price': product.price,
          'data-title': product.title
        });
        select.append(option);
      });
    },

    _setRecommended: function () {
      var self = this;
      var prodHandle = this.$container.data('recommended');
      var recommendedExists = this.$container.data('recommended-exists');

      if (!prodHandle) {
        return;
      }

      this.data.products.forEach(function (product) {
        if (product.handle == prodHandle) {
          self.recommended.product = product.title;
          self.recommended.price = product.price;
          self.recommended.variant = recommendedExists ? product.variants[0].id : null;
        }
      });

      this.recommended.crosses = this.$container.find('[data-crosses]').data('crosses');
      this.recommended.mains = this.$container.find('[data-mains]').data('mains');
      this.recommended.stencil = this.$container.find('[data-stencil]').data('stencil');

      var $recommendedPrice = this.$container.find(selectors.recommendedPrice);
      if ($recommendedPrice.length && this.recommended.price) {
        $recommendedPrice.text(Currency.formatMoney(this.recommended.price, shop.moneyFormat));
      }
    },

    _updateSummary: function (show) {
      if (this.$summaryContainer && this.$summaryContainer.length) {
        this.$summaryContainer.toggleClass('hidden', !show);
      }
    },

    _renderSummary: function (type) {
      var target;
      if (type === 'recommended') {
        target = this.recommended;
      } else if (type === 'custom') {
        target = this.custom;
      } else if (type === 'frame') {
        target = {
          product: (theme.strings && theme.strings.frameOnly) || 'Frame only selected',
          price: 0,
          mains: '',
          crosses: '',
          stencil: false
        };
      }

      if (!target) {
        return;
      }

      if (this.$summaryString && this.$summaryString.length) {
        this.$summaryString.text(target.product || '');
      }
      if (this.$summaryPrice && this.$summaryPrice.length) {
        if (target.price) {
          this.$summaryPrice.text((typeof Currency !== 'undefined' && Currency.formatMoney) ? Currency.formatMoney(target.price, shop.moneyFormat) : target.price);
        } else {
          this.$summaryPrice.text('');
        }
      }
      if (this.$summaryMains && this.$summaryMains.length) {
        this.$summaryMains.text(target.mains || '');
      }
      if (this.$summaryCrosses && this.$summaryCrosses.length) {
        this.$summaryCrosses.text(target.crosses || '');
      }
      if (this.$summaryStencil && this.$summaryStencil.length) {
        var stencilText = '';
        if (target.stencil !== undefined && target.stencil !== null) {
          stencilText = target.stencil
            ? ((theme.strings && theme.strings.red_w_stencil) ? theme.strings.red_w_stencil : 'Yes')
            : ((theme.strings && theme.strings.no_red_w_stencil) ? theme.strings.no_red_w_stencil : 'No');
        }
        this.$summaryStencil.text(stencilText);
      }
    },

    _buildSummary: function () {
      return '';
    },

    _promptText: function () {
      return this.selectionPrompt;
    },

    _frameOnlySummary: function () {
      return (theme.strings && theme.strings.frameOnly) || 'Frame only selected';
    },

    _unavailableText: function () {
      return (theme.strings && theme.strings.recommendedUnavailable) || 'Recommended strings are unavailable';
    },

    _resetSelection: function () {
      this.$choice.val('');
      this.$panels.addClass('hidden');
      this.selectionComplete = false;
      this.stringingAdded = false;
      this.recommendedSelected = false;
      this.custom = {
        product: null,
        variant: null,
        mains: null,
        crosses: null,
        stencil: false,
        price: 0
      };
      this._updateCustomPrice();
      this._clearSummaryFields();
      this._updateSummary(false);
      this._disableAddToCart(true);
    },

    _clearSummaryFields: function () {
      if (this.$summaryString && this.$summaryString.length) {
        this.$summaryString.text('');
      }
      if (this.$summaryPrice && this.$summaryPrice.length) {
        this.$summaryPrice.text('');
      }
      if (this.$summaryMains && this.$summaryMains.length) {
        this.$summaryMains.text('');
      }
      if (this.$summaryCrosses && this.$summaryCrosses.length) {
        this.$summaryCrosses.text('');
      }
      if (this.$summaryStencil && this.$summaryStencil.length) {
        this.$summaryStencil.text('');
      }
    },

    _updateCustomPrice: function () {
      var $customPrice = this.$container.find(selectors.customPrice);
      if ($customPrice.length) {
        if (typeof Currency === 'undefined' || !Currency.formatMoney) {
          $customPrice.text(this.custom.price || 0);
        } else {
          $customPrice.text(Currency.formatMoney(this.custom.price || 0, shop.moneyFormat));
        }
      }
    },

    _disableAddToCart: function (force) {
      if (!this.$addToCart.length) {
        return;
      }
      if (!this.variantAvailable) {
        return;
      }
      if (!force && this.$addToCart.prop('disabled') && !this.$addToCart.data('dropdown-disabled')) {
        return;
      }
      this.$addToCart.prop('disabled', true).data('dropdown-disabled', true);
      this._setButtonText(this.selectionPrompt);
    },

    _enableAddToCart: function () {
      if (!this.$addToCart.length) {
        return;
      }
      if (!this.selectionComplete || !this.variantAvailable) {
        return;
      }
      if (this.$addToCart.data('dropdown-disabled')) {
        this.$addToCart.prop('disabled', false).data('dropdown-disabled', false);
        this._setButtonText(this.defaultButtonText);
      }
    },

    _getButtonText: function () {
      if (this.$addToCartText.length) {
        return this.$addToCartText.text();
      }
      return this.$addToCart.text();
    },

    _setButtonText: function (text) {
      if (this.$addToCartText.length) {
        this.$addToCartText.text(text);
      } else {
        this.$addToCart.text(text);
      }
    }
  });

  return new StringingDropdown();
})();

window.theme = window.theme || {};

theme.SearchPopup = (function () {

  function SearchPopup() {

    this.template = theme.utils.getTemplate('search-popup');
    if(this.template){
          this.el = theme.utils.createElementFromHTML(this.template);

    
    tinybind.bind(this.el, {
      search: theme.current.search,
      shop: shop,
      Currency: Currency
    });
    }

  }

  SearchPopup.prototype = _.extend(SearchPopup.prototype, {

    getPopup: function () {
      this.el.style.display = ''; // Remove display styles added by Boost
      return this.el;
    },

  });

  return new SearchPopup();
})();

window.theme = window.theme || {};

window.theme.ProductSiblings = (function() {
  function generateSiblingHtml(product) {
    var groupTagPrefix = "group:";
    var productGroup, colourTag;
    for (const tag of product.tags) {
      if(tag.includes(groupTagPrefix)) {
        productGroup = tag
      }
      if(tag.includes("colour:")) {
        colourTag = tag
      }
    }

    if(productGroup && colourTag) {
      return generateSiblingHtmlWithGroupTag(product, productGroup, colourTag);
    } else {
      return generateSiblingHtmlWithVariants(product);
    }
  }

  function generateSiblingHtmlWithVariants(product) {
    return '';
    var itemVariants = '';
    var variantColors = false;
    
    for (var i = 0; i < product.options_with_values.length; i++) {
      var optionHandle = theme.utils.handleize(product.options_with_values[i].name);
      if (optionHandle == 'color' || optionHandle == 'colour') {
        if (product.options_with_values[i].values.length >= 1) {
          variantColors = product.options_with_values[i].values;
          break;
        }
      }
    }
    
    if (variantColors) {
      if (!variantColors[0].title) {
        variantColorArray = [];
        for (var i = 0; i < variantColors.length; i++) {
          var variantColorObject = {};
          variantColorObject.title = variantColors[i];
          for (var n = 0; n < product.variants.length; n++) {
            var variant = product.variants[n];
            if (variant.options.indexOf(variantColors[i]) > -1 && variant.featured_image !== null && variant.featured_image.position !== undefined) {
              variantColorObject.image = variant.featured_image.position - 1;
              break;
            }
          }
          variantColorArray.push(variantColorObject);
        }
        variantColors = variantColorArray;
      }
      var productSiblings =  variantColors.length >= 4 ?
          '<div class="product-grid-item__siblings product-grid-item__siblings--old is-slider">' : '<div class="product-grid-item__siblings product-grid-item__siblings--old">'
      itemVariants += productSiblings;
      for (var i = 0; i < variantColors.length; i++) {
        var variant = product.variants[i];
        var variantColor = variantColors[i].title;
        var variantImage = bcSfFilterConfig.general.no_image_url;
        // console.log(product.images, variantColors[i]);
        if (product.images[variantColors[i].image]) {
          variantImage = slate.Image.getSizedImageUrl(product.images[variantColors[i].image], '60x');
        }
        var variantMarkup = '';
        var color = window.theme.colours[variantColor] ? theme.utils.handleize(window.theme.colours[variantColor]) : "";
        variantMarkup += '<div class="product-grid-item__sibling product-grid-item__sibling--' + theme.utils.handleize(variantColor) + '" data-image-src="' + variantImage?.replace('_60x', '_{width}x') + '" data-colour="colour:'+ color + '">';
        variantMarkup += '<span><img loading="lazy" src="' + variantImage + '"></span>';
        variantMarkup += '</div>';
        
        itemVariants += variantMarkup;
      }
      
      itemVariants += '</div>';
    }
    return itemVariants;
  }

  function generateSiblingHtmlWithGroupTag(product, productGroup, colourTag) {
    return `
      <colour-swatches data-product-id="${product.id}">
        <div class="product-grid-item__siblings is-slider colour-swatches__container is-slider" data-main-product="${product.handle}">
        </div>
        <script type="application/json" id="swatches-settings">
          {
            "handle":"${product.handle}",
            "image_type": "first_variant_image",
            "groupTag":  "${productGroup}",
            "colour": "${colourTag ? colourTag.replace("colour:", "") :""}",
            "colourTagPrefix": "colour:",
            "swatchUrl": "blank.jpg"
          }
        </script>
      </colour-swatches>
    `;
  }
  
  return {
    generateSiblingHtml: generateSiblingHtml
  };
})();

/*================ Sections ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.collection-filters__dropdown--filter',
    sortSelection: '.collection-filters__dropdown--sort',
    defaultSort: '.collection-filters__default-sort',
    filterPlaceholderDesktop: '.collection-filters-placeholder--desktop',
    filterPlaceholderMobile: '.collection-filters-placeholder--mobile',
    filterContentDesktop: '.collection-filters-content--desktop',
    filterContentMobile: '.collection-filters-content--mobile',
    filterSection: '[data-section-type="collection-filters"]',
    filterSectionWrapper: '#shopify-section-collection-filters',
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.initFilters();

    this.$filterSelects = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelects.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {

    /**
     * Initialises filters
     */
    initFilters: function () {
      var self = this;
      var $filterSectionWrapper = $(selectors.filterSectionWrapper);

      var $filterContentMobile = $(selectors.filterContentMobile, $filterSectionWrapper).html();
      var $filterContentDesktop = $(selectors.filterContentDesktop, $filterSectionWrapper).html();

      $(selectors.filterPlaceholderMobile, this.$container).replaceWith($filterContentMobile);
      $(selectors.filterPlaceholderDesktop, this.$container).replaceWith($filterContentDesktop);
    },

    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(window.location.search, '');
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      // window.location.href = $(evt.target).val() + window.location.search;
      var newLocation = $(evt.target).val();
      if (window.location.search != '') {
        var currentQueryParams = theme.utils.getQueryParams();
        for (var k in currentQueryParams) {
          if (currentQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(k, currentQueryParams[k], newLocation);
          }
        }
        var newQueryParams = theme.utils.getQueryParams(newLocation);
        for (var k in newQueryParams) {
          if (newQueryParams.hasOwnProperty(k)) {
            newLocation = theme.utils.updateQueryStringParameter(k, newQueryParams[k], newLocation);
          }
        }
        window.location.href = newLocation;
      }
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + 5 + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelects.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.HeaderSection = (function () {

  var settings = {
    stickyHeader: true
  };

  function Header(container) {
    var $container,
      stickyHeader;

    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();

    $container = $(container);

    if (settings.stickyHeader) {
      stickyHeader = $container.parent().stickybits();
    }
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.FooterSection = (function () {

  var settings = {

  };

  function Footer(container) {

    var $tabs = $('.tabs', container);

    new theme.TabAccordions($tabs, {
      hashWatch: true,
      pauseMedia: true,
      responsiveSwitch: 'tablist',
      saveState: sessionStorage,
    });

  }

  return Footer;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function () {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function (results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function () {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function () {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json-main]',
    productSku: '[data-product-variant-sku]',
    productPrice: '[data-product-price]',
    productImageWrap: '[data-product-images-wrap]',
    productImageContainer: '[data-product-images]',
    productImages: '[data-product-image]',
    productActiveImage: '[data-product-active-image]',
    productHorizontalThumbContainer: '[data-product-thumbnails-horizontal]',
    productVerticalThumbContainer: '[data-product-thumbnails-vertical]',
    productThumbnailNav: '[data-product-thumbnails-nav]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    singleOptionValue: '[data-single-option-value]',
    productQtyWrapper: '.product-form__item--quantity',
    productQtySelector: '[data-product-quantity]',
    optionSelector: '[data-option-selector]',
    percentOff: '[data-percent-off]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    this.$qtySelector = $(selectors.productQtySelector);
    var sectionId = this.$container.attr('data-section-id');

    this.$addToCart = $(selectors.addToCart, this.$container);
    this.$addToCartText = $(selectors.addToCartText, this.$container);

    // Add early access checks
    this.hasEarlyAccess = this.$container.data('early-access') || false;
    this.isCustomerLoggedIn = !!this.$container.data('customer');

    this.hasComingSoon = this.$container.data('coming-soon') || false;

    console.log('hasComingSoon', this.hasComingSoon);

    this.settings = {
      // Breakpoints from src/styles/settings/variables.scss.liquid // $grid-breakpoints
      mediaQuerySmall: theme.settings.mediaQuery.small,
      mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      sectionId: sectionId,
      sliderActive: false,
      bpSmall: false,
      zoomEnabled: false,
      qtySelectorType: $(selectors.productQtySelector).is('select') ? 'select' : 'input',
    };
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html() && !theme.current.product) {
      return;
    }

    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    
    // Use enhanced product JSON with metafields if available
    var enhancedProductElement = $(selectors.productJson, this.$container);
    if (enhancedProductElement.length && enhancedProductElement.html()) {
      this.productSingleObject = JSON.parse(enhancedProductElement.html());
    } else {
      this.productSingleObject = theme.current.product;
    }
    this.settings.imageSize = this.$featuredImage.length ? slate.Image.imageSize(this.$featuredImage.attr('src')) : 0;
    this.settings.zoomEnabled = $(selectors.productFeaturedImage).hasClass('js-zoom-enabled');

    // slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    // this.initBreakpoints();
    this.initImageSlider();
    this.initGallery();
    this.initVariants();
    this.initYouMayAlsoLike();

    var readMoreLink = '<button aria-hidden="true" focusable="false" role="presentation" class="read-more">Read more <svg class="icon icon-fa-caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/></svg></button>';
    var productDescriptionReadMoreHeight = 200;

    // Only enable readmore if there's a decent amount of text to hide
    if ($('.product-single__description').innerHeight() >= (productDescriptionReadMoreHeight * 1.175)) {
      $('.product-single__description').readmore({
        speed: 75,
        collapsedHeight: productDescriptionReadMoreHeight,
        heightMargin: 20,
        moreLink: readMoreLink,
        lessLink: false,
        beforeToggle: function (trigger, element, expanded) {
          $(element).toggleClass('readmore-expanded');
        }
      });
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Creates linked sliders for product main and thumb images
     */
    initImageSlider: function () {
      var thumbOptionsHorizontal = {
        slidesToShow: 4,
        swipeToSlide: true,
        infinite: true,
        asNavFor: selectors.productImageContainer,
        focusOnSelect: true,
        nextArrow: '.product-single__thumbnail-nav-right',
        prevArrow: '.product-single__thumbnail-nav-left',
        arrows: true,
        rows: 0,
        responsive: [
          {
            breakpoint: 1420,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      };

      var mainOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        arrows: true,
        infinite: true,
        focusOnSelect: true,
        fade: true,
        adaptiveHeight: true,
        lazyLoad: 'progressive',
        rows: 0,
        asNavFor: selectors.productThumbnailNav,
        nextArrow: '.product-single__thumbnail-nav-right',
        prevArrow: '.product-single__thumbnail-nav-left',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              // arrows: true,
              // fade: false,
              // dots: true,
            }
          }
        ]
      };

      $activeProductImage = $(selectors.productActiveImage).first();
      if ($activeProductImage.length > 0) {
        var firstSlide = $activeProductImage.index() || 0;
        mainOptions.initialSlide = firstSlide;
      }

      var thumbOptionsVertical = {}
      if ($(selectors.productImageWrap, this.$container).is('[data-vertical]')) {

        thumbOptionsVertical = $.extend({}, thumbOptionsHorizontal, {
          vertical: true,
          verticalSwiping: true,
          arrows: false
        });
      }

      if (this.productSingleObject.images.length > 1) {
        $(selectors.productHorizontalThumbContainer).on('init', function(event, slick){
          var viewportWidth = window.innerWidth;
          if (slick.slideCount == 4 && (viewportWidth <= 900 || viewportWidth >= 1419)) {
            $(selectors.productHorizontalThumbContainer).addClass('small-slides');
          }
        }).slick(thumbOptionsHorizontal);
        if (thumbOptionsVertical) {
          $(selectors.productVerticalThumbContainer).slick(thumbOptionsVertical);
        }
      }

      $(selectors.productImageContainer).slick(mainOptions);

      this.settings.sliderActive = true;
    },

    /**
     * Sets up product image lightbox with Photoswipe.js
     */
    initGallery: function () {
      const self = this;

      // Early return if zoom is disabled or dependencies missing
      if (!self.settings.zoomEnabled || !window.PhotoSwipeLightbox || !window.PhotoSwipe) {
        console.warn('Gallery initialization skipped - zoom disabled or PhotoSwipe missing');
        return;
      }

      // Cleanup any existing instance
      if (self.lightbox?.destroy) {
        self.lightbox.destroy();
      }

      // Initialize new PhotoSwipe instance
      self.lightbox = new PhotoSwipeLightbox({
        gallery: selectors.productImageWrap,
        children: 'a, [data-media-type]',
        pswpModule: PhotoSwipe,
        showAnimationDuration: 200,
        hideAnimationDuration: 200,
        bgOpacity: 0.85
      });

      self.lightbox.addFilter('itemData', (itemData) => {
        if (itemData.element.dataset.videoType === 'shopify') {
          return {
            ...itemData,
            videoType: 'shopify',
            videoId: itemData.element.dataset.videoId,
            sources: itemData.element.dataset.sources.split(',').map(url => ({
              url: url.startsWith('//') ? `https:${url}` : url,
              mime_type: 'video/mp4'
            })),
            width: parseInt(itemData.element.dataset.width),
            height: parseInt(itemData.element.dataset.height)
          };
        }
        return itemData;
      });
  
      self.lightbox.on('contentLoad', (e) => {
        const { content } = e;
        const { videoType, videoId, sources } = content.data;
  
        if (videoType === 'shopify') {
          e.preventDefault();
          const container = document.createElement('div');
          container.className = 'pswp__video-container';
  
          const video = document.createElement('video');
          video.setAttribute('controls', '');
          video.setAttribute('autoplay', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('loop', '');
          video.style.width = '100%';

          video.muted = true;
  
          sources.forEach(src => {
            const source = document.createElement('source');
            source.src = src.url;
            source.type = src.mime_type;
            video.appendChild(source);
          });
  
          container.appendChild(video);
          content.element = container;
        }
      });
  
      // Initialize lightbox
      self.lightbox.init();


    },

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      
      this.$container.on('variantChange' + this.namespace, function (evt) {
        this.updateAddToCartState(evt);
        document.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: { variant: evt.variant }
          })
        );
        
        // Trigger cart validation check for mixed cart status
        if (typeof theme.AjaxCart !== 'undefined' && theme.AjaxCart.checkCartButtonState) {
          setTimeout(theme.AjaxCart.checkCartButtonState, 50);
        }
      }.bind(this));
      
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
      this.$container.on('variantOptionChange' + this.namespace, this.updateProductOptions.bind(this));
      this.$container.on('variantSKUChange' + this.namespace, this.updateSKU.bind(this));
      // $( window ).on("load", this.updateProductOptions.bind(this) )
      jQuery(selectors.singleOptionSelector).first().prop('selectedIndex', 1);
      jQuery(selectors.singleOptionSelector).first().trigger('change');
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      theme.StringingPopup._changeSku(evt.variant?.sku);
      if (theme.StringingDropdown && typeof theme.StringingDropdown._changeSku === 'function') {
        theme.StringingDropdown._changeSku(evt.variant?.sku);
      }

      var self = this,
        quantityAvailable,
        variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        quantityAvailable = Math.max(Math.max(variant.inventory_quantity, 0), self.$qtySelector.attr('data-max'));

        if (self.settings.qtySelectorType == 'select') {
          $('option', self.$qtySelector).remove();

          for (var i = quantityAvailable - 1; i >= 0; i--) {
            self.$qtySelector.prepend('<option ' + (i == 0 ? 'selected' : '') + ' value="' + (i + 1) + '">' + (i + 1) + '</option>');
          }
        } else {
          quantityAvailable = quantityAvailable > 0 ? quantityAvailable : 999;
          self.$qtySelector.prop('max', quantityAvailable);
          self.$qtySelector.prop('min', 1);
        }

        if (this.hasComingSoon) {
          this.$addToCart.prop('disabled', true);
          this.$addToCartText.html(theme.strings.comingSoon || 'Coming Soon');
          $(selectors.addToCartText, this.$container).attr('block-popup', false);
          return;
        }
        
        if (this.hasEarlyAccess) {
          if (!this.isCustomerLoggedIn) {
            this.$addToCart.prop('disabled', true).addClass('product-form__cart-submit--early-access');
            this.$addToCartText.html(theme.strings.earlyAccessGuestCTA || 'Log in to Order');
            //this.$container.find('.early-access-message').hide(); 
            return;
          }      
        } else {
          // Check for pre-order status from variant metafields
          var isPreorder = this._checkVariantPreorderStatus(variant);
          var shippingDate = this._extractShippingDate(variant);
          var buttonText;
          
          // Keep the hidden preorder property in sync with the selected variant
          this._syncPreorderProperty(isPreorder);
          
          if (isPreorder) {
            if (shippingDate) {
              var preOrderDateTemplate = theme.strings.preOrderDate || 'Pre Order Now - Shipping {{ shipping_date }}';
              buttonText = preOrderDateTemplate
                .replace(/\{\{\s*shipping_date\s*\}\}/gi, shippingDate)
                .replace(/\{\{shipping_date\}\}/gi, shippingDate);
            } else {
              buttonText = theme.strings.preOrder || 'Pre-Order';
            }
          } else {
            buttonText = theme.strings.addToCart;
          }
          
          $(selectors.addToCart, this.$container).prop('disabled', false);
          
          var $preOrderText = $(selectors.addToCart, this.$container).find('.pre-order-button-text');
          var $addToCartText = $(selectors.addToCartText, this.$container);
          
          if (isPreorder) {
            if ($preOrderText.length) {
              $preOrderText.html(buttonText);
            } else if ($addToCartText.length) {
              $addToCartText.replaceWith('<span class="pre-order-button-text">' + buttonText + '</span>');
            } else {
              $(selectors.addToCart, this.$container).html('<span class="pre-order-button-text">' + buttonText + '</span>');
            }
          } else {
            if ($preOrderText.length) {
              $preOrderText.replaceWith('<span data-add-to-cart-text>' + buttonText + '</span>');
            } else if ($addToCartText.length) {
              $addToCartText.html(buttonText);
            }
          }
          
          $(selectors.addToCartText, this.$container).attr('block-popup', false);
          
          // Add/remove pre-order class
          if (isPreorder) {
            $(selectors.addToCart, this.$container).addClass('product-form__cart-submit--preorder');
          } else {
            $(selectors.addToCart, this.$container).removeClass('product-form__cart-submit--preorder');
          }
        }
      } else {
        $(selectors.productQtyWrapper + ' input', this.$container).prop('max', 0);
        $(selectors.productQtyWrapper + ' input', this.$container).prop('min', 0);
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.addToCartText, this.$container).attr('block-popup', true);
      }
    },

    /**
     * Ensure product forms carry the correct _is_pre_order flag for the selected variant.
     * Removes the flag when the variant is not a preorder.
     */
    _syncPreorderProperty: function(isPreorder) {
      var $forms = this.$container.find('form[action="/cart/add"]');
      if (!$forms.length) return;

      $forms.each(function() {
        var $form = $(this);
        var $input = $form.find('input[name="properties[_is_pre_order]"]');

        if (isPreorder) {
          if (!$input.length) {
            $input = $('<input>', { type: 'hidden', name: 'properties[_is_pre_order]' });
            $form.append($input);
          }
          $input.val('true');
        } else if ($input.length) {
          $input.remove();
        }
      });
    },

    initYouMayAlsoLike: function (evt) {
      if (!$('.related_item__row').length) {
        return;
      }
      $('.related_item__row').slick({
        // dots: true,
        infinite: true,
        // speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        nextArrow: '.you-may-also-like__thumbnail-nav-right',
        prevArrow: '.you-may-also-like__thumbnail-nav-left',
        responsive: [
          {
            breakpoint: 1224,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              swipeToSlide: true,
              infinite: true,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              swipeToSlide: true,
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              swipeToSlide: true,
              arrows: true
            }
          }
        ]
      });
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      console.log('price')
      var variant = evt.variant,
        $comparePrice = $(selectors.comparePrice, this.$container),
        $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container),
        comparePrefixString = $comparePrice.data('prefix-string'),
        $percentOffEl = $(selectors.percentOff),
        compareSuffixString = $comparePrice.data('suffix-string');

      comparePrefixString = comparePrefixString ? '<span>' + comparePrefixString + '</span>' : '';
      compareSuffixString = compareSuffixString ? '<span>' + compareSuffixString + '</span>' : '';

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, shop.moneyFormat));
      console.log("test", variant.compare_at_price, variant.price)
      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(comparePrefixString + slate.Currency.formatMoney(variant.compare_at_price, shop.moneyFormat) + compareSuffixString);
        var discount = Math.round((((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price));
        $percentOffEl.text(discount)
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

    },

    /**
     * Updates the DOM with specified options
     */
    updateProductOptions: function(evt) {
      var enabledOptions2 = [];
      var selectedVariant = evt.variant;
      var initialLoadHandled = false; // Track if the initial load logic has been applied

      function checkInitialAvailability() {
        $(selectors.singleOptionSelector + '[data-index="option1"]').each(function() {
          var $this = $(this);
          var optionValue = $this.val();
          var isAvailable = false;

          theme.current.product.variants.forEach(variant => {
            if (variant.option1 === optionValue && variant.available) {
              isAvailable = true;
            }
          });

          $this.attr('data-available', isAvailable ? 'true' : 'false');
        });

        initialLoadHandled = true;
      }

      function updateSwatchAvailability() {
        enabledOptions2 = [];

        if (selectedVariant) {
          theme.current.product.variants.forEach(variant => {
            if (variant.available && variant.option1 === selectedVariant.option1) {
              enabledOptions2.push(variant.option2);
            }
          });

          $(selectors.singleOptionSelector + '[data-index="option2"]').each(function() {
            var $this = $(this);
            var optionValue = $this.val();
            var isAvailable = enabledOptions2.includes(optionValue);
            $this.attr('data-available', isAvailable ? 'true' : 'false');
          });
        }
      }

      if (!initialLoadHandled && evt.type === 'variantOptionChange') {
        checkInitialAvailability();
      }

      updateSwatchAvailability();

      if (selectedVariant) {
        if (!selectedVariant.available) {
          var $selectedDisabledOptions = $(selectors.singleOptionSelector + ':disabled:checked');
          if ($selectedDisabledOptions.length) {
            $selectedDisabledOptions.each(function() {
              var $newOption = $(this).siblings(selectors.singleOptionSelector + ':not(:disabled):not(:checked)').eq(0);
              $(this).removeAttr('checked');
              $newOption.attr('checked', 'checked').trigger('click');
            });
          }
        }

        $(selectors.singleOptionValue).each(function () {
          var $this = $(this);
          $this.text(selectedVariant.options[$this.data('single-option-value')]);
        });

        $(selectors.singleOptionSelector + '[data-always-enabled]').removeAttr('disabled');
      }
    },
    
    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var self = this;
      var variant = evt.variant;
    
      if (!variant || !variant.featured_image) return;
    
      if (self.settings.sliderActive) {
        var imageIndex = $('[data-image-id="' + variant.featured_image.id + '"]:not(.slick-cloned)')
          .closest('.slick-slide')
          .data('slick-index');
        
        if (typeof imageIndex !== 'undefined') {
          $(selectors.productImageContainer).slick('slickGoTo', imageIndex);
        }
      } else {
        if (this.$featuredImage && this.$featuredImage.length) {
          var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
          this.$featuredImage.attr('src', sizedImgUrl);
        }
      }
    },

    /**
     * Updates the DOM with specified Variant SKU
     */
    updateSKU: function (evt) {
      var variant = evt.variant;

      // Update the sku
      $(selectors.productSku, this.$container).html(variant.sku);
    },

    /**
     * Check if variant has pre-order status from metafields
     */
    _checkVariantPreorderStatus: function(variant) {
      if (!variant || !variant.metafields || !variant.metafields.custom || !variant.metafields.custom.pre_order_status) {
        return false;
      }
      
      var status = variant.metafields.custom.pre_order_status.toLowerCase();
      return status === 'preorder' || status === 'pre-order' || status.includes('pre-order::');
    },

    /**
     * Extract shipping date from variant pre-order metafield
     * Returns the date string if found, null otherwise
     */
    _extractShippingDate: function(variant) {
      if (!variant || !variant.metafields || !variant.metafields.custom || !variant.metafields.custom.pre_order_status) {
        return null;
      }
      
      var status = variant.metafields.custom.pre_order_status;
      if (status && typeof status === 'string' && status.toLowerCase().includes('pre-order::')) {
        var dateMatch = status.match(/pre-order::(.+)/i);
        if (dateMatch && dateMatch[1]) {
          return dateMatch[1].replace(/-/g, ' ').trim();
        }
      }
      
      return null;
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0
  };

  var defaults = {
    arrows: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3,
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    defaults.prevArrow = '#Quotes-' + sectionId + ' ~ .slideshow__prev';
    defaults.nextArrow = '#Quotes-' + sectionId + ' ~ .slideshow__next';

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $('.quotes__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = theme.slideshows || {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.BrandValueSliders = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0,
    anchorPosition: 'above', // above, below
    anchorElement: false, // '.site-header-lower'
    anchorViewport: 'small' // large, small
  };

  var cache = {
    anchorMarginBottom: 0,
    anchorMarginTop: 0,
    anchorOffset: 0
  }

  var defaults = {
    arrows: false,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    swipeToSlide: true,
    slidesToScroll: 1,
    rows: 0,
  };

  function brandValueSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.brand-values-wrap';
    var slider = this.slider = '#brand-values-' + sectionId;
    var $slider = $(slider, wrapper);
    var $contentContainer = $('#PageContent');
    var $anchorElement = $(config.anchorElement);

    var mobileOptions = $.extend({}, defaults, {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: $slider.data('autoplay-mobile'),
      autoplaySpeed: $slider.data('speed')
    });

    var sliderActive = false;
    var desktopOptions = $.extend({}, defaults, {
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop')
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if ($anchorElement.length) {
      cache.anchorMarginTop = parseInt($anchorElement.css("marginTop").replace('px', ''));
      cache.anchorMarginBottom = parseInt($anchorElement.css("marginBottom").replace('px', ''));
    }

    enquire.register(config.mediaQuerySmall, {
      deferSetup: true,
      match: function () {
        initSlider($slider, mobileOptions);

        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px'
          });

          if (config.anchorViewport == 'small' || config.anchorViewport == 'all') {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'top': cache.anchorOffset + 'px'
                };
                break;
              default:
                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'top': cache.anchorOffset + 'px'
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px'
            };
            var sliderAdjustment = {
              'position': 'static',
              'top': '0px'
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      deferSetup: true,
      match: function () {
        initSlider($slider, desktopOptions);
        if ($anchorElement.length) {
          $anchorElement.css({
            'margin-top': cache.anchorMarginTop + 'px',
            'margin-bottom': cache.anchorMarginBottom + 'px'
          });

          if (config.anchorViewport == 'large' || config.anchorViewport == 'all') {
            $container.css('position', 'fixed');
            switch (config.anchorPosition) {
              case 'above':
                cache.anchorOffset = $anchorElement.offset().top;
                var anchorAdjustment = {
                  'margin-top': (cache.anchorMarginTop + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'position': 'fixed',
                  'top': cache.anchorOffset + 'px'
                };
                break;
              default:
                cache.anchorOffset = $anchorElement.offset().top + $anchorElement.innerHeight();
                var anchorAdjustment = {
                  'margin-bottom': (cache.anchorMarginBottom + $container.outerHeight()) + 'px'
                };
                var sliderAdjustment = {
                  'position': 'fixed',
                  'top': cache.anchorOffset + 'px'
                };
                break;
            }
          } else {
            var anchorAdjustment = {
              'margin-bottom': cache.anchorMarginBottom + 'px'
            };
            var sliderAdjustment = {
              'position': 'static',
              'top': '0px'
            };
          }

          $anchorElement.css(anchorAdjustment);
          $container.not('.brand-values--cloned').css(sliderAdjustment);
        }
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
        $('.brand-values-clone').empty();
      }

      // Clone brand values content to other site areas
      // #TODO: Attach this to the main slider init so it functions as a slider
      sliderObj.clone().addClass('brand-values--cloned').removeAttr('id').removeAttr('style').appendTo('.brand-values-clone');

      sliderObj.slick(args);
      sliderActive = true;

      if ($anchorElement.length) {
        if ($(window).width() < 750) {
          switch (config.anchorPosition) {
            case 'above':
              $anchorElement.css('margin-top', sliderObj.outerHeight() + 'px');
              break;
            default:
              $anchorElement.css('margin-bottom', sliderObj.outerHeight() + 'px');
              break;
          }
        }
      }
    }
  }

  brandValueSliders.prototype = _.assignIn({}, brandValueSliders.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $('.brand-values__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return brandValueSliders;
})();

window.theme = window.theme || {};

theme.FeaturedCollection = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMediumUp: theme.settings.mediaQuery.mediumUp,
    slideCount: 0
  };

  var sliderOptions = {
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
  };

  function featuredCollection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.featured-collection-wrap';
    var slider = this.slider = '#featured-collection-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = $.extend({}, sliderOptions, {
      prevArrow: slider + ' ~ .featured-collection__prev',
      nextArrow: slider + ' ~ .featured-collection__next',
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            // dots: true,
            autoplay: $slider.data('autoplay-mobile'),
          }
        },
        {
          breakpoint: 512,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            // dots: true
          }
        }
      ]
    });

    var self = this;

    function appendSlickScrollbar(slick) {
      if (slick.$slides.filter('.slick-active').length != slick.$slides.length) {
        var currentMarkerOffset = slick.currentSlide * 100;
        var scrollbarMarkerWidth = 1 / slick.slideCount * 100;
        slick.$slider.append('<div class="slick-scrollbar"><div class="slick-scrollbar-mark" style="width: ' + scrollbarMarkerWidth + '%"></div></div>');
        $('.slick-scrollbar-mark', slick.$slider).css('transform', 'translateX(' + currentMarkerOffset + '%)');
      }
    }

    $slider.on('init', function (evt, slick) {
      self.a11y.bind(this);

      appendSlickScrollbar(slick);
    });

    $slider.on('reInit', function (evt, slick) {
      appendSlickScrollbar(slick);
    });

    $slider.on('beforeChange', function (evt, slick, currentSlide, nextSlide) {
      var currentMarkerOffset = nextSlide * 100;
      $('.slick-scrollbar-mark', slick.$slider).css('transform', 'translateX(' + currentMarkerOffset + '%)');
    });

    initSlider($slider, options);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;

      var markerRatio = $('.featured-collection .slick-list').width() / $('.featured-collection .slick-track').width();

      $('input[type="number"]', sliderObj).not('.js-qty-select input[type="number"]').each(function () {
        var $el = $(this);
        theme.QuantitySelectors.init($el);
      });
    }
  }

  featuredCollection.prototype = _.assignIn({}, featuredCollection.prototype, {
    onUnload: function () {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return featuredCollection;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.FeaturedCollections = (function () {

  var selectors = {
    slidesDataContainer: '#featured-collections-data-',
    slideContainer: '.featured-collections__product-grid--',
    gridItems: '.product-grid-item-wrapper',
  };

  function FeaturedCollections(container) {

    var self = this;

    this.container = container;
    this.containerID = container.dataset.sectionId;

    this.data = {
      slides: [],
      progress: 0,
      autoProgress: false,
      activateOnScroll: true
    };

    this.methods = {
      setActiveSlideListener: this._setActiveSlideListener.bind(this),
      autoProgress: this._autoProgress.bind(this)
    };

    this._getSlidesdata();
    this._findInitialActiveSlide();
    this._bindView();
    this._autoProgress();
    this._activateOnScroll();
    this._holdOnMouseEnter();
    this._startOnMouseLeave();

  }

  FeaturedCollections.prototype = _.extend({}, FeaturedCollections.prototype, {

    _bindView: function () {
      var self = this;

      tinybind.bind(this.container, {
        data: self.data,
        methods: self.methods,
      });
    },

    _holdOnMouseEnter: function () {
      var self = this;

      $(selectors.gridItems).mouseenter(function () {
        self.data.autoProgress = false;
      });
    },

    _startOnMouseLeave: function () {
      var self = this;

      $(selectors.gridItems).mouseleave(function () {
        self.data.autoProgress = true;
      });
    },

    _activateOnScroll: function () {
      var self = this;
      if (this.data.activateOnScroll) {
        var waypoint = new Waypoint({
          element: $('.featured-collections--animate'),
          handler: function (direction) {
            self.data.autoProgress = true;
            self._autoProgress();
            this.destroy()
          },
          offset: 500
        })
      }
    },

    _getSlidesdata: function () {

      var self = this;

      var slidesDataContainer,
        slidesData;

      slidesDataContainer = this.container.querySelector(selectors.slidesDataContainer + self.containerID).innerHTML;
      slidesData = JSON.parse(slidesDataContainer);

      function Slide(data) {
        _.extend(this, data);
      }

      _.each(slidesData, function (id) {

        var slide,
          slideContainer;

        slideContainer = self.container.querySelector(selectors.slideContainer + id);
        self._generateRandomAnimations(slideContainer);

        slide = new Slide({
          id: id,
          slide: slideContainer
        });

        self.data.slides.push(slide);
      });

    },

    _setActiveSlideListener: function () {
      var targetSlide;
      targetSlideID = event.currentTarget.dataset.targetSlide;
      this.setActiveSlide(parseInt(targetSlideID));
    },

    setActiveSlide: function (id) {

      var self = this;

      var targetSlide;

      targetSlide = _.find(this.data.slides, { 'id': id.toString() });

      if (this.data.activeSlide == targetSlide) {
        return;
      }

      if (this.data.isTransitioning) {
        return;
      }

      this.data.isTransitioning = true;

      this.data.previousSlide = this.data.activeSlide;
      this.data.activeSlide = targetSlide;

      this._generateRandomAnimations(this.data.activeSlide.slide);

      this.data.previousSlide.slide.style.zIndex = 99;
      this.data.activeSlide.slide.style.zIndex = 100;
      this.data.activeSlide.slide.classList.add('reveal');
      this.data.previousSlide.slide.classList.remove('reveal');

      this.data.progress = 0;

      setTimeout(function () {
        self.data.previousSlide.slide.style.zIndex = null;
        self.data.activeSlide.slide.style.zIndex = null;
        self.data.isTransitioning = false;
      }, 1500);

    },

    _generateRandomAnimations: function (slideContainer) {

      var gridItems;

      gridItems = slideContainer.querySelectorAll(selectors.gridItems);

      _.each(gridItems, function (gridItem, i) {
        var curtain,
          content,
          randomDuration,
          duration;

        curtain = gridItem.querySelector('.curtain');
        content = gridItem.querySelector('.product-grid-item');

        randomDuration = Math.floor(Math.random() * (75 - 50)) / 100;
        duration = i * 0.15;

        curtain.style.animationDelay = randomDuration + 's';
        content.style.animationDelay = randomDuration + 's';

      });

    },

    _findInitialActiveSlide: function () {

      var self = this;

      _.each(this.data.slides, function (slide) {
        if (slide.slide.classList.contains('reveal')) {
          self.data.activeSlide = slide;
        }
      });
    },

    _autoProgress: function () {
      var self = this;
      var duration,
        interval,
        autoProgress;

      duration = 10000;
      interval = duration / 1000;

      autoProgress = setInterval(function () {

        if (self.data.autoProgress && !self.data.isTransitioning) {

          if (self.data.progress >= 100) {
            self._goToNextSlide();
          } else {
            self.data.progress += 0.1;
          }

        }

      }, interval);
    },

    _goToNextSlide: function () {

      var activeSlideIndex,
        nextSlideIndex,
        slidesCount,
        nextSlideId;

      slidesCount = this.data.slides.length;

      activeSlideIndex = _.findIndex(this.data.slides, this.data.activeSlide);
      nextSlideIndex = activeSlideIndex + 1;

      if (nextSlideIndex > (slidesCount - 1)) {
        nextSlideIndex = 0;
      }

      nextSlideId = this.data.slides[nextSlideIndex].id;

      this.setActiveSlide(nextSlideId);

    }

  });

  return FeaturedCollections;
})();


window.theme = window.theme || {};

theme.slideshows = theme.slideshows || {};

theme.FeaturedProducts = (function () {

  function FeaturedProducts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshowMasthead = this.slideshow = '#featured-products-masthead-' + sectionId;
    var slideshow = this.slideshow = '#featured-products-' + sectionId;

    theme.slideshows[slideshowMasthead] = new theme.Slideshow(slideshowMasthead);
    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    $('.featured-products__slide', slideshow).on('mouseenter', function () {
      $(slideshowMasthead).slick('slickGoTo', $(this).parents('.slick-slide').data('slick-index'));
    });

    $('.featured-products__slide', slideshow).on('mouseleave', function () {
      $(slideshowMasthead).slick('slickGoTo', $(slideshow).slick('slickCurrentSlide'));
    });
  }

  return FeaturedProducts;
})();

theme.FeaturedProducts.prototype = _.assignIn({}, theme.FeaturedProducts.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('[data-block-id="' + evt.detail.blockId + '"]:not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageRows = (function () {

  function ImageRows(container) {

  }

  return ImageRows;
})();

window.theme = window.theme || {};

theme.ContentSliders = (function () {
  var config = {
    mediaQuerySmall: theme.settings.mediaQuery.small,
    mediaQueryMedium: theme.settings.mediaQuery.medium,
    mediaQueryLargeUp: theme.settings.mediaQuery.largeUp
  };

  function contentSliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.content-slider-wrap';
    var slider = this.slider = '#content-slider-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    var options = {
      infinite: $slider.data('infinite'),
      prevArrow: slider + ' ~ .content-slider__prev',
      nextArrow: slider + ' ~ .content-slider__next',
      arrows: $slider.data('arrows'),
      dots: $slider.data('dots'),
      autoplay: $slider.data('autoplay'),
      autoplaySpeed: $slider.data('speed'),
      slidesToShow: $slider.data('slides-show-desktop'),
      slidesToScroll: $slider.data('slides-scroll-desktop'),
      rows: $slider.data('rows-desktop'),
      slidesPerRow: $slider.data('per-row-desktop')
    };

    var tabletOptions = $.extend({}, options, {
      slidesToShow: $slider.data('slides-show-tablet'),
      slidesToScroll: $slider.data('slides-scroll-tablet'),
      rows: $slider.data('rows-tablet'),
      slidesPerRow: $slider.data('per-row-tablet')
    });

    var mobileOptions = $.extend({}, options, {
      arrows: $slider.data('arrows-mobile'),
      dots: $slider.data('dots-mobile'),
      autoplay: $slider.data('autoplay-mobile'),
      slidesToShow: $slider.data('slides-show-mobile'),
      slidesToScroll: $slider.data('slides-scroll-mobile'),
      rows: $slider.data('rows-mobile'),
      slidesPerRow: $slider.data('per-row-mobile')
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMedium, {
      match: function () {
        initSlider($slider, tabletOptions);
      }
    });

    enquire.register(config.mediaQueryLargeUp, {
      match: function () {
        initSlider($slider, options);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }

    $('.slideshow__video', wrapper).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
  }

  contentSliders.prototype = _.assignIn({}, contentSliders.prototype, {
    onUnload: function () {
      $(this.slider, this.wrapper).slick('unslick');
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return contentSliders;
})();

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.LatestBlogPosts = (function () {
  function LatestBlogPosts(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return LatestBlogPosts;
})();

theme.LatestBlogPosts.prototype = _.assignIn({}, theme.LatestBlogPosts.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};
theme.slideshows = theme.slideshows || {};

theme.ImageGallerySliders = (function () {
  function ImageGallerySliders(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);

    var pswpElement = document.querySelectorAll('.pswp')[0];
    var galleryItems = [];

    $('.image-gallery-item__anchor:not(.slick-cloned .image-gallery-item__anchor)', slideshow).map(function () {
      var $this = $(this);
      var width = $this.data('width');

      galleryItems.push({
        src: $this.attr('href'),
        w: width,
        h: width / $this.data('aspect-ratio'),
      });
    });

    $('.image-gallery-item__anchor').on('click', function (evt) {
      evt.preventDefault();

      var thumbnail = $(this).find('img')[0];

      var options = {
        index: $(this).data('index'),
        barsSize: { top: 0, bottom: 0 },
        captionEl: false,
        fullscreenEl: false,
        shareEl: false,
        bgOpacity: 0.96,
        tapToClose: true,
        tapToToggleControls: false,
        history: false,
        getThumbBoundsFn: function (index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect(),
            thumbInfo = theme.utils.getImgSizeInfo(thumbnail);
          return { x: rect.left + thumbInfo.left, y: rect.top + pageYScroll, w: thumbInfo.width };
        }
      };

      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);
      gallery.init();
    });
  }

  return ImageGallerySliders;
})();

theme.ImageGallerySliders.prototype = _.assignIn({}, theme.ImageGallerySliders.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function (evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function () {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

window.theme = window.theme || {};

theme.NoticeBar = (function () {

  var selectors = {
    internationalStoreSelector: '.international-store-selector',
  };

  function NoticeBar(container) {

    $(selectors.internationalStoreSelector, container).on('mouseleave', function () {
      $(this).removeClass('active');
    });
  }

  return NoticeBar;
})();
window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.Hero = (function () {

  var SELECTORS = {
    slideshow: '[data-slideshow]'
  };

  function Hero(container) {

    var slideshows = container.querySelectorAll(SELECTORS.slideshow);

    _.each(slideshows, function (slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });

  }

  return Hero;

})();
window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.LandingPage = (function () {

  var SELECTORS = {
    slideshow: '[data-slideshow]'
  };

  function LandingPage(container) {

    var slideshows = container.querySelectorAll(SELECTORS.slideshow);

    _.each(slideshows, function (slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });

  }

  return LandingPage;

})();
window.theme = window.theme || {};
window.theme.slideshows = window.theme.slideshows || {};

theme.AdvisoryStaff = (function () {

  var SELECTORS = {
    slideshow: '[data-slideshow]'
  };

  function AdvisoryStaff(container) {

    var slideshows = container.querySelectorAll(SELECTORS.slideshow);

    _.each(slideshows, function (slideshow) {
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    });

  }

  return AdvisoryStaff;

})();
window.theme = window.theme || {};

theme.AdvisoryStaffIndex = (function () {

  var selectors = {
    slidesDataContainer: '#advisory-staff-index-featured-data-',
    slideContainer: '.advisory-staff-index__hero--'
  };

  function AdvisoryStaffIndex(container) {

    var self = this;

    this.container = container;
    this.containerID = container.dataset.sectionId;

    this.data = {
      slides: [],
      progress: 0,
      autoProgress: true
    };

    this.methods = {
      setActiveSlideListener: this._setActiveSlideListener.bind(this)
    };

    this._getSlidesdata();
    this._findInitialActiveSlide();
    this._bindView();
    this._autoProgress();

    console.info(this.data);

  }

  AdvisoryStaffIndex.prototype = _.extend({}, AdvisoryStaffIndex.prototype, {

    _bindView: function () {
      var self = this;

      tinybind.bind(this.container, {
        data: self.data,
        methods: self.methods,
      });

    },

    _getSlidesdata: function () {

      var self = this;

      var slidesDataContainer,
        slidesData;

      slidesDataContainer = this.container.querySelector(selectors.slidesDataContainer + self.containerID).innerHTML;
      slidesData = JSON.parse(slidesDataContainer);

      function Slide(data) {
        _.extend(this, data);
      }

      _.each(slidesData, function (id) {

        var slide,
          slideContainer;

        slideContainer = self.container.querySelector(selectors.slideContainer + id);

        slide = new Slide({
          id: id,
          slide: slideContainer
        });

        self.data.slides.push(slide);
      });

    },

    _setActiveSlideListener: function () {

      var targetSlide;
      targetSlideID = event.currentTarget.dataset.targetSlide;
      this.setActiveSlide(parseInt(targetSlideID));

    },

    setActiveSlide: function (id) {

      var self = this;

      var targetSlide;

      targetSlide = _.find(this.data.slides, { 'id': id.toString() });

      if (this.data.activeSlide == targetSlide) {
        return;
      }

      if (this.data.isTransitioning) {
        return;
      }

      this.data.isTransitioning = true;

      this.data.previousSlide = this.data.activeSlide;
      this.data.activeSlide = targetSlide;

      // this.data.activeSlide.slide.style.zIndex = 3;
      this.data.activeSlide.slide.classList.add('reveal');
      this.data.previousSlide.slide.classList.remove('reveal');
      // this.data.activeSlide.slide.style.zIndex = 2;

      this.data.progress = 0;

      setTimeout(function () {
        self.data.isTransitioning = false;
      }, 1500);

    },

    _findInitialActiveSlide: function () {

      var self = this;

      _.each(this.data.slides, function (slide) {
        if (slide.slide.classList.contains('reveal')) {
          self.data.activeSlide = slide;
        }
      });
    },

    _autoProgress: function () {
      var self = this;

      var duration,
        interval,
        autoProgress;

      duration = 10000;
      interval = duration / 1000;

      autoProgress = setInterval(function () {

        if (self.data.autoProgress && !self.data.isTransitioning) {

          if (self.data.progress >= 100) {
            self._goToNextSlide();
          } else {
            self.data.progress += 0.1;
          }

        }

      }, interval);
    },

    _goToNextSlide: function () {

      var activeSlideIndex,
        nextSlideIndex,
        slidesCount,
        nextSlideId;

      slidesCount = this.data.slides.length;

      activeSlideIndex = _.findIndex(this.data.slides, this.data.activeSlide);
      nextSlideIndex = activeSlideIndex + 1;

      if (nextSlideIndex > (slidesCount - 1)) {
        nextSlideIndex = 0;
      }

      nextSlideId = this.data.slides[nextSlideIndex].id;

      this.setActiveSlide(nextSlideId);

    }

  });

  return AdvisoryStaffIndex;
})();


window.theme = window.theme || {};

theme.StickySubNav = (function () {

  var selectors = {
    subNav: '.sticky-sub-nav'
  }

  var options = {
    stickybits: {}
  }

  function StickySubNav(container) {

    this.$container = $(container);

    this.$subNav = $(selectors.subNav).insertBefore(this.$container.parent());
    this.$subNav.stickybits(options.stickybits);
  }

  return StickySubNav;
})();

window.theme = window.theme || {};

theme.FourOhFour = (function () {
  var selectors = {
    container: '#shopify-section-404',
    collectionContainer: '.featured-collections__product-grid .row'
  };

  function init() {
    if (!$(selectors.container).length) {
      return;
    }
    $(selectors.collectionContainer).slick({
      // dots: true,
      infinite: true,
      // speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1224,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            infinite: true,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            swipeToSlide: true,
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            arrows: true
          }
        }
      ]
    });
  }

  return init();

})();



/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if ($newAddressForm.length) {

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {

  var config = {
    recoverPasswordForm: '#RecoverPassword',
    newCustomerForm: '#NewCustomer',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    HideNewCustomerLink: '#HideNewCustomerLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();
  newCustomerSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  $(config.newCustomerForm).on('click', onShowHideNewCustomerForm);
  $(config.HideNewCustomerLink).on('click', onShowHideNewCustomerForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();

    if (!$('#RecoverEmail').val()) {
      var enteredEmail = $('#CustomerEmail').val();
      $('#RecoverEmail').val(enteredEmail);
    }

    toggleRecoverPasswordForm();
  }

  function onShowHideNewCustomerForm(evt) {
    evt.preventDefault();

    if (!$('#CreateEmail').val()) {
      var enteredEmail = $('#CustomerEmail').val();
      $('#CreateEmail').val(enteredEmail);
    }

    toggleNewCustomerForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }

    if (hash === '#create') {
      toggleNewCustomerForm();
    }

  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  function toggleNewCustomerForm() {
    $('#NewCustomerForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    // $('#ResetSuccess').removeClass('hide');
    // $('#CustomerLoginForm').toggleClass('hide');

    iziToast.success({
      message: theme.strings.recoverPasswordEmailSent,
      position: 'bottomCenter',
      theme: 'light',
      closeOnClick: true,
      timeout: false,
    });

  }

  function newCustomerSuccess() {
    var $formState = $('.new-customer-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#NewCustomerSuccess').removeClass('hide');
  }
})();

window.theme = window.theme || {};

theme.RegisterPage = (function () {
  var selectors = {
    registerPage: '.register-page',
  };

  if (!$(selectors.registerPage).length) {
    return;
  }

  var validateABN = function (abn) {
    var isValid = true;
    abn = abn.replace(/[^0-9]/g, '');
    isValid &= abn && /^\d{11}$/.test(abn);

    if (isValid) {
      var weightedSum = 0;
      var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      for (var i = 0; i < weight.length; i++) {
        weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i];
      }
      isValid &= ((weightedSum % 89) === 0);
    }

    return isValid;
  };

  var abnField = document.getElementById('CustomerFormABN');
  if (abnField !== undefined && abnField !== null) {
    abnField.addEventListener('input', function (event) {
      if (abnField.validity.typeMismatch || validateABN(abnField.value) != true) {
        abnField.setCustomValidity('Please enter a valid ABN.');
      } else {
        abnField.setCustomValidity('');
      }
    });
  }

  if ($('#CustomerFormCustomerType').length) {
    updateRegisterFormFields($('#CustomerFormCustomerType').val());

    $('#CustomerFormCustomerType').on('change', function () {
      updateRegisterFormFields($(this).val());
    });
  }

  $('.form-element--product-interest label:last-child input').on('change', function () {
    $('.form-element--product-interest label input').not(this).prop('checked', this.checked);
  });

  $('.form-element--product-interest label:not(:last-child) input').on('change', function () {
    $('.form-element--product-interest label:last-child input').prop('checked', false);
  });

  function updateRegisterFormFields(selector) {
    var activeGroup = theme.utils.handleize(selector);
    var activeSelector = '.form-element--' + activeGroup;

    $('.form-element--toggles').not(activeSelector).hide();
    $('.form-element--toggles').not(activeSelector).removeClass('form-element--visible');
    $('.form-element--toggles').not(activeSelector).prop('disabled', true);

    $(activeSelector).show();
    $(activeSelector).addClass('form-element--visible');
    $(activeSelector).prop('disabled', false);

    $('input[name="tags"]').val(activeGroup);
  };

})();

window.theme = window.theme || {};

theme.Password = (function () {
  var selectors = {
    passwordPage: '.password-page',
    loginModal: '#LoginModal',
    focusOnOpen: '#Password'
  };

  if (!$(selectors.passwordPage).length) {
    return;
  }

  initModal();

  function initModal() {

    var $loginModal = $(selectors.loginModal);

    if (!$loginModal.length) {
      return;
    }

    var passwordModal = new theme.Modals(selectors.loginModal, 'login-modal', {
      focusOnOpen: selectors.focusOnOpen
    });

    // Open modal if errors exist
    if ($loginModal.find('.errors').length) {
      passwordModal.open();
    }

  }
})();

(function () {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function () {
    location.href = $(this).val();
  });

})();


$(document).ready(function () {

  // Object-fit polyfill initialise
  objectFitImages();

  // Hacky IE Lazysizes fix until we find a better solution or drop IE
  var ms_ie = !!window.navigator.userAgent.match(/MSIE|Trident/);
  if (ms_ie) {
    var lazyImageChecker = window.setInterval(function () {
      if (!$('img.lazyload').length) { window.clearInterval(lazyImageChecker); console.log(5); }
      $('img.lazyloading').each(function () {
        var imageSrc = $(this).attr('data-src');
        $(this).removeClass('lazyloading');
        $(this).get(0).src = imageSrc;
      });
    }, 3000);
  }

  var sections = new slate.Sections();
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('sticky-sub-nav', theme.StickySubNav);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('footer-section', theme.FooterSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
  sections.register('brand-values', theme.BrandValueSliders);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('featured-collections', theme.FeaturedCollections);
  sections.register('featured-product', theme.FeaturedProducts);
  sections.register('image-row', theme.ImageRows);
  sections.register('content-slider', theme.ContentSliders);
  sections.register('latest-blog-posts', theme.LatestBlogPosts);
  sections.register('image-gallery-slider', theme.ImageGallerySliders);
  sections.register('instagram-feature', theme.Instagram);
  sections.register('notice-bar', theme.NoticeBar);
  sections.register('compare-tool-sheet', theme.CompareToolSheet);
  sections.register('compare-tool', theme.CompareTool);
  sections.register('landing-page', theme.LandingPage);
  sections.register('hero', theme.Hero);
  sections.register('advisory-staff', theme.AdvisoryStaff);
  sections.register('advisory-staff-index', theme.AdvisoryStaffIndex);
  sections.register('404', theme.FourOhFour);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Setup progress bar plugin
  if ('NProgress' in window) {
    NProgress.configure({ showSpinner: false });
  }

  // $('.collection-filters a').click(function(e){
  //   e.preventDefault();
  //   var $this = $(this);
  //   $gridContainer = $('.collection-grid .row');

  //   $gridContainer.empty().addClass('loading');

  //   $.ajax({
  //     url: $this.attr('href') + '?view=json'
  //   }).done(function(data) {
  //     var products = JSON.parse(data);
  //     template = $('#collection_grid_tpl').html();
  //     for (var i = 0; i < products.length; i++) {
  //       var newProduct = template;
  //       product = products[i];

  //       newProduct = newProduct.replace(/\{url\}/g, product.url);
  //       newProduct = newProduct.replace(/\{title\}/g, product.title);
  //       newProduct = newProduct.replace(/\{price\}/g, product.price);
  //       newProduct = newProduct.replace(/\{image\}/g, product.featured_image);
  //       $gridContainer.append(newProduct);
  //     }
  //   });

  // });

  // #TODO Replace this with some nicer logic - Rivets, slick, etc.
  theme.RecentlyViewed.showRecentlyViewed({ howManyToShow: 4 });

  $(document).on('click', '.pagination a', function (e) {
    var $this = $(this);
    if (!$this.hasClass('pagination__view-all')) {
      var $paginationElem = $this.parents('.pagination');
      var targetContainer = $paginationElem.data('target-container');
      var targetContainerOffset = $paginationElem.data('offset') || 0;

      if (targetContainer) {
        e.preventDefault();
        var $parentElem = $(targetContainer).parent();
        var targetURL = $this.attr('href');
        var match = RegExp('[?&]page=([^&]*)').exec(targetURL);
        var targetPage = match && decodeURIComponent(match[1].replace(/\+/g, ' ')) || 1;

        $parentElem.addClass('ajax-loading');

        $('html, body').animate({ scrollTop: $(targetContainer).offset().top + targetContainerOffset }, 500);
        // If page already exists
        if ($(targetContainer + '[data-page="' + targetPage + '"]').length) {
          $(targetContainer).not('[data-page="' + targetPage + '"]').fadeOut('slow');
          $(targetContainer + '[data-page="' + targetPage + '"]').fadeIn('slow');
          history.pushState({}, targetPage, targetURL);
          $parentElem.offset().top;
          $parentElem.removeClass('ajax-loading');
        } else {
          $.ajax({
            type: 'GET',
            dataType: 'html',
            url: targetURL + '&view=ajax',
            success: function (data) {
              $(targetContainer).not('[data-page="' + targetPage + '"]').fadeOut('slow');
              history.pushState({}, targetPage, targetURL);
              var appendData = $(data).find(targetContainer).prependTo($parentElem).hide();

              var $qtyInputs = $('input[type="number"]', appendData);
              $qtyInputs.each(function () {
                var $el = $(this);
                theme.QuantitySelectors.init($el);
              });

              appendData.fadeIn('slow');
              $parentElem.offset().top;
              $parentElem.removeClass('ajax-loading');
            }
          });
        }
      }
    }
  });

  // $('#MainContent').on('click.quickAddToCart', '.product-grid-item .btn-add-to-cart', function(evt){
  //   var $this = $(this);
  //   var $container = $('#product-grid-item-' + $this.data('product-id'));
  //   var qty = $('input[name="quantity"]', $container).val();
  //   var progressElementSelector = $('[data-progress-element]', $container).data('progress-element');
  //   var $progressElement = progressElementSelector ? $(progressElementSelector) : $(this);

  //   if (qty > 0) {
  //     var variantId = $('#variant-select-' + $this.data('product-id') + ' option:selected').val();

  //     CartJS.addItem(variantId, qty, {}, {
  //       "success": function(data, textStatus, jqXHR) {
  //         iziToast.success({
  //           title: 'Success!',
  //           message: 'Added to cart.',
  //           position: 'bottomCenter',
  //           theme: 'light',
  //           buttons: [
  //             ['<button>View</button>', function (instance, toast) {
  //               instance.hide(toast);
  //               theme.CartDrawer.open();
  //             }]
  //           ]
  //         });
  //       }
  //     });
  //   } else {
  //     $progressElement.removeClass('loading');
  //     $progressElement.addClass('error');
  //     window.setTimeout(function(){
  //       $progressElement.removeClass('error');
  //     }, 1500);
  //     evt.stopImmediatePropagation();
  //   }
  // });

  $('.product-grid-form__items select').on('change', function () {
    var $selectedOption = $(this).find('option:selected');
    var productId = $(this).parents('.product-grid-form').data('product-id');
    var variantPrice = Currency.formatMoney(Currency.convert($selectedOption.data('price'), shop.currency, Currency.currentCurrency), Currency.currentFormat);

    $('#product-grid-item-' + productId + ' span.money').html(variantPrice);
    $('#product-grid-item-' + productId + ' input[name="quantity"]').val(0);
    $('#product-grid-item-' + productId + ' .btn-add-to-cart').removeClass('active');
    // $(this).attr('data-currency-' + shop.currency, $(this).html());
  });

  $('.product-grid-form__items').on('update.qtySelector', 'input[name="quantity"]', function (evt) {
    // $('.product-grid-form__items').on('click', '.js-qty-select button', function(){
    //   var productId = $(this).parents('.product-grid-form').data('product-id');
    //   var selectedVariantId = $('#variant-select-' + productId + ' option:selected').val();
    //   var variantQuantity = $(this).siblings('input[name="quantity"]').val();
    //   // CartJS.updateItemById({selectedVariantId, variantQuantity});
    var quantity = $(evt.target).val();
    var productId = $(this).parents('.product-grid-form').data('product-id');
    var $addButton = $('#product-grid-item-' + productId + ' .btn-add-to-cart');
    if (quantity > 0) {
      $addButton.addClass('active');
    } else {
      $addButton.removeClass('active');
    }
  });


  // $('.newsletter-section form').on('submit', function() {
  //   console.log('scroll')
  //   $('body, html').animate({scrollTop:$('body').offset().top}, 'slow');
  // }) 
  // Transition helpers
  $('[data-prepare-transition="hover"]').bind('mouseenter', function () {
    var activeClass = $(this).data('data-prepare-transition-class') || 'hover';
    $(this).prepareTransition().addClass(activeClass);
  });

  $('[data-prepare-transition="hover"]').bind('mouseleave', function () {
    var activeClass = $(this).data('data-prepare-transition-class') || 'hover';
    $(this).prepareTransition().removeClass(activeClass);
  });


  // // Update 'last viewed of type' text to match last viewed object, e.g. breadcrumbs
  // $('[data-last-viewed]').each(function(){
  //   var $this = $(this);
  //   var type = $this.data('last-viewed');
  //   var typeVar = 'lastViewed' + type.charAt(0).toUpperCase() + type.slice(1);
  //   var lastViewed = sessionStorage[typeVar];

  //   if (lastViewed !== undefined) {
  //     type += 's';
  //     var relatedObjects = $this.data('related-' + type);
  //     if (relatedObjects[lastViewed] !== undefined) {
  //       $this.text(relatedObjects[lastViewed].title);
  //     }
  //   }
  // });


  $('[data-viewport-container]').each(function () {
    if (this.scrollWidth > this.clientWidth) {
      $(this).addClass('force-visibility');
    }
  });


  // Show password buttons
  $('.form-vertical__password-toggle').on('click', function () {
    var $input = $($(this).siblings('input'));

    $(this).toggleClass('active');

    if ($input.attr('type') == 'password') {
      $input.attr('type', 'text');
    } else {
      $input.attr('type', 'password');
    }
  });

  $customerServiceNav = $('.customer-service .navigation-mobile');
  if ($customerServiceNav.length > 0) {
    $customerServiceNav.click(function () {
      if ($customerServiceNav.hasClass('active')) {

        $customerServiceNav.removeClass('active')
        $('.customer-service-nav__wrapper').slideUp()
      } else {
        $customerServiceNav.addClass('active')
        $('.customer-service-nav__wrapper').slideDown()
      }
    });
  }

  $("#top-sorting").change(function (event) {
    var target = $(event.target);
    bcsffilter.onChangeData(theme.utils.updateQueryStringParameter('sort', target.val(), window.location.href), 'sort');
    // target.addClass('selected');
  })

  $("#top-sorting--mobile").change(function (event) {
    var target = $(event.target);
    bcsffilter.onChangeData(theme.utils.updateQueryStringParameter('sort', target.val(), window.location.href), 'sort');
    // target.addClass('selected');
  })

  var bcSfFilterWrapperEl = document.getElementById('bc-sf-filter-wrapper');

  if (bcSfFilterWrapperEl) {

    var waypoint = new Waypoint({
      element: bcSfFilterWrapperEl,
      handler: function (direction) {

        if (direction == 'down' && $(window).width() > 900) {
          $('#bc-sf-filter-wrapper').css('position', 'sticky')
          $('#bc-sf-filter-wrapper').css('max-height', 'calc(100vh - 6.7em)')
          $('#bc-sf-filter-wrapper').scrollTop(10000)
        }

        if (direction == 'up' && $(window).width() > 900) {
          $('#bc-sf-filter-wrapper').css('position', 'relative')
          $('#bc-sf-filter-wrapper').css('max-height', 'none')
        }
      },
      offset: '-100%'
    })

  }

  if ($('.faq-accordion').length) {
    $('.faq-accordion').accordion();

    var parentCategories = $('.faq-accordion').data('parent-catergories').split(' | ');
    updateActiveParentCategory(parentCategories[0]);

    $('.faq-header__category').on('click', function () {
      var $this = $(this);
      var relatedTag = $this.data('related-tag');

      $this.addClass('active');
      $this.siblings().removeClass('active');

      updateActiveParentCategory(relatedTag);
    });

    function updateActiveParentCategory(relatedTag) {
      var subcategoryHeaders = [];
      $('.faq-accordion .title').each(function () {
        var $tabTitle = $(this);

        if ($tabTitle.is('[data-tags*="' + relatedTag + '"]')) {
          $tabTitle.removeClass('hidden');
          $tabTitle.next().removeClass('hidden');

          subcategoryHeaders = subcategoryHeaders.concat($tabTitle.data('tags').split(' | '));
        } else {
          $tabTitle.addClass('hidden');
          $tabTitle.next().addClass('hidden');
        }
      });

      subcategoryHeaders = _.difference(subcategoryHeaders, parentCategories);
      subcategoryHeaders.sort();

      for (var i = 0; i < subcategoryHeaders.length; i++) {
        var $filteredItems = $('.faq-accordion .title[data-tags*="' + subcategoryHeaders[i] + '"]');
        $filteredItems.attr('data-order', i);
        $filteredItems.next().attr('data-order', i);
        $filteredItems.first().attr('data-title', subcategoryHeaders[i]);
      }
    }
  }



  theme.Translate = theme.Translate || {};
  theme.Translate.updateSelectElements = function (elem) {
    var countryCode = $('option:selected', elem).data('country-code');
    $(elem).parent().attr('data-lang', countryCode);
  };

  if ($.cookie('googtrans')) {
    $('.translate-select option[data-google-code="' + $.cookie('googtrans') + '"]').attr('selected', 'selected');
    $('.translate-select').trigger('change');
  }


  // // Init CSS Custom Property polyfill if browser is IE
  // if (isMSIE) {
  //   cssVars();
  // }


  if (window.location.hostname == 'localhost') {
    document.documentElement.classList.add('localhost');
  }

  var videoContainers = document.getElementsByClassName('video');

  theme.videos = [];

  _.each(videoContainers, function (videoContainer) {
    var video = new theme.Video(videoContainer);
    theme.videos.push(video);
  });

  // // Update browser theme colour 

  // try {
  //   var colorPrimary = getComputedStyle(document.body).getPropertyValue('--color-primary').trim();
  //   $('meta[name=theme-color]').attr('content', colorPrimary);
  // } catch (err) {
  //   console.error(err);
  // }


  // ASYNC submit form with Accentuate

  var asyncForms = document.querySelectorAll('[data-async-submit]');

  _.each(asyncForms, function (asyncForm) {

    $(asyncForm).on('submit.bindAsync', function () {
      event.preventDefault();
      asyncSubmitForm(asyncForm);
    });

  });

  function asyncSubmitForm(form) {

    form.querySelector('[type="submit"]').classList.add('loading');

    loadJS('https://app.accentuate.io/dist/proxy.js', function () {
      var $form = $(form);

      $form.off('submit.bindAsync');

      Accentuate($form, function () {
        setTimeout(function () {
          window.location.reload();
        }, 500);
      });

      $form.submit();

    });

  }

  if ($('.form--success').length > 0) {
    $('html, body').animate({
      scrollTop: $('.form--success').offset().top
    }, 'slow');
  }
});


// Contact Us select option modal
function contactOptionChange() {
  $('#ContactFormState').change(function () {
    const opval = $(this).val();
    const modalWarning = $('.state-modal__warning').html();

    if (opval !== "other") {
      $('.state-warning').html('');
    } else {
      optionModalOpen();
      $('.state-warning').html(modalWarning);
    }

  });
}

function warrantyOptionChange() {
  const select = $('#ProductWarrantyReturnFormPlacePurchase');



  select.change(function () {
    const selectedAttr = $('#ProductWarrantyReturnFormPlacePurchase').find(':selected').attr('data-text');
    const modalText = $('.state-modal__warning');
    const underFieldText = $('.state-warning');
    const underButtonText = $('.warning-message');
    const submitButton = $('#warranty-submit-btn');

    if (selectedAttr) {
      optionModalOpen();
      submitButton.prop('disabled', true);
      modalText.html('');
      underFieldText.html('');
      underButtonText.html('');
      modalText.html(selectedAttr);
      underFieldText.html(selectedAttr);
      underButtonText.html(selectedAttr);
    } else {
      submitButton.prop('disabled', false);
      underFieldText.html('');
      underButtonText.html('');
    }
  });
}

function optionModalOpen() {
  $('body').addClass('popup-open');
  $('.state-modal__container').addClass('open');
}

function optionModalClose() {
  $('.state-modal__close').click(function () {
    $('.state-modal__container').removeClass('open');
    $('body').removeClass('popup-open');
  });
}

contactOptionChange();
optionModalClose();
warrantyOptionChange();

var accordion = document.getElementsByClassName("js-checkbox-packaging-link");

if (accordion) {
  for (var i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
}


// External access to cart button state checking
// The logic is now handled within theme.AjaxCart module
function checkCartButtonState() {
  if (theme.AjaxCart && theme.AjaxCart.checkCartButtonState) {
    theme.AjaxCart.checkCartButtonState();
  }
}

// Cart button state is now managed within theme.AjaxCart module


let checkboxPackaging = document.querySelector('.js-checkbox-packaging-input');
let productHidden =  document.querySelector('.js-product-id-hidden') && document.querySelector('.js-product-id-hidden').textContent; 
let productSubmit =  document.querySelector('.js-product-form-cart-submit');

if (checkboxPackaging && productSubmit) {
  checkboxPackaging.addEventListener("change", function (e) {
    checkPackagingCheckbox(e);
  })
}

function checkPackagingCheckbox(e) {
  if (checkboxPackaging.checked) {
    productSubmit.click();
  }
  else {
    document.querySelector(`[data-product-delete="${productHidden.textContent}"]`).click();
  }
}
setTimeout(function() { theme.CompareToolManager._restoreExistingProductSelections(); }, 4000);

$(document).ready(function () {
  if ($(".template-product").length > 0) {
    let checkedSelector = $(".product-form__item.radio-wrapper .product-form__item-inner fieldset input[type='radio']:checked");
    let checkedAtrr = checkedSelector.attr("value");
    let targetImg = $(".js-thumbnail-image--element").filter(function () {
      return $(this).attr("data-image-alt") === checkedAtrr;
    });

    if (targetImg.length > 0) {
      targetImg[0].click();
    }

    let productVariantSelector = $(".js-variant--selector");

    if (productVariantSelector.length > 0) {
      productVariantSelector.on('click', function () {
        let self = $(this);
        let selfAtrr = self.attr("data-variant-color");

        let targetImg = $(".js-thumbnail-image--element").filter(function () {
          return $(this).attr("data-image-alt") === selfAtrr;
        });

        console.log(selfAtrr);
        console.log(targetImg);
        if (targetImg.length > 0) {
          targetImg[0].click();
        }
      });
    }
  }
});


function popupOpen() {
  var popup = document.querySelector(".js-stringing-popup-offer__popuptext");
  if(popup){
    let blockPopup =  $(".stringing-pop-up [data-add-to-cart-text]").attr("block-popup");
    if (blockPopup == "false") {
      popup.classList.add("stringing-popup-offer--show");
      document.querySelector('.stringing-popup__overlay').style.display = "block";
    }
  }
}

function popupClose() {
  var popup = document.querySelector(".js-stringing-popup-offer__popuptext");
  if(popup){
    popup.classList.remove("stringing-popup-offer--show");
    document.querySelector('.stringing-popup__overlay').style.display = "none";
  }
}

function popupCoverOpen() {
  var popupCover = document.querySelector(".js-cover-popup__popuptext");
  if(popupCover){
    popupCover.classList.add("cover-popup--show");
    document.querySelector('.stringing-popup__overlay').style.display = "block";
  }
}

function popupCoverClose() {
  var popupCover = document.querySelector(".js-cover-popup__popuptext");
  if(popupCover){
    popupCover.classList.remove("cover-popup--show");
    document.querySelector('.stringing-popup__overlay').style.display = "none";
  }
}

var closePopup = document.querySelector(".register_popupclose");
var registerOverlay = document.querySelector(".register_overlay");
var registerPopup = document.querySelector(".register_popup");
var buttonPrivacy = document.querySelector(".privacy_link");
var mainContent = document.querySelector("#MainContent");

if(closePopup && registerOverlay && registerPopup){
  closePopup.onclick = function() {
    registerOverlay.style.display = 'none';
    registerPopup.style.display = 'none';
    mainContent.style.zIndex = '1';
  };  
}
if(registerOverlay && registerPopup){
  registerOverlay.onclick = function() {
    registerOverlay.style.display = 'none';
    registerPopup.style.display = 'none';
    mainContent.style.zIndex = '1';
  };  
}

if(buttonPrivacy && registerOverlay && registerPopup){
  buttonPrivacy.onclick = function() {
    registerOverlay.style.display = 'block';
    registerPopup.style.display = 'block';
    mainContent.style.zIndex = '2';
  };
}


var closePopup2 = document.querySelector(".register_popupclose2");
var registerOverlay2 = document.querySelector(".register_overlay2");
var registerPopup2 = document.querySelector(".register_popup2");
var buttonTerms = document.querySelector(".terms_link");

if(closePopup2 && registerOverlay2 && registerPopup2){
  closePopup2.onclick = function() {
    registerOverlay2.style.display = 'none';
    registerPopup2.style.display = 'none';
    mainContent.style.zIndex = '1';
  };  
}

if(registerOverlay2 && registerPopup2){
  registerOverlay2.onclick = function() {
    registerOverlay2.style.display = 'none';
    registerPopup2.style.display = 'none';
    mainContent.style.zIndex = '1';
  };  
}

if(buttonTerms && registerOverlay2 && registerPopup2){
  buttonTerms.onclick = function() {
    registerOverlay2.style.display = 'block';
    registerPopup2.style.display = 'block';
    mainContent.style.zIndex = '2';
  };
}
$('#customer_birthday').on('focusout', function(event) {
  var input = event.target;
  var value = input.value.trim();
  if (input.value.includes('/')){
    if (!isValidDate(input.value)) {
      input.value = ''
    }
  } else {
    var year = input.value.substr(0,4);
    var month = input.value.substring(4,6);
    var day = input.value.substring(6,8);
    var date = year + '/' + month + '/' + day;
    if (!isValidDate(date)) {
      input.value = ''
    }else {
      input.value = date
    }
  }

  birthDateChange();
})

function isValidDate(dateString) {
  var regEx = /^\d{4}\/\d{2}\/\d{2}$/;
  if(!dateString.match(regEx)) return false;  // Invalid format
  var d = new Date(dateString);
  var dNum = d.getTime();
  if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return true;
}


if(document.querySelector('#customer_tags')){
  document.querySelector('#customer_tags').onchange = function() {
    if(!document.querySelector('#customer_tags2').value.includes('phone::'))
    document.querySelector('#customer_tags2').value = 'phone::' + document.querySelector('#customer_tags').value;
  }
}

if(document.querySelector('#customer_birthday')){
  document.querySelector('#customer_birthday').onchange = function() {
    if(!document.querySelector('#customer_birthday2').value.includes('dob::'))
    document.querySelector('#customer_birthday2').value = 'dob::' + document.querySelector('#customer_birthday').value;
  }
}
document.addEventListener("change", (event) => {
  if (event.target.matches(".custom-cart-drawer-item__quantity")) {
    const value = event.target.value;
    console.log(value);
    const _elInputTrigger = event.target.closest(".custom-cart__trigger-input")?.querySelector(".custom-cart__quantity-input");
    if (_elInputTrigger) {
      _elInputTrigger.value = value;
      _elInputTrigger.dispatchEvent(new Event("click", { bubbles: true }));
    }
  }
})
document.addEventListener("DOMContentLoaded", () => {
  const goBackMenus = document.querySelectorAll("[data-go-back-menu-mb]");
  if (goBackMenus) {
    goBackMenus.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const handleMenu = btn.getAttribute("data-go-back-menu-mb");
        const _parent = btn.closest(".simple-accordion__item");
        const targetTitle = _parent.querySelector(`h4[data-handle="${handleMenu}"]`);
        if (targetTitle) {
          targetTitle.click();
        }
      })
    })
  }
  const submenu = document.querySelectorAll("[data-tab-menu]");
  if (submenu) {
    submenu.forEach((menu) => {
      menu.addEventListener("mouseenter", (e) => {
        e.preventDefault();
        const handle = menu.getAttribute("data-tab-menu");
        const container = menu.closest(".site-nav__childlist-tab");
        if (!container) return;
        container.querySelector(".site-nav__childlist-tab__item.active").classList.remove("active");
        container.querySelector(".site-nav__childlist-grid.active").classList.remove("active");
        menu.classList.add("active");
        container.querySelector(`[data-tab-menu-content="${handle}"]`)?.classList.add("active");
      })
    })
  }
  const menuMobileCustom = document.querySelector(".mobile-nav__secondary-nav-custom");
  const menuTitleMobileCustom = document.querySelector(".mobile-nav__main-nav-title-custom");
  if (menuMobileCustom && menuTitleMobileCustom) {
    menuTitleMobileCustom.addEventListener("click", (e) => {
      menuTitleMobileCustom.classList.toggle("active_custom");
      menuMobileCustom.classList.toggle("active_custom");
      if (menuTitleMobileCustom.hasClass("active_custom")) {
        menuTitleMobileCustom.classList.add("active");
        menuMobileCustom.classList.add("active");
      } else {
        menuTitleMobileCustom.classList.remove("active");
        menuMobileCustom.classList.remove("active");
      }
    })
  }
})